"use client"
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/react-fast-compare/index.js
var require_react_fast_compare = __commonJS({
  "node_modules/react-fast-compare/index.js"(exports, module) {
    var hasElementType = typeof Element !== "undefined";
    var hasMap = typeof Map === "function";
    var hasSet = typeof Set === "function";
    var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
    function equal(a, b) {
      if (a === b)
        return true;
      if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor)
          return false;
        var length, i, keys;
        if (Array.isArray(a)) {
          length = a.length;
          if (length != b.length)
            return false;
          for (i = length; i-- !== 0; )
            if (!equal(a[i], b[i]))
              return false;
          return true;
        }
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
          if (a.size !== b.size)
            return false;
          it = a.entries();
          while (!(i = it.next()).done)
            if (!b.has(i.value[0]))
              return false;
          it = a.entries();
          while (!(i = it.next()).done)
            if (!equal(i.value[1], b.get(i.value[0])))
              return false;
          return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
          if (a.size !== b.size)
            return false;
          it = a.entries();
          while (!(i = it.next()).done)
            if (!b.has(i.value[0]))
              return false;
          return true;
        }
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
          length = a.length;
          if (length != b.length)
            return false;
          for (i = length; i-- !== 0; )
            if (a[i] !== b[i])
              return false;
          return true;
        }
        if (a.constructor === RegExp)
          return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf)
          return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString)
          return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length)
          return false;
        for (i = length; i-- !== 0; )
          if (!Object.prototype.hasOwnProperty.call(b, keys[i]))
            return false;
        if (hasElementType && a instanceof Element)
          return false;
        for (i = length; i-- !== 0; ) {
          if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) {
            continue;
          }
          if (!equal(a[keys[i]], b[keys[i]]))
            return false;
        }
        return true;
      }
      return a !== a && b !== b;
    }
    module.exports = function isEqual2(a, b) {
      try {
        return equal(a, b);
      } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
          console.warn("react-fast-compare cannot handle circular refs");
          return false;
        }
        throw error;
      }
    };
  }
});

// node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object2) {
          if (typeof object2 === "object" && object2 !== null) {
            var $$typeof = object2.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object2.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object2) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object2) {
          return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object2) {
          return typeOf(object2) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object2) {
          return typeOf(object2) === REACT_PROVIDER_TYPE;
        }
        function isElement2(object2) {
          return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object2) {
          return typeOf(object2) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object2) {
          return typeOf(object2) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object2) {
          return typeOf(object2) === REACT_LAZY_TYPE;
        }
        function isMemo(object2) {
          return typeOf(object2) === REACT_MEMO_TYPE;
        }
        function isPortal(object2) {
          return typeOf(object2) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object2) {
          return typeOf(object2) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object2) {
          return typeOf(object2) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object2) {
          return typeOf(object2) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element2;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement2;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// node_modules/react-is/index.js
var require_react_is = __commonJS({
  "node_modules/react-is/index.js"(exports, module) {
    "use strict";
    if (false) {
      module.exports = null;
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "node_modules/object-assign/index.js"(exports, module) {
    "use strict";
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2["_" + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
          return test2[n];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };
  }
});

// node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "node_modules/prop-types/lib/has.js"(exports, module) {
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "node_modules/prop-types/checkPropTypes.js"(exports, module) {
    "use strict";
    var printWarning = function() {
    };
    if (true) {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has = require_has();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has;
    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (true) {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (true) {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    "use strict";
    var ReactIs = require_react_is();
    var assign = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (true) {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement2, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x, y) {
        if (x === y) {
          return x !== 0 || 1 / x === 1 / y;
        } else {
          return x !== x && y !== y;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (true) {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement2(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (true) {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          true ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location, propFullName) {
          var expectedTypes = [];
          for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
            var checker2 = arrayOfTypeCheckers[i2];
            var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement2(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "node_modules/prop-types/index.js"(exports, module) {
    if (true) {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = null();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// src/theme/theme-context.tsx
import { Global } from "@emotion/react";
import { cssom, defineConfig, twind, virtual } from "@twind/core";
import presetAutoprefix from "@twind/preset-autoprefix";
import presetLineClamp from "@twind/preset-line-clamp";
import presetTailwind from "@twind/preset-tailwind";
import React8, { createContext as createContext2, useContext as useContext2, useMemo as useMemo2 } from "react";

// src/components/Toast/Toast.tsx
import React5, { useEffect } from "react";

// node_modules/react-icons/lib/esm/iconBase.js
import React2 from "react";

// node_modules/react-icons/lib/esm/iconContext.js
import React from "react";
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = React.createContext && React.createContext(DefaultContext);

// node_modules/react-icons/lib/esm/iconBase.js
var __assign = function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = function(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
};
function Tree2Element(tree) {
  return tree && tree.map(function(node, i) {
    return React2.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  return function(props) {
    return React2.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function(conf) {
    var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    return React2.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React2.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? React2.createElement(IconContext.Consumer, null, function(conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}

// node_modules/react-icons/md/index.esm.js
function MdCheckCircleOutline(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" } }] })(props);
}
function MdCheckCircle(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" } }] })(props);
}
function MdInfoOutline(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" } }] })(props);
}
function MdInfo(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" } }] })(props);
}
function MdReportProblem(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" } }] })(props);
}
function MdErrorOutline(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" } }] })(props);
}
function MdError(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" } }] })(props);
}
function MdClear(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" } }] })(props);
}
function MdChevronLeft(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" } }] })(props);
}
function MdChevronRight(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" } }] })(props);
}
function MdClose(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" } }] })(props);
}
function MdRefresh(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" } }] })(props);
}
function MdPerson(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" } }] })(props);
}
function MdCheckBox(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" } }] })(props);
}
function MdIndeterminateCheckBox(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z" } }] })(props);
}
function MdOutlineEvent(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-7 5h5v5h-5z" } }] })(props);
}
function MdOutlineReportProblem(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z" } }] })(props);
}
function MdOutlineSearch(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" } }] })(props);
}
function MdOutlineClear(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" } }] })(props);
}
function MdOutlineArrowBackIos(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z", "opacity": ".87" } }, { "tag": "path", "attr": { "d": "M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z" } }] })(props);
}
function MdOutlineArrowForwardIos(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M6.23 20.23L8 22l10-10L8 2 6.23 3.77 14.46 12z" } }] })(props);
}
function MdOutlineChevronRight(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z" } }] })(props);
}
function MdOutlineExpandLess(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z" } }] })(props);
}
function MdOutlineExpandMore(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M24 24H0V0h24v24z", "opacity": ".87" } }, { "tag": "path", "attr": { "d": "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z" } }] })(props);
}

// node_modules/uuid/dist/esm-browser/rng.js
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}

// node_modules/uuid/dist/esm-browser/stringify.js
var byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset2 = 0) {
  return (byteToHex[arr[offset2 + 0]] + byteToHex[arr[offset2 + 1]] + byteToHex[arr[offset2 + 2]] + byteToHex[arr[offset2 + 3]] + "-" + byteToHex[arr[offset2 + 4]] + byteToHex[arr[offset2 + 5]] + "-" + byteToHex[arr[offset2 + 6]] + byteToHex[arr[offset2 + 7]] + "-" + byteToHex[arr[offset2 + 8]] + byteToHex[arr[offset2 + 9]] + "-" + byteToHex[arr[offset2 + 10]] + byteToHex[arr[offset2 + 11]] + byteToHex[arr[offset2 + 12]] + byteToHex[arr[offset2 + 13]] + byteToHex[arr[offset2 + 14]] + byteToHex[arr[offset2 + 15]]).toLowerCase();
}

// node_modules/uuid/dist/esm-browser/native.js
var randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native_default = {
  randomUUID
};

// node_modules/uuid/dist/esm-browser/v4.js
function v4(options, buf, offset2) {
  if (native_default.randomUUID && !buf && !options) {
    return native_default.randomUUID();
  }
  options = options || {};
  const rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset2 = offset2 || 0;
    for (let i = 0; i < 16; ++i) {
      buf[offset2 + i] = rnds[i];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}
var v4_default = v4;

// src/utils/getUniqId.ts
function getUniqId() {
  return v4_default();
}

// src/utils/clsx.ts
import { cx } from "@twind/core";
var clsx = cx;

// src/components/Box/Box.tsx
import React3, { forwardRef } from "react";
var defaultElement = "div";
var Box = forwardRef(function BoxHelper({ as: Element2 = defaultElement, className, apply, ...props }, ref) {
  const tw = useTw();
  return /* @__PURE__ */ React3.createElement(
    Element2,
    {
      className: apply || className ? tw(apply ? `@(${clsx(className, apply)})` : className || "") : void 0,
      ref,
      ...props
    }
  );
});

// src/components/Icon/Icon.tsx
import { forwardRef as forwardRef2 } from "react";
import React4 from "react";
var baseStyles = `
  fill-current
  inline-block
  flex-shrink-0
  align-middle
  leading-none
`;
var Icon = forwardRef2(function IconHelper({ as: Element2, className, size = "6", ...rest }, ref) {
  const iconSize = `w-${size} h-${size}`;
  const instanceStyles = `
    ${baseStyles}
    ${iconSize}
  `;
  return /* @__PURE__ */ React4.createElement(
    Box,
    {
      as: Element2,
      role: "img",
      ref,
      apply: clsx(className),
      className: instanceStyles,
      ...rest
    }
  );
});

// src/components/MotionBox/index.tsx
import { motion } from "framer-motion";
var MotionBox = motion(Box);

// src/components/Toast/Toast.tsx
var baseStyles2 = `
  h-16
  inline-flex
  px-4
  rounded-sm
  shadow-2xl
  items-center
  overflow-hidden
  relative
  pointer-events-auto
`;
var iconMap = {
  success: MdCheckCircleOutline,
  warning: MdOutlineReportProblem,
  danger: MdErrorOutline,
  info: MdInfoOutline
};
var statusMap = {
  success: `
    bg-success-100
    text-success-700
  `,
  warning: `
    bg-warning-100
    text-warning-900
  `,
  danger: `
    bg-danger-100
    text-danger-700
  `,
  info: `
    bg-info-100
    text-info-700
  `
};
var progressMap = {
  success: "bg-success-700",
  warning: "bg-warning-400",
  danger: "bg-danger-600",
  info: "bg-info-600"
};
var Toast = ({
  id,
  status = "info",
  content,
  duration = 5e3,
  onCloseComplete,
  actionContent,
  close,
  size = "md"
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      id && (close == null ? void 0 : close(id));
      onCloseComplete == null ? void 0 : onCloseComplete();
    }, duration);
    return () => {
      if (timer)
        clearTimeout(timer);
    };
  }, []);
  const durationInSecs = duration / 1e3;
  return /* @__PURE__ */ React5.createElement(Box, { className: `${baseStyles2} ${statusMap[status]}`, "data-testid": "Toast" }, /* @__PURE__ */ React5.createElement(Icon, { size: "6", as: iconMap[status], className: "mr-2" }), /* @__PURE__ */ React5.createElement(
    Box,
    {
      className: clsx(
        "font-regular max-w-[60ch] overflow-hidden whitespace-nowrap",
        size === "sm" && "text-sm",
        size === "md" && "text-md"
      )
    },
    content
  ), actionContent && /* @__PURE__ */ React5.createElement(Box, { className: "ml-auto pl-12" }, actionContent({
    id: id || "",
    close: () => id && (close == null ? void 0 : close(id))
  })), /* @__PURE__ */ React5.createElement(
    MotionBox,
    {
      key: `Toast-progress-${id}`,
      className: clsx(
        "absolute bottom-0 left-0 h-1 w-full",
        progressMap[status]
      ),
      transition: {
        ease: "linear",
        duration: durationInSecs
      },
      animate: { width: 0 }
    }
  ));
};

// src/components/Toast/toastContext.tsx
import React7, { createContext, useContext, useState as useState2 } from "react";

// src/components/Toast/ToastContainer.tsx
import { AnimatePresence } from "framer-motion";
import React6 from "react";
import { useMemo } from "react";
import { useEffect as useEffect2, useRef, useState } from "react";
import { createPortal } from "react-dom";
var toastPositions = [
  {
    position: "top",
    className: "flex-col-reverse items-center top-8 left-8 right-8"
  },
  {
    position: "top-right",
    className: "flex-col-reverse items-end top-8 right-8"
  },
  {
    position: "top-left",
    className: "flex-col-reverse items-start top-8 left-8"
  },
  {
    position: "bottom",
    className: "flex-col items-center bottom-8 left-8 right-8"
  },
  {
    position: "bottom-right",
    className: "flex-col items-end bottom-8 right-8"
  },
  {
    position: "bottom-left",
    className: "flex-col items-start bottom-8 left-8"
  }
];
var PORTAL_ID = "suit-ui-toast-portal";
var createPortalElement = () => {
  var _a3;
  if ((globalThis == null ? void 0 : globalThis.document) && !globalThis.document.getElementById(PORTAL_ID)) {
    const div = globalThis.document.createElement("div");
    div.id = PORTAL_ID;
    (_a3 = globalThis.document.body) == null ? void 0 : _a3.appendChild(div);
  }
};
createPortalElement();
var ToastContainer = ({
  toasts,
  close
}) => {
  const ref = useRef(null);
  const [mounted, setMounted] = useState(false);
  const groupedToasts = useMemo(
    () => toasts.reduce((group, toast) => {
      const position = toast.position;
      group[position] = group[position] || [];
      group[position].push(toast);
      return group;
    }, {}),
    [toasts]
  );
  useEffect2(() => {
    var _a3;
    ref.current = (_a3 = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a3.getElementById(PORTAL_ID);
    setMounted(true);
  }, []);
  return mounted ? createPortal(
    /* @__PURE__ */ React6.createElement(Box, { className: "pointer-events-none" }, toastPositions.map(({ position, className }) => {
      var _a3;
      return /* @__PURE__ */ React6.createElement(
        Box,
        {
          key: position,
          className: `z-toast fixed -my-2.5 flex ${className}`
        },
        /* @__PURE__ */ React6.createElement(AnimatePresence, null, (_a3 = groupedToasts[position]) == null ? void 0 : _a3.map((toast) => /* @__PURE__ */ React6.createElement(
          MotionBox,
          {
            className: "my-2.5",
            key: `${position}-${toast.id}`,
            layout: true,
            initial: { opacity: 0, y: 50, scale: 0.3 },
            animate: {
              opacity: 1,
              y: 0,
              scale: 1
            },
            exit: { opacity: 0, y: 20, scale: 0.5 }
          },
          /* @__PURE__ */ React6.createElement(Toast, { close, ...toast })
        )))
      );
    })),
    ref.current
  ) : null;
};

// src/components/Toast/toastContext.tsx
var ToastContext = createContext(void 0);
var ToastProvider = ({
  children
}) => {
  const [toasts, setToasts] = useState2([]);
  const add = ({
    id = getUniqId(),
    position = "bottom-left",
    ...newToast
  }) => {
    setToasts((prevToasts) => [
      ...prevToasts,
      {
        ...newToast,
        position,
        id
      }
    ]);
    return id;
  };
  const close = (id) => {
    setToasts((prevToasts) => prevToasts.filter((s) => s.id !== id));
  };
  const closeAll = () => {
    setToasts([]);
  };
  const update = (id, { position = "bottom-left", ...newToastProps }) => {
    setToasts(
      (prevToasts) => prevToasts.map(
        (toast) => toast.id === id ? {
          ...toast,
          ...newToastProps,
          position
        } : toast
      )
    );
    return id;
  };
  return /* @__PURE__ */ React7.createElement(
    ToastContext.Provider,
    {
      value: {
        add,
        close,
        closeAll,
        update
      }
    },
    /* @__PURE__ */ React7.createElement(ToastContainer, { toasts, close }),
    children
  );
};
var useToast = () => {
  return useContext(ToastContext);
};

// src/theme/tailwind.config.ts
var tailwind_config_default = {
  theme: {
    colors: {
      current: "currentColor",
      transparent: "transparent",
      primary: {
        "50": "#F5F9FF",
        "100": "#EBF3FE",
        "200": "#BFD8FD",
        "300": "#92BDFC",
        "400": "#5296FA",
        "500": "#3987F9",
        "600": "#106EF8",
        "700": "#0654C6",
        "800": "#0B48A3",
        "900": "#032454"
      },
      neutral: {
        "50": "#FDFDFD",
        "100": "#F3F4F6",
        "200": "#E5E7EB",
        "300": "#D1D5DB",
        "400": "#9CA3AF",
        "500": "#6B7280",
        "600": "#4B5563",
        "700": "#374151",
        "800": "#1F2937",
        "900": "#111827"
      },
      info: {
        "50": "#F6FAFE",
        "100": "#EDF5FC",
        "200": "#D8E9F8",
        "300": "#B9D8F3",
        "400": "#66AAE5",
        "500": "#227BC9",
        "600": "#195A94",
        "700": "#144774",
        "800": "#0C2D4A",
        "900": "#081D30"
      },
      danger: {
        "50": "#FFF5F5",
        "100": "#FEEBEB",
        "200": "#FDD3D3",
        "300": "#FCB0B0",
        "400": "#F85353",
        "500": "#E20909",
        "600": "#A70707",
        "700": "#830505",
        "800": "#530303",
        "900": "#360202"
      },
      success: {
        "50": "#F6FFF0",
        "100": "#EBFFE5",
        "200": "#C8FFC1",
        "300": "#A5F6A2",
        "400": "#8AD988",
        "500": "#55A157",
        "600": "#2A7B30",
        "700": "#0D601F",
        "800": "#004611",
        "900": "#002105"
      },
      warning: {
        "50": "#002105",
        "100": "#FFFAEA",
        "200": "#FEF3D2",
        "300": "#FDEAAF",
        "400": "#FBD050",
        "500": "#E6AE05",
        "600": "#AA8003",
        "700": "#856503",
        "800": "#544002",
        "900": "#372901"
      },
      purple: {
        "50": "#F8F8FC",
        "100": "#F0F0F9",
        "200": "#DFDDF3",
        "300": "#C6C3E9",
        "400": "#827CCF",
        "500": "#473FAC",
        "600": "#342F7F",
        "700": "#292563",
        "800": "#1A173F",
        "900": "#110F29"
      },
      violet: {
        "50": "#FDF7FC",
        "100": "#FBEEF9",
        "200": "#F7D9F1",
        "300": "#F1BBE6",
        "400": "#E16AC9",
        "500": "#C328A4",
        "600": "#901D79",
        "700": "#71175F",
        "800": "#470F3C",
        "900": "#2E0A27"
      },
      rose: {
        "50": "#FDF7F9",
        "100": "#FAEFF2",
        "200": "#F5DBE2",
        "300": "#EDBFCB",
        "400": "#D9728E",
        "500": "#B83356",
        "600": "#882540",
        "700": "#6B1D32",
        "800": "#441220",
        "900": "#2C0C15"
      },
      cyan: {
        "50": "#F5FEFF",
        "100": "#EBFDFF",
        "200": "#D4F8FC",
        "300": "#CBF9FF",
        "400": "#8AF2FF",
        "500": "#12C9D9",
        "600": "#0D94A0",
        "700": "#0A747E",
        "800": "#064950",
        "900": "#043034"
      },
      rust: {
        "50": "#FBF9F9",
        "100": "#FBF9F9",
        "200": "#EFE1E1",
        "300": "#E2CACA",
        "400": "#C08B8B",
        "500": "#995252",
        "600": "#713D3D",
        "700": "#583030",
        "800": "#381E1E",
        "900": "#241414"
      },
      copper: {
        "50": "#FDFAF7",
        "100": "#FAF5EF",
        "200": "#F4E9DC",
        "300": "#ECD7C0",
        "400": "#D5A976",
        "500": "#B47A37",
        "600": "#855A29",
        "700": "#684620",
        "800": "#422D14",
        "900": "#2B1D0D"
      },
      barley: {
        "50": "#FCFCF8",
        "100": "#F8F8F1",
        "200": "#EFF0E0",
        "300": "#E3E4C8",
        "400": "#C2C388",
        "500": "#9B9C4F",
        "600": "#72733A",
        "700": "#5A5A2E",
        "800": "#39391D",
        "900": "#252513"
      }
    },
    boxShadow: {
      none: "0 0 0 0 #0000",
      xs: "0 4px 6px 0 rgba(149, 149, 149, 0.15)",
      sm: "0 1px 5px 0 rgba(56, 56, 56, 0.4)",
      md: "0 4px 4px 0 rgba(56, 56, 56, 0.25)",
      lg: "0 2px 8px 1px rgba(56, 56, 56, 0.4)",
      xl: "0 2px 10px 3px rgba(56, 56, 56, 0.3)",
      "2xl": "0 6px 15px 6px rgba(56, 56, 56, 0.3)"
    },
    fontFamily: {
      sans: "Open sans, ui-sans-serif, system-ui, sans-serif"
    },
    fontSize: {
      xs: "0.75rem",
      sm: "0.875rem",
      md: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.625rem",
      "3xl": "1.875rem",
      "4xl": "2.25rem",
      "5xl": "3rem",
      "6xl": "3.75rem"
    },
    borderRadius: {
      none: "0",
      sm: "0.25rem",
      md: "0.625rem",
      lg: "1.25rem",
      full: "9999px"
    },
    zIndex: {
      hide: "-1",
      auto: "auto",
      base: "0",
      docked: "10",
      dropdown: "1000",
      sticky: "1100",
      banner: "1200",
      overlay: "1300",
      modal: "1400",
      popover: "1500",
      skipLink: "1600",
      toast: "1700",
      tooltip: "1800"
    },
    extend: {
      fontWeight: {
        regular: "400"
      },
      spacing: {
        4.5: "1.125rem",
        7.5: "1.875rem",
        18: "4.5rem",
        22: "5.5rem",
        27: "6.75rem"
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      minWidth: ({ theme }) => ({
        ...theme("spacing")
      }),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      minHeight: ({ theme }) => ({
        ...theme("spacing")
      }),
      opacity: {
        15: "0.15",
        25: "0.25",
        35: "0.35",
        45: "0.45",
        55: "0.55",
        65: "0.65",
        75: "0.75",
        85: "0.85",
        95: "0.95"
      }
    }
  }
};

// src/theme/theme-context.tsx
var ThemeContext = createContext2(
  void 0
);
var _a;
if (typeof window !== "undefined" && typeof process !== "undefined" && ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.STORYBOOK)) {
  window.addEventListener("warning", (event) => {
    const customEvent = event;
    if (customEvent.detail.code === "TWIND_INVALID_CLASS")
      event.preventDefault();
  });
}
var ThemeProvider = ({
  resetCSS = true,
  hashClassNames = true,
  children,
  theme
}) => {
  const tw = useMemo2(
    () => (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // prettier-ignore
      twind(
        // TODO no es necesario poner defineConfig aqui
        defineConfig({
          presets: [
            presetAutoprefix(),
            presetTailwind({ disablePreflight: !resetCSS }),
            presetLineClamp()
          ],
          theme: {
            ...tailwind_config_default.theme,
            extend: {
              ...tailwind_config_default.theme.extend,
              ...theme
            }
          },
          hash: hashClassNames,
          darkMode: "class"
        }),
        typeof document === "undefined" ? virtual() : cssom("style[data-library]")
        // getSheet(true) // use this line to display all styles in the browser
      )
    ),
    []
  );
  const globalParams = resetCSS ? {
    "html, body": {
      fontFamily: tw.theme("fontFamily.sans")
    }
  } : {};
  return /* @__PURE__ */ React8.createElement(ThemeContext.Provider, { value: { tw } }, /* @__PURE__ */ React8.createElement(ToastProvider, null, children), /* @__PURE__ */ React8.createElement(
    Global,
    {
      styles: {
        ...globalParams
      }
    }
  ));
};
function useTheme() {
  const { tw } = useContext2(ThemeContext);
  function getProp(prop) {
    const themeProp = tw.theme(prop);
    return themeProp;
  }
  return {
    getProp
  };
}
function useTw() {
  const { tw } = useContext2(ThemeContext);
  return tw;
}

// src/hooks/useDisclosure.ts
import { useCallback, useState as useState3 } from "react";
function useDisclosure(initialState = false) {
  const [isOpen, setIsOpen] = useState3(initialState);
  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);
  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  const onToggle = useCallback(() => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  }, []);
  return {
    isOpen,
    onOpen,
    onClose,
    onToggle
  };
}

// src/hooks/useMediaQuery.ts
import { useEffect as useEffect3, useState as useState4 } from "react";
function useMediaQuery(query) {
  const getMatches = (query2) => {
    if (typeof window !== "undefined") {
      return window.matchMedia(query2).matches;
    }
    return false;
  };
  const [matches, setMatches] = useState4(getMatches(query));
  function handleChange() {
    setMatches(getMatches(query));
  }
  useEffect3(() => {
    const matchMedia = window == null ? void 0 : window.matchMedia(query);
    handleChange();
    if (matchMedia.addListener) {
      matchMedia.addListener(handleChange);
    } else {
      matchMedia.addEventListener("change", handleChange);
    }
    return () => {
      if (matchMedia.removeListener) {
        matchMedia.removeListener(handleChange);
      } else {
        matchMedia.removeEventListener("change", handleChange);
      }
    };
  }, [query]);
  return matches;
}

// src/hooks/useBreakpoint.ts
function useBreakpoint(props) {
  const { getProp } = useTheme();
  const isSm = useMediaQuery(`(min-width: ${getProp("screens.sm")})`);
  const isMd = useMediaQuery(`(min-width: ${getProp("screens.md")})`);
  const isLg = useMediaQuery(`(min-width: ${getProp("screens.lg")})`);
  const isXl = useMediaQuery(`(min-width: ${getProp("screens.xl")})`);
  const is2Xl = useMediaQuery(`(min-width: ${getProp("screens.2xl")})`);
  if (props && typeof props === "object" && ("sm" in props || "md" in props || "lg" in props || "xl" in props || "2xl" in props || "base" in props)) {
    if (is2Xl && props["2xl"])
      return props["2xl"];
    if (isXl && props.xl)
      return props.xl;
    if (isLg && props.lg)
      return props.lg;
    if (isMd && props.md)
      return props.md;
    if (isSm && props.sm)
      return props.sm;
    return props.base;
  }
  return props;
}

// src/components/Avatar/Avatar.tsx
import React10, {
  createContext as createContext3,
  forwardRef as forwardRef3,
  useContext as useContext3,
  useEffect as useEffect4,
  useMemo as useMemo3,
  useState as useState5
} from "react";

// src/components/Badge/Badge.tsx
import React9 from "react";
var sizeMap = {
  sm: "h-1.5 w-1.5 rounded-full ",
  md: "h-4 min-w-4 px-1 text-xs max-w-fit rounded-full"
};
var Badge = ({
  children,
  color = "primary",
  size = "md",
  className
}) => {
  return /* @__PURE__ */ React9.createElement(
    Box,
    {
      as: "span",
      className: clsx(
        "inline-flex items-center justify-center text-neutral-50 font-semibold",
        `bg-${color}-500`,
        sizeMap[size]
      ),
      apply: clsx(className)
    },
    size !== "sm" && children
  );
};

// src/components/Avatar/Avatar.tsx
var AvatarContext = createContext3(void 0);
var colors = ["purple", "violet", "rose", "cyan", "rust", "copper", "barley"];
var sizeMap2 = {
  xs: "6",
  sm: "10",
  md: "14"
};
var iconSizeMap = {
  xs: "3.5",
  sm: "6",
  md: "8"
};
var AvatarForwarded = forwardRef3(
  function AvatarHelper({
    size: sizeProp2 = "md",
    variant: variantProp = "light",
    name = "",
    className,
    children,
    src,
    onClick,
    disabled = false,
    ...otherProps
  }, ref) {
    const context = useContext3(AvatarContext);
    const size = (context == null ? void 0 : context.size) || sizeProp2;
    const variant = (context == null ? void 0 : context.variant) || variantProp;
    const [hasImageError, setHasImageError] = useState5(false);
    const bgShade = variant === "light" ? "200" : "700";
    const textColor = variant === "light" ? "text-neutral-900" : "text-neutral-50";
    const ringSize = size === "xs" ? "2px" : "3px";
    const disabledStyles = "bg-neutral-100 text-neutral-400 cursor-not-allowed";
    const buttonStyles = clsx(
      `hover:(ring-[${ringSize}] ring-neutral-600/10 ring-offset-0)`,
      `active:(ring-[${ringSize}] ring-neutral-600/15 ring-offset-0)`,
      `focus-visible:(outline-none ring-2 ring-neutral-800/100 ring-offset-2)`
    );
    const containerTag = onClick ? "button" : "span";
    const color = useMemo3(() => {
      if (name.includes("+"))
        return "neutral";
      const firstColor = 0;
      const lastColor = colors.length;
      const colorIndex = name ? firstColor + name.length % lastColor : Math.floor(Math.random() * colors.length);
      return colors[colorIndex];
    }, [name]);
    const initials = useMemo3(() => {
      if (!name)
        return "";
      const words = name.replace(/\s+/g, " ").trim().split(" ");
      const hasOneWord = words.length === 1;
      if (hasOneWord) {
        const firstTwoLetters = words[0].substring(0, 2);
        return firstTwoLetters.toUpperCase();
      }
      const firstTwoInitials = words[0][0] + words[1][0];
      return firstTwoInitials.toUpperCase();
    }, [name]);
    useEffect4(() => {
      if (src)
        setHasImageError(false);
    }, [src]);
    if (!hasImageError && src && !disabled)
      return /* @__PURE__ */ React10.createElement(
        Box,
        {
          ref,
          as: containerTag,
          className: clsx(
            "relative inline-flex rounded-full",
            onClick && buttonStyles
          ),
          apply: className,
          onClick,
          ...otherProps
        },
        /* @__PURE__ */ React10.createElement(
          Box,
          {
            as: "img",
            className: `rounded-full object-cover bg-neutral-${bgShade} w-${sizeMap2[size]} h-${sizeMap2[size]}`,
            apply: className,
            src,
            onError: () => setHasImageError(true),
            alt: initials
          }
        ),
        children
      );
    return /* @__PURE__ */ React10.createElement(
      Box,
      {
        ref,
        as: containerTag,
        disabled,
        className: clsx(
          "inline-flex relative items-center justify-center rounded-full object-cover",
          `w-${sizeMap2[size]} h-${sizeMap2[size]}`,
          `bg-${color}-${bgShade}`
        ),
        apply: clsx(
          textColor,
          onClick && !disabled && buttonStyles,
          !onClick && disabled && disabledStyles,
          onClick && `disabled:(${disabledStyles})`,
          className
        ),
        onClick,
        ...otherProps
      },
      initials ? /* @__PURE__ */ React10.createElement(Box, { as: "span", className: size === "md" ? "text-sm" : "text-xs" }, initials) : /* @__PURE__ */ React10.createElement(
        Icon,
        {
          as: MdPerson,
          "aria-label": "Person Icon",
          size: iconSizeMap[size]
        }
      ),
      children
    );
  }
);
var AvatarGroup = (props) => {
  const {
    children,
    className = "",
    size = "md",
    max: max2 = 2,
    variant = "light"
  } = props;
  const { getProp } = useTheme();
  const items = Array.isArray(children) ? children : [children];
  const startIndex = 0;
  const maxIndex = max2 - 1;
  const remainingItems = items.length - max2 + 1;
  const hasMoreThanOneItemRemaining = remainingItems > 1;
  const avatars = hasMoreThanOneItemRemaining ? [...items].slice(startIndex, maxIndex) : [...items];
  const spacing = getProp(`spacing.${sizeMap2[size]}`);
  const calcSpacing = `calc(${spacing} / 3)`;
  const borderSize = size === "xs" ? "2px" : "3px";
  const containerStyles = clsx(
    "border-neutral-50 rounded-full flex relative",
    `-mr-[${calcSpacing}]`,
    `border-[${borderSize}]`
  );
  return /* @__PURE__ */ React10.createElement(AvatarContext.Provider, { value: { size, variant } }, /* @__PURE__ */ React10.createElement(Box, { className: "inline-flex", apply: className }, avatars == null ? void 0 : avatars.map((avatar, index) => {
    var _a3;
    return /* @__PURE__ */ React10.createElement(
      Box,
      {
        key: `avatar-${(_a3 = avatar == null ? void 0 : avatar.props) == null ? void 0 : _a3.name}-${index}`,
        className: containerStyles
      },
      avatar
    );
  }), hasMoreThanOneItemRemaining && /* @__PURE__ */ React10.createElement(Box, { className: containerStyles }, /* @__PURE__ */ React10.createElement(AvatarForwarded, { name: `+${remainingItems}` }))));
};
var AvatarBadge = ({ color = "danger", ...props }) => {
  return /* @__PURE__ */ React10.createElement(Box, { className: "absolute bottom-0 right-0" }, /* @__PURE__ */ React10.createElement(Badge, { color, ...props }));
};
var Avatar = {
  ...AvatarForwarded,
  Group: AvatarGroup,
  Badge: AvatarBadge
};

// src/components/Banner/Banner.tsx
import React11 from "react";
var baseStyles3 = `
  flex
  px-4
  py-3
  min-h-[60px]
  rounded-sm
  items-center
  overflow-hidden
  relative
  pointer-events-auto
`;
var statusMap2 = {
  success: `
    bg-success-100
    text-success-700
  `,
  warning: `
    bg-warning-100
    text-warning-900
  `,
  danger: `
    bg-danger-100
    text-danger-700
  `,
  info: `
    bg-info-100
    text-info-700
  `
};
var iconMap2 = {
  success: MdCheckCircleOutline,
  warning: MdOutlineReportProblem,
  danger: MdErrorOutline,
  info: MdInfoOutline
};
var Banner = ({
  status = "info",
  children,
  actionContent,
  size = "md",
  className = ""
}) => {
  return /* @__PURE__ */ React11.createElement(
    Box,
    {
      className: baseStyles3,
      apply: clsx(statusMap2[status], className),
      role: "alert"
    },
    /* @__PURE__ */ React11.createElement(Box, { className: "flex" }, /* @__PURE__ */ React11.createElement(Icon, { as: iconMap2[status], size: "6", className: "mr-2" }), /* @__PURE__ */ React11.createElement(
      Box,
      {
        className: clsx(
          "font-regular",
          size === "sm" && "text-sm",
          size === "md" && "text-md"
        )
      },
      children
    )),
    actionContent && /* @__PURE__ */ React11.createElement(Box, { className: "ml-auto self-end pl-12" }, actionContent)
  );
};

// src/components/Button/Button.tsx
import React13, { forwardRef as forwardRef4 } from "react";

// src/components/Spinner/Spinner.tsx
import { css, keyframes } from "@emotion/css";
import React12 from "react";
var lineAnimation = keyframes`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`;
var Spinner = ({
  color = "primary",
  className = "",
  size = "12"
}) => {
  return /* @__PURE__ */ React12.createElement(
    Box,
    {
      as: "span",
      className: clsx(
        "inline-flex items-center justify-center animate-spin",
        `w-${size} h-${size}`,
        color === "current" ? "text-current" : `text-${color}-600`
      ),
      apply: className,
      role: "alert",
      "aria-busy": "true"
    },
    /* @__PURE__ */ React12.createElement(Box, { as: "svg", className: "w-[75%] h-[75%]", viewBox: "22 22 44 44" }, /* @__PURE__ */ React12.createElement(
      "circle",
      {
        cx: "44",
        cy: "44",
        r: "20.2",
        fill: "none",
        strokeWidth: "3.6",
        stroke: "currentColor",
        strokeLinecap: "round",
        className: css({
          animation: `${lineAnimation} 1.4s ease-in-out infinite`
        })
      }
    ))
  );
};

// src/components/Button/useButton.ts
var baseStyles4 = clsx(
  "inline-flex justify-center items-center border border-solid border-transparent bg-transparent rounded-sm whitespace-nowrap font-semibold space-x-1",
  "focus:outline-none focus-visible:outline-none"
);
var iconSizeMap2 = {
  xs: "4.5",
  sm: "4.5",
  md: "4.5",
  lg: "6"
};
function useButton(color, isFocused) {
  const variantMap2 = {
    solid: clsx(
      `border-${color}-600 bg-${color}-600 text-neutral-50`,
      `hover:(border-${color}-700 bg-${color}-700)`,
      `active:(border-${color}-800 bg-${color}-800)`,
      `focus-visible:(border-${color}-800 bg-${color}-800 ring-[1.5px] ring-offset-2 ring-${color}-800/100)`,
      "disabled:(border-neutral-100 bg-neutral-100 text-neutral-400 cursor-not-allowed)",
      isFocused && `border-${color}-800 bg-${color}-800`
    ),
    outline: clsx(
      `border-${color}-600 text-${color}-600`,
      `hover:(border-${color}-700 text-${color}-700 bg-${color}-600/10)`,
      `active:(border-${color}-800 text-${color}-800 bg-${color}-600/15)`,
      `focus-visible:(border-${color}-800 text-${color}-800 bg-${color}-600/20 ring-[1.5px] ring-offset-2 ring-${color}-800/100)`,
      "disabled:(bg-transparent border-neutral-300 text-neutral-400 cursor-not-allowed)",
      isFocused && `border-${color}-800 text-${color}-800 bg-${color}-600/15`
    ),
    text: clsx(
      `text-${color}-600`,
      `hover:(text-${color}-700 bg-${color}-600/10)`,
      `active:(text-${color}-800 bg-${color}-600/15)`,
      `focus-visible:(text-${color}-800 bg-${color}-600/20 ring-[1.5px] ring-offset-2 ring-${color}-800/100)`,
      "disabled:(bg-transparent text-neutral-400 cursor-not-allowed)",
      isFocused && `text-${color}-800 bg-${color}-600/15`
    )
  };
  return { baseStyles: baseStyles4, iconSizeMap: iconSizeMap2, variantMap: variantMap2 };
}

// src/components/Button/Button.tsx
var sizeMap3 = {
  xs: "text-sm h-8 px-3 min-w-18",
  sm: "text-sm h-9 px-4 min-w-22",
  md: "text-md h-10 px-5 min-w-24",
  lg: "text-md h-12 px-6 min-w-27"
};
var Button = forwardRef4(
  function ButtonHelper({
    size = "md",
    variant = "solid",
    color = "primary",
    type = "button",
    disabled,
    leftIcon,
    rightIcon,
    className,
    children,
    loading,
    loadingText,
    ...props
  }, ref) {
    const isFocused = Boolean(props["aria-expanded"]);
    const { variantMap: variantMap2, iconSizeMap: iconSizeMap6, baseStyles: baseStyles6 } = useButton(color, isFocused);
    const loadingVariantMap = {
      solid: clsx(
        `disabled:(border-${color}-300 bg-${color}-300 text-neutral-50)`
      ),
      outline: clsx(
        `disabled:(border-${color}-600 text-${color}-600 opacity-50)`
      ),
      text: clsx(`disabled:(text-${color}-600) opacity-50`)
    };
    return /* @__PURE__ */ React13.createElement(
      Box,
      {
        as: "button",
        type,
        className: clsx(baseStyles6, sizeMap3[size]),
        apply: clsx(
          variantMap2[variant],
          className,
          loading && loadingVariantMap[variant]
        ),
        ref,
        disabled: disabled || loading,
        ...props
      },
      !loading && leftIcon && /* @__PURE__ */ React13.createElement(Box, { as: "span", className: "grid place-content-center" }, /* @__PURE__ */ React13.createElement(Icon, { size: iconSizeMap6[size], as: leftIcon.type })),
      loading && /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(
        Spinner,
        {
          color: "current",
          className: `w-${iconSizeMap6[size]} h-${iconSizeMap6[size]}`
        }
      ), loadingText ? /* @__PURE__ */ React13.createElement(Box, { as: "span" }, loadingText) : /* @__PURE__ */ React13.createElement(Box, { as: "span", className: "sr-only" }, "Loading")),
      !loading && children,
      !loading && rightIcon && /* @__PURE__ */ React13.createElement(Box, { as: "span", className: "grid place-content-center" }, /* @__PURE__ */ React13.createElement(Icon, { size: iconSizeMap6[size], as: rightIcon.type }))
    );
  }
);

// src/components/Button/IconButton.tsx
import { forwardRef as forwardRef5 } from "react";
import React14 from "react";
var buttonSizeMap = {
  xs: "h-6 w-6",
  sm: "h-7.5 w-7.5",
  md: "h-10 w-10",
  lg: "h-10 w-10"
};
var iconSizeMap3 = {
  xs: "3.5",
  sm: "4.5",
  md: "6",
  lg: "8"
};
var IconButton = forwardRef5(
  function IconButtonHelper({
    className,
    size = "md",
    variant = "solid",
    color = "primary",
    type = "button",
    icon,
    ...otherProps
  }, ref) {
    const isFocused = Boolean(otherProps["aria-expanded"]);
    const { baseStyles: baseStyles6, variantMap: variantMap2 } = useButton(color, isFocused);
    return /* @__PURE__ */ React14.createElement(
      Box,
      {
        as: "button",
        type,
        className: clsx(baseStyles6, buttonSizeMap[size], variantMap2[variant]),
        apply: clsx("rounded-full", className),
        ref,
        ...otherProps
      },
      /* @__PURE__ */ React14.createElement(Icon, { as: icon.type, size: iconSizeMap3[size] })
    );
  }
);

// src/components/Card/Card.tsx
import React19, { forwardRef as forwardRef6 } from "react";

// src/components/Card/CardBody.tsx
import React16 from "react";

// src/components/Card/CardContext.tsx
import React15 from "react";
var CardContext = React15.createContext({
  size: "md"
});
var useCardContext = () => React15.useContext(CardContext);

// src/components/Card/CardBody.tsx
var sizeMap4 = {
  sm: "px-4 py-2",
  md: "px-4 py-2.5"
};
var CardBody = ({
  className,
  children,
  ...otherProps
}) => {
  const { size } = useCardContext();
  return /* @__PURE__ */ React16.createElement(Box, { className: sizeMap4[size], apply: className, ...otherProps }, children);
};

// src/components/Card/CardFooter.tsx
import React17 from "react";
var sizeMap5 = {
  sm: "px-4 pt-2 pb-4",
  md: "px-4 pt-2.5 pb-5"
};
var CardFooter = ({
  className,
  children,
  ...otherProps
}) => {
  const { size } = useCardContext();
  return /* @__PURE__ */ React17.createElement(Box, { className: sizeMap5[size], apply: className, ...otherProps }, children);
};

// src/components/Card/CardHeader.tsx
import React18 from "react";
var sizeMap6 = {
  sm: "p-4",
  md: "px-4 py-5"
};
var CardHeader = ({
  className,
  children,
  ...otherProps
}) => {
  const { size } = useCardContext();
  return /* @__PURE__ */ React18.createElement(Box, { className: sizeMap6[size], apply: className, ...otherProps }, children);
};

// src/components/Card/Card.tsx
var CardForwarded = forwardRef6(
  function CardHelper({
    className,
    children,
    variant = "elevated",
    size = "md",
    ...otherProps
  }, ref) {
    return /* @__PURE__ */ React19.createElement(
      CardContext.Provider,
      {
        value: {
          size
        }
      },
      /* @__PURE__ */ React19.createElement(
        Box,
        {
          className: clsx(
            "inline-flex flex-col bg-neutral-50 rounded-md text-neutral-900",
            variant === "outline" && "border border-neutral-300",
            variant === "elevated" && "shadow-sm"
          ),
          apply: className,
          ...otherProps,
          ref
        },
        children
      )
    );
  }
);
var Card = {
  ...CardForwarded,
  Body: CardBody,
  Footer: CardFooter,
  Header: CardHeader
};

// src/components/Checkbox/Checkbox.tsx
import React20, {
  forwardRef as forwardRef7,
  useEffect as useEffect5,
  useLayoutEffect,
  useRef as useRef2
} from "react";
var Checkbox = forwardRef7(
  function CheckboxHelper(props, ref) {
    const {
      className,
      children,
      disabled,
      labelPosition = "right",
      indeterminate = false,
      ...otherProps
    } = props;
    const checkboxRef = useRef2(null);
    useLayoutEffect(() => {
      if (ref) {
        if (ref instanceof Function) {
          ref(checkboxRef.current);
        } else {
          ref.current = checkboxRef.current;
        }
      }
    }, [checkboxRef]);
    useEffect5(() => {
      if (checkboxRef.current) {
        checkboxRef.current.indeterminate = indeterminate;
      }
    }, [checkboxRef, indeterminate]);
    return /* @__PURE__ */ React20.createElement(
      Box,
      {
        as: "label",
        apply: clsx(className, disabled && "cursor-not-allowed"),
        className: "text-md cursor-pointer inline-flex items-center"
      },
      children && labelPosition === "left" && /* @__PURE__ */ React20.createElement(LabelContainer, { className: "mr-3", disabled }, children),
      /* @__PURE__ */ React20.createElement(Box, { className: "relative min-w-4.5 h-4.5 bg-neutral-50 rounded-sm" }, /* @__PURE__ */ React20.createElement(
        Box,
        {
          as: "input",
          type: "checkbox",
          className: `
                absolute z-[1]
                top-1/2
                left-1/2
                -translate-x-1/2
                -translate-y-1/2
                border-(solid 2 neutral-600)
                min-w-4.5
                w-4.5
                h-4.5
                rounded-[2px]
                bg-transparent
                outline-none
                appearance-none
                cursor-pointer
                border-neutral-600

                peer

                indeterminate:border-primary-600
                checked:border-primary-600
              `,
          apply: clsx(
            disabled && `
                  cursor-not-allowed
                  border-neutral-300
                  checked:border-neutral-300
                  indeterminate:border-neutral-300
                `
          ),
          ref: checkboxRef,
          disabled,
          ...otherProps
        }
      ), /* @__PURE__ */ React20.createElement(
        Box,
        {
          className: `
              absolute
              top-1/2
              left-1/2
              -translate-x-1/2
              -translate-y-1/2
              w-10
              h-10
              rounded-full
              cursor-pointer
              bg-transparent

              hover:bg-neutral-600/10

              peer-hover:bg-neutral-600/10

              peer-checked:(
                hover:(bg-primary-600/10)
                peer-hover:(bg-primary-600/10)
              )

              peer-focus-visible:(
                outline outline-[1.5px]
                outline-offset-[-1.5px]
                outline-neutral-800
                bg-neutral-600/20

                peer-checked:(bg-primary-100 outline-primary-800)
                peer-indeterminate:(bg-primary-100 outline-primary-800)
              )

              peer-indeterminate:(
                hover:bg-primary-100
                peer-hover:bg-primary-100
              )
            `,
          apply: clsx(disabled && "cursor-not-allowed hidden bg-transparent")
        }
      ), /* @__PURE__ */ React20.createElement(
        Icon,
        {
          as: indeterminate ? MdIndeterminateCheckBox : MdCheckBox,
          className: `
              absolute
              top-1/2
              left-1/2
              -translate-x-1/2
              -translate-y-1/2
              rounded-sm
              hidden
              text-primary-600
              m-auto
              pointer-events-none

              peer-indeterminate:inline-block
              peer-checked:inline-block
              peer-disabled:text-neutral-300
            `
        }
      )),
      children && labelPosition === "right" && /* @__PURE__ */ React20.createElement(LabelContainer, { className: "ml-3", disabled }, children)
    );
  }
);
var LabelContainer = ({
  children,
  className,
  disabled
}) => {
  return /* @__PURE__ */ React20.createElement(
    Box,
    {
      as: "span",
      className,
      apply: clsx(disabled && "text-neutral-300")
    },
    children
  );
};

// src/components/DatePicker/DatePicker.tsx
import {
  format as format3,
  getMonth,
  getYear,
  isSameWeek,
  parse,
  startOfWeek,
  subYears
} from "date-fns";
import React26, { forwardRef as forwardRef9, useMemo as useMemo7 } from "react";
import ReactDatePicker, {
  CalendarContainer
} from "react-datepicker";

// src/components/Dropdown/Dropdown.tsx
import React23, {
  createContext as createContext4,
  useContext as useContext4,
  useEffect as useEffect7,
  useLayoutEffect as useLayoutEffect3,
  useMemo as useMemo5,
  useRef as useRef4,
  useState as useState7
} from "react";
import { createPortal as createPortal2 } from "react-dom";

// node_modules/react-popper/lib/esm/utils.js
import * as React21 from "react";
var fromEntries = function fromEntries2(entries) {
  return entries.reduce(function(acc, _ref) {
    var key = _ref[0], value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" && window.document && window.document.createElement ? React21.useLayoutEffect : React21.useEffect;

// node_modules/react-popper/lib/esm/usePopper.js
import * as React22 from "react";
import * as ReactDOM from "react-dom";

// node_modules/@popperjs/core/lib/enums.js
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

// node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}

// node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

// node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// node_modules/@popperjs/core/lib/modifiers/applyStyles.js
function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function(name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function(style2, property) {
        style2[property] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles_default = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect,
  requires: ["computeStyles"]
};

// node_modules/@popperjs/core/lib/utils/getBasePlacement.js
function getBasePlacement(placement) {
  return placement.split("-")[0];
}

// node_modules/@popperjs/core/lib/utils/math.js
var max = Math.max;
var min = Math.min;
var round = Math.round;

// node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function(item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}

// node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

// node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window, visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width,
    height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x,
    y
  };
}

// node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}

// node_modules/@popperjs/core/lib/dom-utils/contains.js
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}

// node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
function getComputedStyle2(element) {
  return getWindow(element).getComputedStyle(element);
}

// node_modules/@popperjs/core/lib/dom-utils/isTableElement.js
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}

// node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : (
    // $FlowFixMe[prop-missing]
    element.document
  )) || window.document).documentElement;
}

// node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    (isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element)
  );
}

// node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle2(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle2(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css7 = getComputedStyle2(currentNode);
    if (css7.transform !== "none" || css7.perspective !== "none" || css7.contain === "paint" || ["transform", "perspective"].indexOf(css7.willChange) !== -1 || isFirefox && css7.willChange === "filter" || isFirefox && css7.filter && css7.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle2(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle2(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}

// node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}

// node_modules/@popperjs/core/lib/utils/within.js
function within(min2, value, max2) {
  return max(min2, min(value, max2));
}
function withinMaxClamp(min2, value, max2) {
  var v = within(min2, value, max2);
  return v > max2 ? max2 : v;
}

// node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

// node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

// node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

// node_modules/@popperjs/core/lib/modifiers/arrow.js
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state, name = _ref.name, options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect2(_ref2) {
  var state = _ref2.state, options = _ref2.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (true) {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "));
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    if (true) {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
    }
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow_default = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect2,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};

// node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split("-")[1];
}

// node_modules/@popperjs/core/lib/modifiers/computeStyles.js
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref) {
  var x = _ref.x, y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle2(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        offsetParent[heightProp]
      );
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        offsetParent[widthProp]
      );
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  if (true) {
    var transitionProperty = getComputedStyle2(state.elements.popper).transitionProperty || "";
    if (adaptive && ["transform", "top", "right", "bottom", "left"].some(function(property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', "\n\n", 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", "\n\n", "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
    }
  }
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles_default = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};

// node_modules/@popperjs/core/lib/modifiers/eventListeners.js
var passive = {
  passive: true
};
function effect3(_ref) {
  var state = _ref.state, instance = _ref.instance, options = _ref.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners_default = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect: effect3,
  data: {}
};

// node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash[matched];
  });
}

// node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var hash2 = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash2[matched];
  });
}

// node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}

// node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

// node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js
function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x + getWindowScrollBarX(element),
    y
  };
}

// node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle2(body || html).direction === "rtl") {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

// node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle2(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

// node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js
function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}

// node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode(target)))
  );
}

// node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

// node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js
function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle2(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

// node_modules/@popperjs/core/lib/utils/computeOffsets.js
function computeOffsets(_ref) {
  var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
      default:
    }
  }
  return offsets;
}

// node_modules/@popperjs/core/lib/utils/detectOverflow.js
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}

// node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements2 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements2.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements2;
    if (true) {
      console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" "));
    }
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a, b) {
    return overflows[a] - overflows[b];
  });
}

// node_modules/@popperjs/core/lib/modifiers/flip.js
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip_default = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};

// node_modules/@popperjs/core/lib/modifiers/hide.js
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state, name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide_default = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};

// node_modules/@popperjs/core/lib/modifiers/offset.js
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref[0], distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
var offset_default = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};

// node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
function popperOffsets(_ref) {
  var state = _ref.state, name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets_default = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};

// node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}

// node_modules/@popperjs/core/lib/modifiers/preventOverflow.js
function preventOverflow(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min2 = offset2 + overflow[mainSide];
    var max2 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min2, tetherMin) : min2, offset2, tether ? max(max2, tetherMax) : max2);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
var preventOverflow_default = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};

// node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

// node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

// node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

// node_modules/@popperjs/core/lib/utils/orderModifiers.js
function order(modifiers) {
  var map = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

// node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}

// node_modules/@popperjs/core/lib/utils/format.js
function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return [].concat(args).reduce(function(p, c) {
    return p.replace(/%s/, c);
  }, str);
}

// node_modules/@popperjs/core/lib/utils/validateModifiers.js
var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function validateModifiers(modifiers) {
  modifiers.forEach(function(modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES).filter(function(value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function(key) {
      switch (key) {
        case "name":
          if (typeof modifier.name !== "string") {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', '"' + String(modifier.name) + '"'));
          }
          break;
        case "enabled":
          if (typeof modifier.enabled !== "boolean") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', '"' + String(modifier.enabled) + '"'));
          }
          break;
        case "phase":
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(", "), '"' + String(modifier.phase) + '"'));
          }
          break;
        case "fn":
          if (typeof modifier.fn !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "effect":
          if (modifier.effect != null && typeof modifier.effect !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "requires":
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', '"' + String(modifier.requires) + '"'));
          }
          break;
        case "requiresIfExists":
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', '"' + String(modifier.requiresIfExists) + '"'));
          }
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + modifier.name + '" modifier, valid properties are ' + VALID_PROPERTIES.map(function(s) {
            return '"' + s + '"';
          }).join(", ") + '; but "' + key + '" was provided.');
      }
      modifier.requires && modifier.requires.forEach(function(requirement) {
        if (modifiers.find(function(mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

// node_modules/@popperjs/core/lib/utils/uniqueBy.js
function uniqueBy(arr, fn2) {
  var identifiers = /* @__PURE__ */ new Set();
  return arr.filter(function(item) {
    var identifier = fn2(item);
    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

// node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}

// node_modules/@popperjs/core/lib/createPopper.js
var INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m) {
          return m.enabled;
        });
        if (true) {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function(_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);
          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function(_ref2) {
              var name = _ref2.name;
              return name === "flip";
            });
            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
            }
          }
          var _getComputedStyle = getComputedStyle2(popper2), marginTop = _getComputedStyle.marginTop, marginRight = _getComputedStyle.marginRight, marginBottom = _getComputedStyle.marginBottom, marginLeft = _getComputedStyle.marginLeft;
          if ([marginTop, marginRight, marginBottom, marginLeft].some(function(margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
          }
        }
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          if (true) {
            console.error(INVALID_ELEMENT_ERROR);
          }
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (true) {
            __debug_loops__ += 1;
            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      if (true) {
        console.error(INVALID_ELEMENT_ERROR);
      }
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref3) {
        var name = _ref3.name, _ref3$options = _ref3.options, options2 = _ref3$options === void 0 ? {} : _ref3$options, effect4 = _ref3.effect;
        if (typeof effect4 === "function") {
          var cleanupFn = effect4({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}

// node_modules/@popperjs/core/lib/popper.js
var defaultModifiers = [eventListeners_default, popperOffsets_default, computeStyles_default, applyStyles_default, offset_default, flip_default, preventOverflow_default, arrow_default, hide_default];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});

// node_modules/react-popper/lib/esm/usePopper.js
var import_react_fast_compare = __toESM(require_react_fast_compare());
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper2(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = React22.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || "bottom",
    strategy: options.strategy || "absolute",
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = React22.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), state = _React$useState[0], setState = _React$useState[1];
  var updateStateModifier = React22.useMemo(function() {
    return {
      name: "updateState",
      enabled: true,
      phase: "write",
      fn: function fn2(_ref) {
        var state2 = _ref.state;
        var elements = Object.keys(state2.elements);
        ReactDOM.flushSync(function() {
          setState({
            styles: fromEntries(elements.map(function(element) {
              return [element, state2.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function(element) {
              return [element, state2.attributes[element]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []);
  var popperOptions = React22.useMemo(function() {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: "applyStyles",
        enabled: false
      }])
    };
    if ((0, import_react_fast_compare.default)(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React22.useRef();
  useIsomorphicLayoutEffect(function() {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function() {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper2 = options.createPopper || createPopper;
    var popperInstance = createPopper2(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function() {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

// src/components/Dropdown/Dropdown.tsx
var animationOrigins = {
  bottom: "origin-top",
  "bottom-start": "origin-top-left",
  "bottom-end": "origin-top-right",
  top: "origin-bottom",
  "top-start": "origin-bottom-left",
  "top-end": "origin-bottom-right",
  right: "origin-left",
  left: "origin-right"
};
var DropdownContext = createContext4(
  void 0
);
function useDropdown() {
  return useContext4(DropdownContext);
}
var Dropdown = ({
  placement = "bottom-start",
  closeOnSelect = true,
  children,
  onClickOutside,
  withPortal = false
}) => {
  const { isOpen, onClose, onOpen, onToggle } = useDisclosure();
  const [referenceElement, setReferenceElement] = useState7(
    null
  );
  const [popperElement, setPopperElement] = useState7(null);
  const popper2 = usePopper(referenceElement, popperElement, {
    placement,
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 8]
        }
      }
    ],
    strategy: withPortal ? "fixed" : "absolute"
  });
  const dropdownContextProps = useMemo5(
    () => ({
      onOpen,
      onToggle,
      isOpen,
      onClose,
      referenceElement,
      setReferenceElement,
      popperElement,
      setPopperElement,
      popper: popper2,
      placement,
      closeOnSelect,
      withPortal
    }),
    [
      onOpen,
      onToggle,
      isOpen,
      onClose,
      referenceElement,
      setReferenceElement,
      popperElement,
      setPopperElement,
      popper2,
      placement,
      closeOnSelect,
      withPortal
    ]
  );
  useEffect7(() => {
    const handleClickOutside = (event) => {
      if (isOpen && popperElement && referenceElement && !referenceElement.contains(event.target) && !popperElement.contains(event.target)) {
        onClose();
        onClickOutside == null ? void 0 : onClickOutside();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popperElement, referenceElement, isOpen, onClose, onClickOutside]);
  return /* @__PURE__ */ React23.createElement(DropdownContext.Provider, { value: dropdownContextProps }, typeof children === "function" ? children({ isOpen, onClose, onOpen, onToggle }) : children);
};
var DropdownButton = ({
  children,
  as: element = "button",
  onClick,
  ...props
}) => {
  const { setReferenceElement, onToggle, isOpen, popper: popper2 } = useDropdown();
  return /* @__PURE__ */ React23.createElement(
    Box,
    {
      "data-testid": "DropdownButton",
      as: element,
      "aria-haspopup": "true",
      "aria-expanded": isOpen,
      ...props,
      ref: setReferenceElement,
      onClick: (e) => {
        var _a3;
        (_a3 = popper2 == null ? void 0 : popper2.update) == null ? void 0 : _a3.call(popper2);
        onClick == null ? void 0 : onClick(e);
        onToggle();
      }
    },
    children
  );
};
var DropdownList = ({
  children,
  className,
  ...props
}) => {
  const { withPortal, ...dropdown } = useDropdown();
  const ref = useRef4(null);
  const [mounted, setMounted] = useState7(false);
  const isSubList = !!props.popper;
  const { isOpen, setPopperElement, popper: popper2, placement } = isSubList ? props : dropdown;
  useEffect7(() => {
    var _a3;
    ref.current = (_a3 = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a3.querySelector("body");
    setMounted(true);
  }, []);
  const content = /* @__PURE__ */ React23.createElement(
    MotionBox,
    {
      ref: setPopperElement,
      style: popper2 == null ? void 0 : popper2.styles.popper,
      className: clsx(
        "opacity-0",
        isSubList && "px-1.5",
        withPortal ? "z-tooltip" : "z-dropdown"
      ),
      animate: {
        opacity: isOpen ? 1 : 0,
        pointerEvents: isOpen ? "auto" : "none"
      },
      transition: {
        duration: 0.1
      },
      ...popper2 == null ? void 0 : popper2.attributes.popper
    },
    /* @__PURE__ */ React23.createElement(
      MotionBox,
      {
        className: clsx(
          "bg-neutral-50 shadow-sm rounded-sm min-w-48 py-2.5",
          animationOrigins[placement]
        ),
        apply: className,
        animate: {
          scale: isOpen ? 1 : 0.8
        },
        transition: {
          duration: 0.1
        }
      },
      children
    )
  );
  if (withPortal && !isSubList) {
    if (!(globalThis == null ? void 0 : globalThis.document))
      return null;
    return mounted ? createPortal2(content, ref.current) : null;
  }
  return content;
};
var DropdownItem = ({
  children,
  className = "",
  onClick,
  icon,
  isFocused,
  subList,
  as: element = "button",
  ...props
}) => {
  const { onClose, isOpen, closeOnSelect } = useDropdown();
  const [referenceElement, setReferenceElement] = useState7(
    null
  );
  const [popperElement, setPopperElement] = useState7(null);
  const [isOpenSubList, setIsOpenSubList] = useState7(false);
  const delayHandler = useRef4(null);
  const popper2 = usePopper(referenceElement, popperElement, {
    placement: "right-start"
  });
  const handleClick = (e) => {
    onClick == null ? void 0 : onClick(e);
    closeOnSelect && onClose();
  };
  const toggleSublist = (flag) => {
    delayHandler.current && clearTimeout(delayHandler.current);
    delayHandler.current = setTimeout(() => setIsOpenSubList(flag), 200);
  };
  const handleMouseEnter = async () => {
    var _a3;
    await ((_a3 = popper2 == null ? void 0 : popper2.update) == null ? void 0 : _a3.call(popper2));
    subList && toggleSublist(true);
  };
  const handleMouseLeave = () => subList && toggleSublist(false);
  useLayoutEffect3(() => {
    if (!isOpen)
      setIsOpenSubList(false);
  }, [isOpen]);
  useEffect7(() => {
    return () => {
      delayHandler.current && clearTimeout(delayHandler.current);
    };
  }, []);
  return /* @__PURE__ */ React23.createElement(
    Box,
    {
      className: "relative",
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave
    },
    /* @__PURE__ */ React23.createElement(
      Box,
      {
        as: element,
        type: element === "button" ? "button" : void 0,
        "aria-expanded": isOpen,
        ref: setReferenceElement,
        className: clsx(
          "w-full flex items-center text-neutral-700 px-4 py-2 min-h-10 text-sm font-semibold",
          "focus:outline-none",
          "hover:bg-primary-600/10",
          "active:(text-primary-800 bg-primary-600/15)",
          "focus-visible:bg-primary-600/10"
        ),
        onClick: handleClick,
        apply: clsx(
          className,
          (isFocused || isOpenSubList) && `text-primary-800 bg-primary-600/15`
        ),
        ...props
      },
      icon && /* @__PURE__ */ React23.createElement(Box, { className: "mr-2.5 flex items-center" }, icon),
      children,
      subList && /* @__PURE__ */ React23.createElement(Icon, { className: "ml-auto", size: "6", as: MdOutlineChevronRight })
    ),
    subList && /* @__PURE__ */ React23.createElement(
      subList.type,
      {
        key: subList.key,
        isOpen: isOpenSubList,
        setPopperElement,
        popper: popper2,
        placement: "bottom-start",
        ...subList.props
      }
    )
  );
};
Dropdown.List = DropdownList;
Dropdown.Item = DropdownItem;
Dropdown.Button = DropdownButton;

// src/components/Input/Input.tsx
import React25, {
  createContext as createContext6,
  forwardRef as forwardRef8,
  useContext as useContext6,
  useLayoutEffect as useLayoutEffect4,
  useState as useState8
} from "react";

// src/components/FormControl/FormControl.tsx
import React24, {
  createContext as createContext5,
  useContext as useContext5,
  useMemo as useMemo6
} from "react";
var FormControlContext = createContext5(
  void 0
);
function useFormControl() {
  return useContext5(FormControlContext);
}
var FormControl = (props) => {
  const {
    children,
    isInvalid,
    isSuccess,
    disabled,
    required,
    className = "",
    ...otherProps
  } = props;
  const id = useMemo6(() => getUniqId(), []);
  return /* @__PURE__ */ React24.createElement(
    FormControlContext.Provider,
    {
      value: { id, isInvalid, isSuccess, disabled, required }
    },
    /* @__PURE__ */ React24.createElement(Box, { apply: className, ...otherProps }, children)
  );
};
var FormControlLabel = ({
  children,
  className = "",
  as = "label",
  counter,
  ...otherProps
}) => {
  const { id, required, disabled } = useFormControl();
  return /* @__PURE__ */ React24.createElement(
    Box,
    {
      as,
      htmlFor: id,
      className: clsx(
        "flex font-semibold text-sm mb-0.5 items-center",
        disabled ? "text-neutral-400" : "text-neutral-600"
      ),
      apply: className,
      ...otherProps
    },
    children,
    required && /* @__PURE__ */ React24.createElement(
      Box,
      {
        as: "span",
        role: "presentation",
        "aria-hidden": "true",
        className: clsx(
          "font-regular ml-1",
          required && !disabled && "text-danger-700"
        )
      },
      "*"
    ),
    counter && /* @__PURE__ */ React24.createElement(Box, { as: "span", className: "text-xs font-regular ml-auto" }, counter)
  );
};
var FormControlErrorMessage = (props) => {
  const { children } = props;
  const { isInvalid, disabled } = useFormControl();
  if (!isInvalid || disabled)
    return null;
  return /* @__PURE__ */ React24.createElement(
    Box,
    {
      as: "span",
      className: "text-danger-600 text-xs flex items-center mt-0.5 h-4.5"
    },
    /* @__PURE__ */ React24.createElement(Icon, { as: MdErrorOutline, size: "4.5", className: "mr-1" }),
    children
  );
};
var FormControlSuccessMessage = (props) => {
  const { children } = props;
  const { isSuccess, disabled } = useFormControl();
  if (!isSuccess || disabled)
    return null;
  return /* @__PURE__ */ React24.createElement(
    Box,
    {
      as: "span",
      className: "text-success-700 text-xs flex items-center mt-0.5 h-4.5"
    },
    /* @__PURE__ */ React24.createElement(Icon, { as: MdCheckCircleOutline, size: "4.5", className: "mr-1" }),
    children
  );
};
var FormControlHelperMessage = (props) => {
  const { children } = props;
  const { isInvalid, disabled, isSuccess } = useFormControl();
  if (isInvalid || isSuccess)
    return null;
  return /* @__PURE__ */ React24.createElement(
    Box,
    {
      as: "span",
      className: clsx(
        "text-xs flex items-center mt-0.5 h-4.5",
        disabled ? "text-neutral-400" : "text-neutral-600"
      )
    },
    children
  );
};
FormControl.Label = FormControlLabel;
FormControl.ErrorMessage = FormControlErrorMessage;
FormControl.HelperMessage = FormControlHelperMessage;
FormControl.SuccessMessage = FormControlSuccessMessage;

// src/components/Input/Input.tsx
var InputContext = createContext6(void 0);
function useInputGroup() {
  return useContext6(InputContext);
}
var InputForwarded = forwardRef8(
  function InputHelper({
    size: sizeProp2 = "md",
    isInvalid: invalid = false,
    isSuccess: success = false,
    disabled = false,
    required = false,
    className = "",
    ...otherProps
  }, ref) {
    const formControl = useFormControl();
    const inputGroup = useInputGroup();
    const isInvalid = (formControl == null ? void 0 : formControl.isInvalid) || invalid;
    const isRequired = (formControl == null ? void 0 : formControl.required) || required;
    const isDisabled = (formControl == null ? void 0 : formControl.disabled) || disabled;
    const isSuccess = (formControl == null ? void 0 : formControl.isSuccess) || success;
    const size = (inputGroup == null ? void 0 : inputGroup.size) || sizeProp2;
    const sizeStyles3 = {
      xs: "h-8 px-3 text-sm",
      sm: "h-9 px-4 text-sm",
      md: "h-10 px-4 text-md",
      lg: "h-12 px-4 text-md"
    };
    const baseStyles6 = clsx(
      "border bg-neutral-50 border-neutral-600 font-regular outline-none text-neutral-600 rounded-sm w-full",
      "placeholder:text-neutral-400"
    );
    const statusStyles2 = clsx(
      "hover:shadow-sm",
      "focus-visible:(border-[1.5px] border-primary-800)",
      "disabled:(text-neutral-400 border-neutral-300 bg-neutral-100 shadow-none ring-0)"
    );
    const errorStyles2 = "border-danger-600 focus-visible:(border-[1.5px] border-danger-600)";
    const successStyles2 = "border-success-700 focus-visible:(border-[1.5px] border-success-700)";
    return /* @__PURE__ */ React25.createElement(
      Box,
      {
        id: formControl == null ? void 0 : formControl.id,
        disabled: isDisabled,
        required: isRequired,
        ref,
        className: clsx(baseStyles6, sizeStyles3[size]),
        apply: clsx(
          statusStyles2,
          isInvalid && errorStyles2,
          isSuccess && successStyles2,
          (inputGroup == null ? void 0 : inputGroup.hasRightElement) && "pr-11",
          (inputGroup == null ? void 0 : inputGroup.hasLeftElement) && "pl-11",
          className
        ),
        as: "input",
        "aria-invalid": isInvalid,
        role: "textbox",
        ...otherProps
      }
    );
  }
);
var InputGroup = forwardRef8(
  function InputGroupHelper({
    size = "md",
    as = "label",
    className,
    children,
    ...otherProps
  }, ref) {
    const [hasRightElement, setHasRightElement] = useState8(false);
    const [hasLeftElement, setHasLeftElement] = useState8(false);
    return /* @__PURE__ */ React25.createElement(
      InputContext.Provider,
      {
        value: {
          size,
          hasRightElement,
          setHasRightElement,
          hasLeftElement,
          setHasLeftElement
        }
      },
      /* @__PURE__ */ React25.createElement(
        Box,
        {
          as,
          className: "relative flex",
          apply: className,
          ref,
          ...otherProps
        },
        children
      )
    );
  }
);
var InputRightElement = ({ children, className }) => {
  const inputGroup = useInputGroup();
  useLayoutEffect4(() => {
    inputGroup.setHasRightElement(true);
    return () => {
      inputGroup.setHasRightElement(false);
    };
  }, []);
  return /* @__PURE__ */ React25.createElement(
    Box,
    {
      className: "absolute right-0 top-1/2 -translate-y-1/2 mr-1.5",
      apply: className
    },
    children
  );
};
var InputLeftElement = ({ children, className }) => {
  const inputGroup = useInputGroup();
  useLayoutEffect4(() => {
    inputGroup.setHasLeftElement(true);
    return () => {
      inputGroup.setHasLeftElement(false);
    };
  }, []);
  return /* @__PURE__ */ React25.createElement(
    Box,
    {
      className: "absolute left-0 top-1/2 -translate-y-1/2 ml-1.5",
      apply: className
    },
    children
  );
};
var Input = {
  ...InputForwarded,
  Group: InputGroup,
  RightElement: InputRightElement,
  LeftElement: InputLeftElement
};

// src/components/DatePicker/DatePickerStyle.ts
import { css as css2 } from "@emotion/css";

// node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

// node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}

// node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

// node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}

// node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn2) {
  try {
    return Function.toString.call(fn2).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn2 === "function";
  }
}

// node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}

// node_modules/@babel/runtime/helpers/esm/construct.js
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}

// node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}

// node_modules/polished/dist/polished.esm.js
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": 'Invalid value passed as base to modularScale, expected number or em string but got "%s"\n\n',
  "12": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.\n\n',
  "13": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.\n\n',
  "14": 'Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
  "15": 'Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.\n\n',
  "70": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.\n\n',
  "71": 'Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.\n\n',
  "72": 'Passed invalid base value %s to %s(), please pass a value like "12px" or 12.\n\n',
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": 'remToPx expects a value in "rem" but you provided it in "%s".\n\n',
  "78": 'base must be set in "px" or "%" but you set it in "%s".\n'
};
function format2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var a = args[0];
  var b = [];
  var c;
  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }
  b.forEach(function(d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
var PolishedError = /* @__PURE__ */ function(_Error) {
  _inheritsLoose(PolishedError2, _Error);
  function PolishedError2(code) {
    var _this;
    if (false) {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      _this = _Error.call(this, format2.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }
    return _assertThisInitialized(_this);
  }
  return PolishedError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function colorToInt(color) {
  return Math.round(color * 255);
}
function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }
  if (saturation === 0) {
    return convert(lightness, lightness, lightness);
  }
  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function nameToHex(color) {
  if (typeof color !== "string")
    return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function parseToRgb(color) {
  if (typeof color !== "string") {
    throw new PolishedError(3);
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }
    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);
    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }
    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }
  throw new PolishedError(5);
}
var reduceHexValue = function reduceHexValue2(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};
var reduceHexValue$1 = reduceHexValue;
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}
function rgb(value, green, blue) {
  if (typeof value === "number" && typeof green === "number" && typeof blue === "number") {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === "object" && green === void 0 && blue === void 0) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }
  throw new PolishedError(6);
}
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === "string" && typeof secondValue === "number") {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number" && typeof fourthValue === "number") {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === "object" && secondValue === void 0 && thirdValue === void 0 && fourthValue === void 0) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }
  throw new PolishedError(7);
}

// src/components/DatePicker/DayStyle.ts
var DayStyle = (p) => `
.react-datepicker__day,
.react-datepicker__month-text,
.react-datepicker__quarter-text,
.react-datepicker__year-text {
  cursor:pointer;
  background-color:transparent;
  &:hover:before{
      background-color: ${p("colors.neutral.200")}
  }
  &:active:before{
      background-color: ${p("colors.neutral.300")}
  }

  &--today {
    font-weight: ${p("fontWeight.semibold")};
    color: ${p("colors.primary.600")};
    &::before,
    &:hover:before,
    &:active:before {
      border: 1px solid ${p("colors.primary.600")};
    }
    &.react-datepicker__day--in-selecting-range,
    &.react-datepicker__day--in-range{
      color: ${p("colors.primary.700")};
      &.react-datepicker__day--selected{
        color: ${p("colors.primary.700")};
        &.react-datepicker__day--range-end,
        &.react-datepicker__day--range-start{
          color: ${p("colors.neutral.50")};
        }
      }
    }
    react-datepicker__day--in-selecting-range
    &.react-datepicker__day--selecting-range-start{
      color: ${p("colors.neutral.50")};
    }
    &.react-datepicker__day--range-start.react-datepicker__day--range-end,
    &.react-datepicker__day--range-start,
    &.react-datepicker__day--range-end{
      color: ${p("colors.neutral.50")};
    }
  }

  &--outside-month{
    color: ${p("colors.neutral.500")}
  }
  &--selected{
    color: ${p("colors.neutral.50")};
    &:before{
      background-color: ${p("colors.primary.600")}
    }
    &:hover:before{
      background-color: ${p("colors.primary.700")};
    }
    &:active:before{
      background-color: ${p("colors.primary.800")};
    }
  }

  &--in-selecting-range,
  &--in-range {
    color: ${p("colors.neutral.700")};
    background-color: ${p("colors.primary.200")};
    border-radius:0;
    &:before{
      background-color: ${p("colors.primary.200")}
    }
    &:hover:before{
      background-color: ${p("colors.primary.300")};
    }
    &:active:before{
      background-color: ${p("colors.primary.400")};
    }
    
    &.react-datepicker__day--range-start.react-datepicker__day--range-end,
    &.react-datepicker__day--selecting-range-start.react-datepicker__day--selecting-range-end{
      &:after{
        width:0px;
      }
    }
  }

  &--range-start,
  &--range-end{
    color: ${p("colors.neutral.50")};
    background:transparent;
    &:before{
      background-color: ${p("colors.primary.600")}
    }
    &:hover:before{
      background-color: ${p("colors.primary.700")};
    }
    &:active:before{
      background-color: ${p("colors.primary.800")};
    }
  }

  &--selecting-range-end,
  &--selecting-range-start{
    background:transparent;
  }

  &--in-range:not(&--in-selecting-range) {
    .react-datepicker__month--selecting-range &,
    .react-datepicker__year--selecting-range & {
      color: red;
      background-color: red;
      &:before{
        background-color: green;
      }
    }
  }

  &--selecting-range-start,
  &--range-start {
    &:after{
      right:0;
      background-color: ${p("colors.primary.200")}
    }
  }
  
  &--selecting-range-end,
  &--range-end{
    &:after{
      left:0;
      background-color: ${p("colors.primary.200")}
    }
  }
}

.react-datepicker__day--outside-month{
  &:empty{
    visibility:hidden;
  }
}

`;
var DayStyle_default = DayStyle;

// src/components/DatePicker/MonthPickerStyle.ts
var MonthPickerStyle = (p) => `

  .react-datepicker__month-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 302px;
    column-gap: 36px;
  } 

  .react-datepicker__month .react-datepicker__month-text {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 32px;
    color: ${p("colors.neutral.600")};
    font-weight: ${p("fontWeight.semibold")};
    border-radius: ${p("borderRadius.sm")};
    font-size: ${p("fontSize.sm")};
    cursor:pointer;
    &:hover {
      background-color: ${p("colors.neutral.200")};
    }
    &:active {
      background-color: ${p("colors.neutral.300")};
    }
  }

  .react-datepicker__month-container {
    float: left;
    &::after {
      content: '';
      clear: both;
      display: table;
    }
  }

  .react-datepicker__monthPicker {
    width: 302px;
    display: flex;
    flex-direction: column;
    row-gap: 24px;
  }

  .react-datepicker__month {
    text-align: center;
    margin: ${p("spacing.[4.5]")};
    margin-top: ${p("spacing.[2.5]")};
    margin-bottom: ${p("spacing.1")};
  }

  .react-datepicker__month .react-datepicker__quarter-text {
    display: inline-block;
    width: 4rem;
    margin: 2px;
  }`;
var MonthPickerStyle_default = MonthPickerStyle;

// src/components/DatePicker/WeekPickerStyle.ts
var weekPickerStyle = (p) => `
.week__selected{
    &.react-datepicker__day{
        background: ${p("colors.primary.200")};
        border-radius:0;
        color: ${p("colors.neutral.700")};
        &:before{
            background-color: transparent;
        }
        &.react-datepicker__day--today{
            color: ${p("colors.primary.600")};
            &:before{
                background-color:transparent;
            }            
        }
        &:first-of-type,
        &:last-of-type{
            background: transparent;
            color: ${p("colors.neutral.50")};
            &:before{
                background-color: ${p("colors.primary.600")};
            }
            &:after{
                background-color: ${p("colors.primary.200")}
            }
        }
        &:first-of-type{
            &:after{
                right:0;
            }
        }
        &:last-of-type{
            &:after{
                left:0;
            }
        }
    }
}

.react-datepicker__week:hover{
    .react-datepicker__day{
        background: ${p("colors.primary.300")};
        &:first-of-type,
        &:last-of-type{
            background-color:transparent;
            &:after{
                background-color:${p("colors.primary.300")};
            }
        }
        &:not(.week__selected){
            background: ${p("colors.neutral.200")};
            border-radius:0;
            color: ${p("colors.neutral.700")};
            &.react-datepicker__day--today{
                color: ${p("colors.primary.600")};
            }
            &:before{
                background-color: transparent;
            }
            &:first-of-type,
            &:last-of-type{
                background-color: transparent;
                &:before,
                &:after{
                    background-color:${p("colors.neutral.200")};
                }
            }
            &:first-of-type{
                &:after{
                    right:0;
                }
            }
            &:last-of-type{
                &:after{
                    left:0;
                }
            }
        }
    }
}

.react-datepicker__week:active{
    .react-datepicker__day{
        &:not(.week__selected){
            background-color:${p("colors.neutral.300")};
            &:first-of-type,
            &:last-of-type{
                background:transparent;
                &:before,
                &:after{
                    background-color:${p("colors.neutral.300")};
                }
            }
        }
        &.week__selected{
            background-color:${p("colors.primary.400")};
            &:first-of-type,
            &:last-of-type{
                background:transparent;
                &:after{
                    background-color:${p("colors.primary.400")};
                }
            }
        }
    }
}
`;
var WeekPickerStyle_default = weekPickerStyle;

// src/components/DatePicker/YearPickerStyle.ts
var yearStyle = (p) => `
 .react-datepicker__year-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 2px;
    padding-bottom:12px;
    max-width: 302px;
    column-gap: 36px;
    row-gap: 24px;
  }
  .react-datepicker__year .react-datepicker__year-text {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 64px;
    height: 32px;
    color: ${p("colors.neutral.600")};
    font-weight: ${p("fontWeight.semibold")};
    border-radius: ${p("borderRadius.sm")};
    font-size: ${p("fontSize.sm")};
    cursor:pointer;
    &:hover {
      background-color: ${p("colors.neutral.200")};
    }
    &:active {
      background-color: ${p("colors.neutral.300")};
    }
  }

  .react-datepicker__year
    .react-datepicker__year-text.react-datepicker__year-text--today,
  .react-datepicker__month
    .react-datepicker__month-text.react-datepicker__month-text--today {
    border-radius: ${p("borderRadius.sm")};
    border: 1px solid ${p("colors.primary.600")};
    color: ${p("colors.primary.600")};
    &:hover {
      background-color: ${p("colors.neutral.200")};
    }
    &:active {
      background-color: ${p("colors.neutral.300")};
    }
  }

  .react-datepicker__year .react-datepicker__year-text.react-datepicker__year-text--selected,
  .react-datepicker__month .react-datepicker__month-text.react-datepicker__month--selected {
    background-color: ${p("colors.primary.600")};
    color: ${p("colors.neutral.50")};
    &:hover {
      background-color: ${p("colors.primary.700")};
    }
    &:active {
      background-color: ${p("colors.primary.800")};
    }
  }
`;
var YearPickerStyle_default = yearStyle;

// src/components/DatePicker/DatePickerStyle.ts
var DatePickerStyle = ({
  p,
  withPortal,
  removeShadows,
  weekPicker = false
}) => {
  const portalParent = withPortal ? "&" : "";
  return css2`
    .react-datepicker {
      font-family: ${p("fontFamily.sans")};
      font-size: ${p("fontSize.sm")};
      background-color: ${p("colors.neutral.50")};
      color: ${p("colors.neutral.700")};
      border: 0 none;
      border-radius: ${p("borderRadius.sm")};
      display: inline-block;
      position: relative;
      box-shadow: ${removeShadows ? "" : "0px 1px 5px rgba(56, 56, 56, 0.4)"};
      z-index: 1;
    }

    .react-datepicker__aria-live {
      display: none;
    }

    .react-datepicker__year-read-view--down-arrow,
    .react-datepicker__month-read-view--down-arrow,
    .react-datepicker__month-year-read-view--down-arrow,
    .react-datepicker__navigation-icon::before {
      border-color: currentColor;
      border-style: solid;
      border-width: 3px 3px 0 0;
      content: '';
      display: block;
      height: ${p("spacing.[3.5]")};
      position: absolute;
      top: ${p("spacing.[1]")};
      width: ${p("spacing.[3.5]")};
    }
    ${portalParent}.react-datepicker-popper .react-datepicker__triangle {
      display: none;
    }
    ${portalParent}.react-datepicker-popper[data-placement^='top']
      .react-datepicker__triangle,
    ${portalParent}.react-datepicker-popper[data-placement^='bottom']
      .react-datepicker__triangle {
      margin-left: -4px;
      position: absolute;
      width: 0;
    }
    ${portalParent}.react-datepicker-popper[data-placement^='top']
      .react-datepicker__triangle::before,
    ${portalParent}.react-datepicker-popper[data-placement^='bottom']
      .react-datepicker__triangle::before,
    ${portalParent}.react-datepicker-popper[data-placement^='top']
      .react-datepicker__triangle::after,
    ${portalParent}.react-datepicker-popper[data-placement^='bottom']
      .react-datepicker__triangle::after {
      box-sizing: content-box;
      position: absolute;
      border: 8px solid transparent;
      height: 0;
      width: 1px;
      content: '';
      z-index: -1;
      border-width: 8px;
      left: -8px;
    }
    ${portalParent}.react-datepicker-popper[data-placement^='top']
      .react-datepicker__triangle::before,
    ${portalParent}.react-datepicker-popper[data-placement^='bottom']
      .react-datepicker__triangle::before {
      border-bottom-color: #aeaeae;
    }

    ${portalParent}.react-datepicker-popper[data-placement^='bottom']
      .react-datepicker__triangle {
      top: 0;
      margin-top: -8px;
    }
    ${portalParent}.react-datepicker-popper[data-placement^='bottom']
      .react-datepicker__triangle::before,
    ${portalParent}.react-datepicker-popper[data-placement^='bottom']
      .react-datepicker__triangle::after {
      border-top: none;
      border-bottom-color: ${p("colors.neutral.100")};
    }
    ${portalParent}.react-datepicker-popper[data-placement^='bottom']
      .react-datepicker__triangle::after {
      top: 0;
    }
    ${portalParent}.react-datepicker-popper[data-placement^='bottom']
      .react-datepicker__triangle::before {
      top: -1px;
      border-bottom-color: #aeaeae;
    }

    ${portalParent}.react-datepicker-popper[data-placement^='top']
      .react-datepicker__triangle {
      bottom: 0;
      margin-bottom: -8px;
    }
    ${portalParent}.react-datepicker-popper[data-placement^='top']
      .react-datepicker__triangle::before,
    ${portalParent}.react-datepicker-popper[data-placement^='top']
      .react-datepicker__triangle::after {
      border-bottom: none;
      border-top-color: ${p("colors.neutral.50")};
    }
    ${portalParent}.react-datepicker-popper[data-placement^='top']
      .react-datepicker__triangle::after {
      bottom: 0;
    }
    ${portalParent}.react-datepicker-popper[data-placement^='top']
      .react-datepicker__triangle::before {
      bottom: -1px;
      border-top-color: #aeaeae;
    }

    .react-datepicker-wrapper {
      display: inline-block;
      padding: 0;
      border: 0;
      width: 100%;
    }

    .react-datepicker--time-only .react-datepicker__triangle {
      left: 35px;
    }
    .react-datepicker--time-only .react-datepicker__time-container {
      border-left: 0;
    }
    .react-datepicker--time-only .react-datepicker__time,
    .react-datepicker--time-only .react-datepicker__time-box {
      border-bottom-left-radius: ${p("borderRadius.sm")};
      border-bottom-right-radius: ${p("borderRadius.sm")};
    }

    .react-datepicker__triangle {
      position: absolute;
      left: 50px;
    }

    ${portalParent}.react-datepicker-popper {
      z-index: ${p(withPortal ? "zIndex.tooltip" : "zIndex.dropdown")};
    }
    ${portalParent}.react-datepicker-popper[data-placement^='bottom'] {
      padding-top: 10px;
    }
    ${portalParent}.react-datepicker-popper[data-placement='bottom-end']
      .react-datepicker__triangle,
    ${portalParent}.react-datepicker-popper[data-placement='top-end']
      .react-datepicker__triangle {
      left: auto;
      right: 50px;
    }
    ${portalParent}.react-datepicker-popper[data-placement^='top'] {
      padding-bottom: 10px;
    }
    ${portalParent}.react-datepicker-popper[data-placement^='right'] {
      padding-left: 8px;
    }
    ${portalParent}.react-datepicker-popper[data-placement^='right']
      .react-datepicker__triangle {
      left: auto;
      right: 42px;
    }
    ${portalParent}.react-datepicker-popper[data-placement^='left'] {
      padding-right: 8px;
    }
    ${portalParent}.react-datepicker-popper[data-placement^='left']
      .react-datepicker__triangle {
      left: 42px;
      right: auto;
    }

    .react-datepicker__header {
      text-align: center;
      background-color: ${p("colors.neutral.50")};
      border-bottom: 0 none;
      border-top-left-radius: ${p("borderRadius.sm")};
      padding: 8px 0;
      padding-top: 20px;
      position: relative;
      padding-bottom: 0;
    }
    .react-datepicker__header--time {
      padding-bottom: 8px;
      padding-left: 5px;
      padding-right: 5px;
    }
    .react-datepicker__header--time:not(.react-datepicker__header--time--only) {
      border-top-left-radius: 0;
    }
    .react-datepicker__header:not(.react-datepicker__header--has-time-select) {
      border-top-right-radius: ${p("borderRadius.sm")};
    }

    .react-datepicker__year-dropdown-container--select,
    .react-datepicker__month-dropdown-container--select,
    .react-datepicker__month-year-dropdown-container--select,
    .react-datepicker__year-dropdown-container--scroll,
    .react-datepicker__month-dropdown-container--scroll,
    .react-datepicker__month-year-dropdown-container--scroll {
      display: inline-block;
      margin: 0 2px;
    }

    .react-datepicker__current-month,
    .react-datepicker-time__header,
    .react-datepicker-year-header {
      margin-top: 0;
      color: ${p("colors.neutral.700")};
      font-weight: ${p("fontWeight.bold")};
      line-height: 27px;
      margin-bottom: ${p("spacing.4")};
      font-size: ${p("fontSize.md")};

      &::first-letter {
        text-transform: uppercase;
      }
    }

    .react-datepicker-time__header {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .react-datepicker__navigation {
      align-items: center;
      background: transparent;
      display: flex;
      justify-content: center;
      text-align: center;
      cursor: pointer;
      position: absolute;
      top: ${p("spacing.[4.5]")};
      padding: 0;
      border: 1px solid transparent;
      z-index: 1;
      height: 32px;
      width: 32px;
      text-indent: -999em;
      overflow: hidden;
      border-radius: ${p("borderRadius.full")};
      color: ${p("colors.neutral.600")};

      &:hover {
        color: ${p("colors.neutral.700")};
        background: ${rgba(p("colors.neutral.600"), 0.1)};
      }

      &:active {
        color: ${p("colors.neutral.800")};
        background: ${rgba(p("colors.neutral.600"), 0.15)};
      }

      &:focus {
        outline: none;
      }

      &:focus-visible {
        outline: none;
        color: ${p("colors.neutral.800")};
        background: ${rgba(p("colors.neutral.600"), 0.2)};
        box-shadow: 0 0 0 2px ${p("colors.neutral.50")},
          0 0 0 3.5px ${p("colors.neutral.800")};
      }

      &:disabled {
        cursor: not-allowed;
        background: transparent;
        color: ${p("colors.neutral.400")};
      }
    }
    .react-datepicker__navigation--previous {
      left: ${p("spacing.5")};
    }
    .react-datepicker__navigation--next {
      right: ${p("spacing.5")};
    }
    .react-datepicker__navigation--next--with-time:not(
        .react-datepicker__navigation--next--with-today-button
      ) {
      right: 85px;
    }
    .react-datepicker__navigation--years {
      position: relative;
      top: 0;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    .react-datepicker__navigation--years-previous {
      top: 4px;
    }
    .react-datepicker__navigation--years-upcoming {
      top: -4px;
    }
    .react-datepicker__navigation:hover *::before {
      border-color: ${p("colors.neutral.700")};
    }

    .react-datepicker__navigation-icon {
      position: relative;
      top: 5px;
      font-size: 20px;
      width: 0;
    }
    .react-datepicker__navigation-icon--next {
      left: 0;
    }
    .react-datepicker__navigation-icon--next::before {
      transform: rotate(45deg);
      left: -${p("spacing.[2.5]")};
    }
    .react-datepicker__navigation-icon--previous {
      right: 0;
    }
    .react-datepicker__navigation-icon--previous::before {
      transform: rotate(225deg);
      right: -${p("spacing.[2.5]")};
    }

    .react-datepicker__input-time-container {
      clear: both;
      width: 100%;
      float: left;
      margin: 5px 0 10px 15px;
      text-align: left;
    }
    .react-datepicker__input-time-container .react-datepicker-time__caption {
      display: inline-block;
    }
    .react-datepicker__input-time-container
      .react-datepicker-time__input-container {
      display: inline-block;
    }
    .react-datepicker__input-time-container
      .react-datepicker-time__input-container
      .react-datepicker-time__input {
      display: inline-block;
      margin-left: 10px;
    }
    .react-datepicker__input-time-container
      .react-datepicker-time__input-container
      .react-datepicker-time__input
      input {
      width: auto;
    }
    .react-datepicker__input-time-container
      .react-datepicker-time__input-container
      .react-datepicker-time__input
      input[type='time']::-webkit-inner-spin-button,
    .react-datepicker__input-time-container
      .react-datepicker-time__input-container
      .react-datepicker-time__input
      input[type='time']::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    .react-datepicker__input-time-container
      .react-datepicker-time__input-container
      .react-datepicker-time__input
      input[type='time'] {
      -moz-appearance: textfield;
    }
    .react-datepicker__input-time-container
      .react-datepicker-time__input-container
      .react-datepicker-time__delimiter {
      margin-left: 5px;
      display: inline-block;
    }

    .react-datepicker__time-container {
      float: right;
      border-left: 1px solid #aeaeae;
      width: 85px;
    }
    .react-datepicker__time-container--with-today-button {
      display: inline;
      border: 1px solid #aeaeae;
      border-radius: ${p("borderRadius.sm")};
      position: absolute;
      right: -72px;
      top: 0;
    }
    .react-datepicker__time-container .react-datepicker__time {
      position: relative;
      background: white;
      border-bottom-right-radius: ${p("borderRadius.sm")};
    }
    .react-datepicker__time-container
      .react-datepicker__time
      .react-datepicker__time-box {
      width: 85px;
      overflow-x: hidden;
      margin: 0 auto;
      text-align: center;
      border-bottom-right-radius: ${p("borderRadius.sm")};
    }
    .react-datepicker__time-container
      .react-datepicker__time
      .react-datepicker__time-box
      ul.react-datepicker__time-list {
      list-style: none;
      margin: 0;
      height: calc(195px + (1.7rem / 2));
      overflow-y: scroll;
      padding-right: 0;
      padding-left: 0;
      width: 100%;
      box-sizing: content-box;
    }
    .react-datepicker__time-container
      .react-datepicker__time
      .react-datepicker__time-box
      ul.react-datepicker__time-list
      li.react-datepicker__time-list-item {
      height: 30px;
      padding: 5px 10px;
      white-space: nowrap;
    }
    .react-datepicker__time-container
      .react-datepicker__time
      .react-datepicker__time-box
      ul.react-datepicker__time-list
      li.react-datepicker__time-list-item:hover {
      cursor: pointer;
      background-color: ${p("colors.neutral.100")};
    }
    .react-datepicker__time-container
      .react-datepicker__time
      .react-datepicker__time-box
      ul.react-datepicker__time-list
      li.react-datepicker__time-list-item--selected {
      background-color: ${p("colors.primary.600")};
      color: white;
      font-weight: bold;
    }
    .react-datepicker__time-container
      .react-datepicker__time
      .react-datepicker__time-box
      ul.react-datepicker__time-list
      li.react-datepicker__time-list-item--selected:hover {
      background-color: ${p("colors.primary.600")};
    }
    .react-datepicker__time-container
      .react-datepicker__time
      .react-datepicker__time-box
      ul.react-datepicker__time-list
      li.react-datepicker__time-list-item--disabled {
      color: #ccc;
    }
    .react-datepicker__time-container
      .react-datepicker__time
      .react-datepicker__time-box
      ul.react-datepicker__time-list
      li.react-datepicker__time-list-item--disabled:hover {
      cursor: default;
      background-color: transparent;
    }

    .react-datepicker__week-number {
      color: #ccc;
      display: inline-block;
      width: 1.7rem;
      line-height: 1.7rem;
      text-align: center;
      margin: 0.166rem;
    }
    .react-datepicker__week-number.react-datepicker__week-number--clickable {
      cursor: pointer;
    }
    .react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
      border-radius: ${p("borderRadius.sm")};
      background-color: ${p("colors.neutral.100")};
    }

    .react-datepicker__day-names,
    .react-datepicker__week {
      white-space: nowrap;
    }

    .react-datepicker__day-names {
      margin-bottom: -8px;
      font-weight: ${p("fontWeight.semibold")};
    }

    .react-datepicker__day-name,
    .react-datepicker__day,
    .react-datepicker__time-name {
      position: relative;
      color: ${p("colors.neutral.700")};
      display: inline-block;
      width: ${p("spacing.10")};
      line-height: ${p("spacing.[7.5]")};
      text-align: center;
      margin: ${p("spacing.[1.5]")} 0;
      z-index: 1;

      &::before {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: ${p("borderRadius.full")};
        background: transparent;
        height: ${p("spacing.[7.5]")};
        width: ${p("spacing.[7.5]")};
        display: block;
        z-index: -1;
      }
      &::after {
        content: '';
        position: absolute;
        top: 0;
        background: transparent;
        height: 100%;
        width: 50%;
        z-index: -2;
      }

      &:focus-visible {
        outline: none;
      }

      &::first-letter {
        text-transform: uppercase;
      }
    }

    .react-datepicker__day--disabled,
    .react-datepicker__month-text--disabled,
    .react-datepicker__quarter-text--disabled,
    .react-datepicker__year-text--disabled {
      cursor: not-allowed;
      color: ${p("colors.neutral.400")};
      text-decoration: line-through;

      &:not(.react-datepicker__day--today)::before {
        display: none;
      }
    }
    .react-datepicker__day--disabled:hover,
    .react-datepicker__month-text--disabled:hover,
    .react-datepicker__quarter-text--disabled:hover,
    .react-datepicker__year-text--disabled:hover {
      background-color: transparent;
    }

    .react-datepicker__input-container {
      position: relative;
      display: inline-block;
      width: 100%;
    }

    .react-datepicker__year-read-view,
    .react-datepicker__month-read-view,
    .react-datepicker__month-year-read-view {
      border: 1px solid transparent;
      border-radius: ${p("borderRadius.sm")};
      position: relative;
    }
    .react-datepicker__year-read-view:hover,
    .react-datepicker__month-read-view:hover,
    .react-datepicker__month-year-read-view:hover {
      cursor: pointer;
    }
    .react-datepicker__year-read-view:hover
      .react-datepicker__year-read-view--down-arrow,
    .react-datepicker__year-read-view:hover
      .react-datepicker__month-read-view--down-arrow,
    .react-datepicker__month-read-view:hover
      .react-datepicker__year-read-view--down-arrow,
    .react-datepicker__month-read-view:hover
      .react-datepicker__month-read-view--down-arrow,
    .react-datepicker__month-year-read-view:hover
      .react-datepicker__year-read-view--down-arrow,
    .react-datepicker__month-year-read-view:hover
      .react-datepicker__month-read-view--down-arrow {
      border-top-color: #b3b3b3;
    }
    .react-datepicker__year-read-view--down-arrow,
    .react-datepicker__month-read-view--down-arrow,
    .react-datepicker__month-year-read-view--down-arrow {
      transform: rotate(135deg);
      right: -16px;
      top: 0;
    }

    .react-datepicker__year-dropdown,
    .react-datepicker__month-dropdown,
    .react-datepicker__month-year-dropdown {
      background-color: ${p("colors.neutral.100")};
      position: absolute;
      width: 50%;
      left: 25%;
      top: 30px;
      z-index: 1;
      text-align: center;
      border-radius: ${p("borderRadius.sm")};
      border: 1px solid #aeaeae;
    }
    .react-datepicker__year-dropdown:hover,
    .react-datepicker__month-dropdown:hover,
    .react-datepicker__month-year-dropdown:hover {
      cursor: pointer;
    }
    .react-datepicker__year-dropdown--scrollable,
    .react-datepicker__month-dropdown--scrollable,
    .react-datepicker__month-year-dropdown--scrollable {
      height: 150px;
      overflow-y: scroll;
    }

    .react-datepicker__year-option,
    .react-datepicker__month-option,
    .react-datepicker__month-year-option {
      line-height: 20px;
      width: 100%;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    .react-datepicker__year-option:first-of-type,
    .react-datepicker__month-option:first-of-type,
    .react-datepicker__month-year-option:first-of-type {
      border-top-left-radius: ${p("borderRadius.sm")};
      border-top-right-radius: ${p("borderRadius.sm")};
    }
    .react-datepicker__year-option:last-of-type,
    .react-datepicker__month-option:last-of-type,
    .react-datepicker__month-year-option:last-of-type {
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      border-bottom-left-radius: ${p("borderRadius.sm")};
      border-bottom-right-radius: ${p("borderRadius.sm")};
    }
    .react-datepicker__year-option:hover,
    .react-datepicker__month-option:hover,
    .react-datepicker__month-year-option:hover {
      background-color: #ccc;
    }
    .react-datepicker__year-option:hover
      .react-datepicker__navigation--years-upcoming,
    .react-datepicker__month-option:hover
      .react-datepicker__navigation--years-upcoming,
    .react-datepicker__month-year-option:hover
      .react-datepicker__navigation--years-upcoming {
      border-bottom-color: #b3b3b3;
    }
    .react-datepicker__year-option:hover
      .react-datepicker__navigation--years-previous,
    .react-datepicker__month-option:hover
      .react-datepicker__navigation--years-previous,
    .react-datepicker__month-year-option:hover
      .react-datepicker__navigation--years-previous {
      border-top-color: #b3b3b3;
    }
    .react-datepicker__year-option--selected,
    .react-datepicker__month-option--selected,
    .react-datepicker__month-year-option--selected {
      position: absolute;
      left: 15px;
    }

    .react-datepicker__close-icon {
      cursor: pointer;
      background-color: transparent;
      border: 0;
      outline: 0;
      padding: 0 6px 0 0;
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      display: table-cell;
      vertical-align: middle;
    }
    .react-datepicker__close-icon::after {
      cursor: pointer;
      background-color: ${p("colors.primary.600")};
      color: ${p("colors.neutral.50")};
      border-radius: 50%;
      height: 16px;
      width: 16px;
      padding: 2px;
      font-size: 12px;
      line-height: 1;
      text-align: center;
      display: table-cell;
      vertical-align: middle;
      content: '×';
    }

    .react-datepicker__today-button {
      background: ${p("colors.neutral.100")};
      border-top: 1px solid #aeaeae;
      cursor: pointer;
      text-align: center;
      font-weight: bold;
      padding: 5px 0;
      clear: left;
    }

    .react-datepicker__portal {
      position: fixed;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.8);
      left: 0;
      top: 0;
      justify-content: center;
      align-items: center;
      display: flex;
      z-index: 2147483647;
    }
    .react-datepicker__portal .react-datepicker__day-name,
    .react-datepicker__portal .react-datepicker__day,
    .react-datepicker__portal .react-datepicker__time-name {
      width: 3rem;
      line-height: 3rem;
    }
    @media (max-width: 400px), (max-height: 550px) {
      .react-datepicker__portal .react-datepicker__day-name,
      .react-datepicker__portal .react-datepicker__day,
      .react-datepicker__portal .react-datepicker__time-name {
        width: 2rem;
        line-height: 2rem;
      }
    }
    .react-datepicker__portal .react-datepicker__current-month,
    .react-datepicker__portal .react-datepicker-time__header {
      font-size: 1.44rem;
    }

    ${DayStyle_default(p)}
    ${weekPicker && WeekPickerStyle_default(p)}
    ${YearPickerStyle_default(p)}
    ${MonthPickerStyle_default(p)}
  `;
};

// src/components/DatePicker/DatePicker.tsx
function getLastYears(count) {
  const currentYear = getYear(/* @__PURE__ */ new Date());
  const startYear = getYear(subYears(/* @__PURE__ */ new Date(), count - 1));
  const years = [];
  for (let i = startYear; i <= currentYear; i++) {
    years.push(i);
  }
  return years.reverse();
}
function getMonthNames(locale) {
  const months = [];
  for (let i = 0; i < 12; i++) {
    const monthDate = parse(`${i + 1}`, "M", /* @__PURE__ */ new Date());
    const monthName = format3(monthDate, "MMMM", { locale });
    months.push(monthName);
  }
  return months;
}
function getYearsPickerRangeStart({
  date,
  yearItemNumber
}) {
  const year = date.getFullYear();
  const yearOffset = 1;
  const endYearOffset = 1;
  const startYear = year - (year - yearOffset) % yearItemNumber;
  return [startYear, startYear + yearItemNumber - endYearOffset];
}
var CustomInput = forwardRef9(
  function CustomInputHelper({ size, ...otherProps }, ref) {
    return /* @__PURE__ */ React26.createElement(Input.Group, { size }, /* @__PURE__ */ React26.createElement(Input, { ref, ...otherProps }), /* @__PURE__ */ React26.createElement(Input.RightElement, null, /* @__PURE__ */ React26.createElement(
      IconButton,
      {
        size: "sm",
        variant: "text",
        color: "neutral",
        icon: /* @__PURE__ */ React26.createElement(MdOutlineEvent, null),
        onClick: otherProps.onClick
      }
    )));
  }
);
var CustomHeaderMonth = () => {
  const years = getLastYears(10);
  return function Header({
    monthDate,
    changeYear,
    increaseYear,
    decreaseYear,
    nextYearButtonDisabled,
    prevYearButtonDisabled
  }) {
    return /* @__PURE__ */ React26.createElement(Box, { className: "flex justify-between items-center px-5 mb-3.5" }, /* @__PURE__ */ React26.createElement(
      IconButton,
      {
        onClick: decreaseYear,
        disabled: prevYearButtonDisabled,
        icon: /* @__PURE__ */ React26.createElement(MdOutlineArrowBackIos, null),
        variant: "text",
        size: "sm"
      }
    ), /* @__PURE__ */ React26.createElement(
      Box,
      {
        as: "span",
        className: "font-bold text-md text-neutral-600 capitalize"
      },
      /* @__PURE__ */ React26.createElement(Dropdown, null, /* @__PURE__ */ React26.createElement(
        Dropdown.Button,
        {
          as: Button,
          className: "mr-1.5 ml-1",
          size: "xs",
          variant: "outline"
        },
        getYear(monthDate)
      ), /* @__PURE__ */ React26.createElement(Dropdown.List, { className: "h-44 overflow-y-auto" }, years.map((option) => /* @__PURE__ */ React26.createElement(
        Dropdown.Item,
        {
          key: option,
          onClick: () => changeYear(+option),
          isFocused: getYear(monthDate) === option
        },
        option
      ))))
    ), /* @__PURE__ */ React26.createElement(
      IconButton,
      {
        onClick: increaseYear,
        disabled: nextYearButtonDisabled,
        icon: /* @__PURE__ */ React26.createElement(MdOutlineArrowForwardIos, null),
        variant: "text",
        size: "sm"
      }
    ));
  };
};
var CustomHeaderYear = ({ yearItemNumber }) => {
  return function Header({
    date,
    increaseYear,
    decreaseYear,
    nextYearButtonDisabled,
    prevYearButtonDisabled
  }) {
    const [startYear, endYear] = getYearsPickerRangeStart({
      date,
      yearItemNumber
    });
    return /* @__PURE__ */ React26.createElement(Box, { className: "flex justify-between items-center px-5 mb-3.5" }, /* @__PURE__ */ React26.createElement(
      IconButton,
      {
        onClick: decreaseYear,
        disabled: prevYearButtonDisabled,
        icon: /* @__PURE__ */ React26.createElement(MdOutlineArrowBackIos, null),
        variant: "text",
        size: "sm"
      }
    ), /* @__PURE__ */ React26.createElement(
      Box,
      {
        as: "span",
        className: "font-bold text-md text-neutral-600 capitalize"
      },
      startYear,
      " - ",
      endYear
    ), /* @__PURE__ */ React26.createElement(
      IconButton,
      {
        onClick: increaseYear,
        disabled: nextYearButtonDisabled,
        icon: /* @__PURE__ */ React26.createElement(MdOutlineArrowForwardIos, null),
        variant: "text",
        size: "sm"
      }
    ));
  };
};
var CustomHeaderBase = ({
  isHeaderClickeable,
  locale,
  monthsShown = 1
}) => {
  return function Header({
    monthDate,
    changeYear,
    changeMonth,
    decreaseMonth,
    customHeaderCount,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled
  }) {
    const years = getLastYears(10);
    const months = getMonthNames(
      typeof locale !== "string" ? locale : void 0
    );
    return /* @__PURE__ */ React26.createElement(Box, { className: "flex justify-center items-center px-5 mb-3.5" }, /* @__PURE__ */ React26.createElement(
      IconButton,
      {
        className: clsx(
          "mr-auto",
          monthsShown >= 2 && customHeaderCount === 1 && "invisible"
        ),
        onClick: decreaseMonth,
        disabled: prevMonthButtonDisabled,
        icon: /* @__PURE__ */ React26.createElement(MdOutlineArrowBackIos, null),
        variant: "text",
        size: "sm"
      }
    ), isHeaderClickeable ? /* @__PURE__ */ React26.createElement(React26.Fragment, null, /* @__PURE__ */ React26.createElement(Dropdown, null, /* @__PURE__ */ React26.createElement(
      Dropdown.Button,
      {
        as: Button,
        className: "ml-1.5 mr-1 capitalize",
        size: "xs",
        variant: "outline"
      },
      months[getMonth(monthDate)]
    ), /* @__PURE__ */ React26.createElement(Dropdown.List, { className: "h-44 overflow-y-auto" }, months.map((option) => /* @__PURE__ */ React26.createElement(
      Dropdown.Item,
      {
        key: option,
        className: "capitalize",
        onClick: () => changeMonth(months.indexOf(option)),
        isFocused: months[getMonth(monthDate)] === option
      },
      option
    )))), /* @__PURE__ */ React26.createElement(Dropdown, null, /* @__PURE__ */ React26.createElement(
      Dropdown.Button,
      {
        as: Button,
        className: "mr-1.5 ml-1",
        size: "xs",
        variant: "outline"
      },
      getYear(monthDate)
    ), /* @__PURE__ */ React26.createElement(Dropdown.List, { className: "h-44 overflow-y-auto" }, years.map((option) => /* @__PURE__ */ React26.createElement(
      Dropdown.Item,
      {
        key: option,
        onClick: () => changeYear(+option),
        isFocused: getYear(monthDate) === option
      },
      option
    ))))) : /* @__PURE__ */ React26.createElement(
      Box,
      {
        as: "span",
        className: "font-semibold text-sm text-neutral-600 capitalize"
      },
      months[getMonth(monthDate)],
      " ",
      getYear(monthDate)
    ), /* @__PURE__ */ React26.createElement(
      IconButton,
      {
        className: clsx(
          "ml-auto",
          monthsShown >= 2 && customHeaderCount === 0 && "invisible"
        ),
        onClick: increaseMonth,
        disabled: nextMonthButtonDisabled,
        icon: /* @__PURE__ */ React26.createElement(MdOutlineArrowForwardIos, null),
        variant: "text",
        size: "sm"
      }
    ));
  };
};
var CustomContainer = ({
  leftContent,
  topContent,
  bottomContent
}) => {
  return function Container({ className, children }) {
    return /* @__PURE__ */ React26.createElement(CalendarContainer, { className }, /* @__PURE__ */ React26.createElement(Box, { className: "flex" }, leftContent && /* @__PURE__ */ React26.createElement(Box, { className: "my-5 px-4 border-r border-neutral-300" }, leftContent), /* @__PURE__ */ React26.createElement(Box, null, topContent, /* @__PURE__ */ React26.createElement(Box, null, children))), bottomContent && /* @__PURE__ */ React26.createElement(Box, { className: "pb-4 pt-2 px-6" }, bottomContent));
  };
};
var CustomHeader = ({
  showMonthYearPicker = false,
  showYearPicker = false,
  isHeaderClickeable = false,
  locale,
  monthsShown,
  yearItemNumber = 12
}) => {
  if (showMonthYearPicker)
    return CustomHeaderMonth();
  if (showYearPicker)
    return CustomHeaderYear({ yearItemNumber });
  return CustomHeaderBase({ isHeaderClickeable, locale, monthsShown });
};
var DatePicker = ({
  disabled,
  required,
  disabledKeyboardNavigation = true,
  size,
  onChange = () => null,
  locale,
  leftContent,
  bottomContent,
  topContent,
  isHeaderClickeable = true,
  withPortal = false,
  monthsShown = 1,
  popperClassName,
  inline = false,
  removeShadows = false,
  showYearPicker,
  showMonthYearPicker,
  weekPicker = false,
  yearItemNumber = 12,
  selected,
  ...otherProps
}) => {
  const { getProp } = useTheme();
  const styles = useMemo7(
    () => DatePickerStyle({
      p: getProp,
      withPortal,
      removeShadows,
      weekPicker
    }),
    [weekPicker]
  );
  const handleOnChange = (date, event) => {
    const startDay = startOfWeek(date, {
      locale: locale || String || void 0
    });
    onChange(weekPicker ? startDay : date, event);
  };
  return /* @__PURE__ */ React26.createElement(Box, { className: styles }, /* @__PURE__ */ React26.createElement(
    ReactDatePicker,
    {
      disabled,
      required,
      disabledKeyboardNavigation,
      renderCustomHeader: CustomHeader({
        isHeaderClickeable,
        monthsShown,
        showMonthYearPicker,
        showYearPicker,
        yearItemNumber,
        locale
      }),
      customInput: /* @__PURE__ */ React26.createElement(CustomInput, { size }),
      locale,
      onChange: handleOnChange,
      calendarContainer: CustomContainer({
        leftContent,
        bottomContent,
        topContent
      }),
      portalId: withPortal ? "suit-ui-datepicker-portal" : void 0,
      monthsShown,
      popperClassName: clsx(withPortal && styles, popperClassName),
      inline,
      showYearPicker,
      showMonthYearPicker,
      yearItemNumber,
      dayClassName: (e) => weekPicker && isSameWeek(e, selected, {
        locale
      }) ? "week__selected" : "",
      selected,
      ...otherProps
    }
  ));
};

// src/components/Divider/Divider.tsx
import React27 from "react";
var Divider = ({
  orientation = "horizontal",
  className,
  ...otherProps
}) => {
  return /* @__PURE__ */ React27.createElement(
    Box,
    {
      as: "hr",
      className: clsx(
        "border-neutral-300 rounded-sm",
        orientation === "horizontal" && "my-2 border-t-0 border-b-[1px]",
        orientation === "vertical" && "mx-2 border-t-0 border-l-[1px] h-full"
      ),
      apply: clsx(className),
      ...otherProps
    }
  );
};

// src/components/Image/Image.tsx
import React28, { forwardRef as forwardRef10 } from "react";
var Image = forwardRef10(
  function ImageHelper(props, ref) {
    const { as: Element2 = "img", fallbackSrc, onError, ...otherProps } = props;
    const handleError = (e) => {
      if (fallbackSrc)
        e.currentTarget.src = fallbackSrc;
      onError && onError(e);
    };
    return /* @__PURE__ */ React28.createElement(Box, { as: Element2, ref, onError: handleError, ...otherProps });
  }
);

// src/components/ProgressBar/ProgressBar.tsx
import React29 from "react";
var ProgressBar = ({
  className,
  value = 0,
  color = "primary",
  ...otherProps
}) => {
  const progressWidth = value >= 100 ? 100 : value <= 0 ? 0 : value;
  return /* @__PURE__ */ React29.createElement(
    Box,
    {
      as: "span",
      className: "inline-block w-full bg-neutral-300 rounded-full h-1.5",
      apply: className,
      role: "progressbar",
      "aria-valuenow": progressWidth,
      ...otherProps
    },
    /* @__PURE__ */ React29.createElement(
      Box,
      {
        as: "span",
        className: `
          block 
          ease-in 
          duration-500 
          h-full 
          rounded-full 
          bg-${color}-600 
          w-[${progressWidth}%]
        `
      }
    )
  );
};

// src/components/Link/Link.tsx
import React30, { forwardRef as forwardRef11 } from "react";
var Link = forwardRef11(
  function LinkHelper(props, ref) {
    const {
      as: Element2 = "a",
      isExternal,
      className,
      children,
      disabled,
      href,
      disableVisitedStyle,
      variant = "default",
      ...otherProps
    } = props;
    return /* @__PURE__ */ React30.createElement(
      Box,
      {
        as: Element2,
        ref,
        apply: clsx(
          className,
          disabled && `
              hover:text-neutral-400
              active:text-neutral-400
              visited:text-neutral-400
              text-neutral-400
              cursor-not-allowed
            `
        ),
        className: clsx(
          variant === "default" && `
            cursor-pointer
            text-primary-600
            hover:text-primary-700
            active:text-primary-800
            underline
            underline-offset-2
          `,
          variant === "default" && !disableVisitedStyle && "visited:text-violet-600 visited:hover:text-violet-700 visited:active:text-violet-800"
        ),
        target: isExternal ? "_blank" : void 0,
        rel: isExternal ? "noopener noreferrer" : void 0,
        href: disabled ? void 0 : href,
        disabled,
        ...otherProps
      },
      children
    );
  }
);

// src/components/Modal/Modal.tsx
import { css as css4 } from "@emotion/css";
import React32 from "react";

// src/components/Modal/ModalManager.tsx
import { css as css3 } from "@emotion/css";
import { Global as Global2 } from "@emotion/react";
import { AnimatePresence as AnimatePresence2 } from "framer-motion";
import React31, {
  createContext as createContext7,
  useContext as useContext7,
  useEffect as useEffect8,
  useRef as useRef5,
  useState as useState9
} from "react";
import { createPortal as createPortal3 } from "react-dom";
var modalSizes = {
  xs: "310px",
  sm: "500px",
  md: "700px",
  lg: "900px",
  xl: "1000px"
};
var ModalManagerContext = createContext7(
  void 0
);
function useModalManager() {
  return useContext7(ModalManagerContext);
}
var ModalManager = ({
  isOpen = false,
  onClose,
  children,
  size,
  isCentered = false,
  closeOnOverlayClick = true,
  closeOnEsc = true,
  scrollBehavior = "outside"
}) => {
  const ref = useRef5(null);
  const [mounted, setMounted] = useState9(false);
  useEffect8(() => {
    var _a3;
    ref.current = (_a3 = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a3.querySelector("body");
    setMounted(true);
  }, []);
  useEffect8(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose == null ? void 0 : onClose();
      }
    };
    if (!(globalThis == null ? void 0 : globalThis.document))
      return;
    if (closeOnEsc && isOpen)
      globalThis.document.addEventListener("keydown", handleKeyDown);
    return () => {
      var _a3;
      return (_a3 = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a3.removeEventListener("keydown", handleKeyDown);
    };
  }, [closeOnEsc, isOpen, onClose]);
  if (!(globalThis == null ? void 0 : globalThis.document))
    return null;
  return mounted ? createPortal3(
    /* @__PURE__ */ React31.createElement(
      ModalManagerContext.Provider,
      {
        value: {
          isOpen,
          onClose,
          size,
          isCentered,
          closeOnOverlayClick,
          closeOnEsc,
          scrollBehavior
        }
      },
      /* @__PURE__ */ React31.createElement(AnimatePresence2, null, isOpen && /* @__PURE__ */ React31.createElement("div", { key: "ModalManager" }, children)),
      isOpen && /* @__PURE__ */ React31.createElement(
        Global2,
        {
          styles: {
            body: {
              overflow: "hidden"
            }
          }
        }
      )
    ),
    ref.current
  ) : null;
};
var ModalManagerOverlay = () => /* @__PURE__ */ React31.createElement(
  MotionBox,
  {
    key: "modal-overlay",
    initial: { opacity: 0 },
    animate: { opacity: 0.6 },
    exit: { opacity: 0 },
    className: "z-modal bg-neutral-900 fixed left-0 top-0 h-screen w-screen opacity-60"
  }
);
var ModalManagerContent = (props) => {
  const { children, className = "", ...otherProps } = props;
  const {
    size = "md",
    isCentered,
    onClose,
    closeOnOverlayClick,
    scrollBehavior
  } = useModalManager();
  const { getProp } = useTheme();
  const mouseDownTarget = useRef5(null);
  const overlayRef = useRef5(null);
  const onMouseDown = (e) => {
    mouseDownTarget.current = e.target;
  };
  const handleClickOverlay = (e) => {
    e.stopPropagation();
    const isDraggingToOutside = mouseDownTarget.current !== e.target;
    const isNotOverlayElement = e.target !== overlayRef.current;
    if (!closeOnOverlayClick || isDraggingToOutside || isNotOverlayElement)
      return;
    onClose == null ? void 0 : onClose();
  };
  const maxHeight = css3({
    maxHeight: `calc(100% - ${getProp("spacing.24")})`
  });
  return /* @__PURE__ */ React31.createElement(
    Box,
    {
      className: clsx(
        "fixed left-0 top-0 flex h-screen w-screen justify-center z-modal",
        isCentered ? "items-center" : "items-start",
        scrollBehavior === "outside" && "overflow-auto"
      ),
      onClick: handleClickOverlay,
      onMouseDown,
      ref: overlayRef
    },
    /* @__PURE__ */ React31.createElement(
      MotionBox,
      {
        key: "modal",
        role: "dialog",
        "aria-modal": "true",
        initial: { translateY: -20, opacity: 0 },
        animate: { translateY: 0, opacity: 1 },
        exit: { translateY: -20, opacity: 0 },
        className: clsx(
          "z-modal bg-neutral-50 relative w-full rounded-md shadow-2xl my-12 flex flex-col",
          `max-w-[${modalSizes[size]}]`,
          scrollBehavior === "inside" && maxHeight
        ),
        apply: className,
        ...otherProps
      },
      children
    )
  );
};

// src/components/Modal/Modal.tsx
var Modal = ({
  children,
  size = "md",
  closeOnOverlayClick = true,
  closeOnEsc = true,
  isCentered = false,
  isOpen = false,
  scrollBehavior = "outside",
  ...props
}) => /* @__PURE__ */ React32.createElement(
  ModalManager,
  {
    size,
    closeOnOverlayClick,
    closeOnEsc,
    isCentered,
    scrollBehavior,
    isOpen,
    ...props
  },
  children
);
var ModalHeader = ({
  children,
  className = "",
  ...otherProps
}) => {
  const { size } = useModalManager();
  return /* @__PURE__ */ React32.createElement(
    Box,
    {
      as: "header",
      className: clsx(
        "text-primary-900 border-neutral-300 border-b py-5 px-8 font-semibold",
        size === "xs" ? "text-md" : "text-xl"
      ),
      apply: className,
      ...otherProps
    },
    children
  );
};
var ModalCloseButton = ({
  icon = /* @__PURE__ */ React32.createElement(MdClose, null),
  className,
  ...otherProps
}) => {
  const { onClose, size } = useModalManager();
  return /* @__PURE__ */ React32.createElement(
    IconButton,
    {
      "aria-label": "Close",
      color: "neutral",
      variant: "text",
      className: clsx("absolute top-4 right-4", className),
      size: size === "xs" ? "sm" : "md",
      onClick: onClose,
      icon,
      ...otherProps
    }
  );
};
var ModalBody = ({
  children,
  className = "",
  ...otherProps
}) => {
  const { size } = useModalManager();
  const { getProp: p } = useTheme();
  const scrollStyles = css4({
    background: `
      linear-gradient(${p("colors.neutral.50")} 33%, ${rgba(p("colors.neutral.50"), 0)}),
      linear-gradient(${rgba(p("colors.neutral.900"), 0.1)}, ${rgba(p("colors.neutral.900"), 0)}),
      linear-gradient(${p("colors.neutral.50")}, ${p("colors.neutral.50")}) 0 100%,
      linear-gradient(${p("colors.neutral.100")}, ${p("colors.neutral.100")}) 0 100%
    `,
    backgroundSize: `
      100% ${p("spacing.2")},
      100% ${p("spacing.1")},
      100% ${p("spacing.1")},
      100% ${p("spacing.[0.5]")}
    `,
    backgroundAttachment: `
      local,
      scroll,
      local,
      scroll
    `,
    backgroundRepeat: "no-repeat",
    overflow: "overlay"
  });
  return /* @__PURE__ */ React32.createElement(
    Box,
    {
      className: clsx(
        "px-8 pt-6 overflow-auto text-neutral-600 pb-3.5 last:pb-6",
        size === "xs" ? "text-sm" : "text-md",
        scrollStyles
      ),
      apply: className,
      ...otherProps
    },
    children
  );
};
var ModalFooter = (props) => {
  const { children, className = "", ...otherProps } = props;
  return /* @__PURE__ */ React32.createElement(
    Box,
    {
      as: "footer",
      className: `flex justify-end px-8 pt-4.5 pb-8`,
      apply: className,
      ...otherProps
    },
    children
  );
};
Modal.Overlay = ModalManagerOverlay;
Modal.Content = ModalManagerContent;
Modal.Header = ModalHeader;
Modal.CloseButton = ModalCloseButton;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

// src/components/Modal/Dialog.tsx
import { css as css5 } from "@emotion/css";
import React33, { createContext as createContext8, useContext as useContext8 } from "react";
var DialogContext = createContext8(void 0);
function useDialog() {
  return useContext8(DialogContext);
}
var Dialog = ({
  children,
  size = "xs",
  status,
  closeOnOverlayClick = true,
  closeOnEsc = true,
  isCentered = false,
  isOpen = false,
  scrollBehavior = "outside",
  ...props
}) => /* @__PURE__ */ React33.createElement(DialogContext.Provider, { value: { status } }, /* @__PURE__ */ React33.createElement(
  ModalManager,
  {
    size,
    closeOnOverlayClick,
    closeOnEsc,
    isCentered,
    isOpen,
    scrollBehavior,
    ...props
  },
  children
));
var DialogHeader = ({
  as = "header",
  children,
  className = "",
  ...props
}) => {
  const { status } = useDialog();
  const { size } = useModalManager();
  const statusIcons = {
    success: MdCheckCircle,
    warning: MdReportProblem,
    danger: MdError,
    info: MdInfo
  };
  const statusMap3 = {
    success: "bg-success-700",
    warning: "bg-warning-400",
    danger: "bg-danger-600",
    info: "bg-info-700"
  };
  return /* @__PURE__ */ React33.createElement(React33.Fragment, null, status && /* @__PURE__ */ React33.createElement(
    Box,
    {
      "data-testid": "DialogHeaderStatusBar",
      className: clsx(
        "absolute top-0 left-0 right-0 h-2.5 rounded-t-md",
        statusMap3[status]
      )
    }
  ), /* @__PURE__ */ React33.createElement(
    Box,
    {
      ...props,
      as,
      className: clsx(
        "text-neutral-800  px-5 pb-2.5 font-bold",
        `pt-${status ? "10" : "8"}`,
        size === "xs" ? "text-md" : "text-xl"
      ),
      apply: className
    },
    status && /* @__PURE__ */ React33.createElement(Icon, { as: statusIcons[status], className: "mr-1.5" }),
    children
  ));
};
var DialogCloseButton = ({
  icon,
  className,
  ...otherProps
}) => {
  const { onClose, size } = useModalManager();
  const { status } = useDialog();
  return /* @__PURE__ */ React33.createElement(
    IconButton,
    {
      "data-testid": "DialogCloseButton",
      color: "neutral",
      variant: "text",
      className: clsx(
        "override:(min-w-max) absolute right-1",
        `top-${status ? "3" : "1"}`,
        className
      ),
      size: size === "xs" ? "sm" : "md",
      onClick: onClose,
      icon: icon || /* @__PURE__ */ React33.createElement(MdClose, null),
      ...otherProps
    }
  );
};
var DialogBody = ({
  children,
  className = "",
  ...props
}) => {
  const { size } = useModalManager();
  const { getProp: p } = useTheme();
  const scrollStyles = css5({
    background: `
      linear-gradient(${p("colors.neutral.50")} 33%, ${rgba(p("colors.neutral.50"), 0)}),
      linear-gradient(${rgba(p("colors.neutral.900"), 0.1)}, ${rgba(p("colors.neutral.900"), 0)}),
      linear-gradient(${p("colors.neutral.50")}, ${p("colors.neutral.50")}) 0 100%,
      linear-gradient(${p("colors.neutral.100")}, ${p("colors.neutral.100")}) 0 100%
    `,
    backgroundSize: `
      100% ${p("spacing.2")},
      100% ${p("spacing.1")},
      100% ${p("spacing.1")},
      100% ${p("spacing.[0.5]")}
    `,
    backgroundAttachment: `
      local,
      scroll,
      local,
      scroll
    `,
    backgroundRepeat: "no-repeat",
    overflow: "overlay"
  });
  return /* @__PURE__ */ React33.createElement(
    Box,
    {
      ...props,
      className: clsx(
        "text-neutral-600 overflow-auto px-5 pb-3 last:pb-6",
        size === "xs" ? "text-sm" : "text-md",
        scrollStyles
      ),
      apply: className
    },
    children
  );
};
var DialogFooter = ({
  children,
  as = "footer",
  className = "",
  ...props
}) => /* @__PURE__ */ React33.createElement(
  Box,
  {
    ...props,
    as,
    className: "flex justify-end px-5 pt-3 pb-6",
    apply: className
  },
  children
);
Dialog.Overlay = ModalManagerOverlay;
Dialog.Content = ModalManagerContent;
Dialog.Header = DialogHeader;
Dialog.CloseButton = DialogCloseButton;
Dialog.Body = DialogBody;
Dialog.Footer = DialogFooter;

// src/components/Navbar/Navbar.tsx
import React40 from "react";

// src/components/Navbar/NavbarBrand.tsx
import React34 from "react";
var NavbarBrand = (props) => {
  const { className, ...otherProps } = props;
  return /* @__PURE__ */ React34.createElement(
    Box,
    {
      as: "span",
      className: `flex items-center whitespace-nowrap ${className}`,
      ...otherProps
    }
  );
};

// src/components/Navbar/NavbarButton.tsx
import React35 from "react";
var NavbarButton = ({
  className,
  children,
  ...otherProps
}) => {
  return /* @__PURE__ */ React35.createElement(
    Box,
    {
      as: "button",
      className: clsx("text-neutral-50 p-2", className),
      ...otherProps
    },
    children
  );
};

// src/components/Navbar/NavbarContent.tsx
import React36 from "react";
var NavbarContent = (props) => {
  const { className, ...otherProps } = props;
  return /* @__PURE__ */ React36.createElement(Box, { className: `flex w-full ${className}`, ...otherProps });
};

// src/components/Navbar/NavbarGroup.tsx
import React37 from "react";
var NavbarGroup = (props) => {
  const { className, ...otherProps } = props;
  return /* @__PURE__ */ React37.createElement(Box, { className: `flex gap-6 ${className}`, ...otherProps });
};

// src/components/Navbar/NavbarItem.tsx
import React38 from "react";
var NavbarItem = ({
  className,
  ...otherProps
}) => {
  return /* @__PURE__ */ React38.createElement(
    Box,
    {
      as: "span",
      className: `
          flex
          items-center 
          whitespace-nowrap 
        `,
      apply: className,
      ...otherProps
    }
  );
};

// src/components/Navbar/NavbarLink.tsx
import React39, { forwardRef as forwardRef12 } from "react";
var NavbarLink = forwardRef12(
  function NavbarLinkHelper(props, ref) {
    const { className, ...otherProps } = props;
    return /* @__PURE__ */ React39.createElement(
      Link,
      {
        className: `
          flex 
          items-center 
          whitespace-nowrap 
          text-neutral-50
          ${className}
        `,
        ref,
        variant: "unstyled",
        ...otherProps
      }
    );
  }
);

// src/components/Navbar/Navbar.tsx
var variantMap = {
  static: { container: "static w-full", nav: "" },
  sticky: { container: "sticky top-0 w-full", nav: "" },
  floating: {
    container: "sticky top-0 pt-[0.5%]",
    nav: "relative  top-0 left-0 rounded-md w-full"
  }
};
var Navbar = ({
  className,
  variant = "static",
  color = "primary",
  minH = "16",
  ...otherProps
}) => {
  const variantStyle = variantMap[variant];
  return /* @__PURE__ */ React40.createElement(Box, { as: "nav", className: clsx(variantStyle == null ? void 0 : variantStyle.container), apply: className }, /* @__PURE__ */ React40.createElement(
    Box,
    {
      className: clsx(
        "flex overflow-hidden px-7 py-4 gap-6 shadow-sm text-neutral-50",
        variantStyle == null ? void 0 : variantStyle.nav,
        `bg-${color}-600`,
        `min-h-${minH}`
      ),
      ...otherProps
    }
  ));
};
Navbar.Content = NavbarContent;
Navbar.Brand = NavbarBrand;
Navbar.Item = NavbarItem;
Navbar.Link = NavbarLink;
Navbar.Group = NavbarGroup;
Navbar.Button = NavbarButton;

// src/components/Radio/Radio.tsx
import React43, { useEffect as useEffect9, useLayoutEffect as useLayoutEffect5, useRef as useRef6 } from "react";
import { forwardRef as forwardRef13 } from "react";

// src/components/Radio/RadioGroup.tsx
import React42, { useMemo as useMemo8 } from "react";

// src/components/Radio/RadioGroupContext.ts
import React41 from "react";
var RadioGroupContext = React41.createContext(void 0);
var useRadioGroupContext = () => React41.useContext(RadioGroupContext);

// src/components/Radio/RadioGroup.tsx
var RadioGroup = (props) => {
  const { children, className, value, onChange, name, ...otherProps } = props;
  const handleChange = (v) => {
    onChange && onChange(v);
  };
  const groupName = useMemo8(() => name || getUniqId(), [name]);
  return /* @__PURE__ */ React42.createElement(
    RadioGroupContext.Provider,
    {
      value: {
        name: groupName,
        value,
        handleChange
      }
    },
    /* @__PURE__ */ React42.createElement(Box, { className, ...otherProps }, children)
  );
};

// src/components/Radio/Radio.tsx
var RadioForwarded = forwardRef13(
  function RadioHelper({
    className,
    children,
    disabled,
    onChange,
    value,
    defaultChecked,
    labelPosition = "right",
    ...otherProps
  }, ref) {
    const groupContext = useRadioGroupContext();
    const radioRef = useRef6(null);
    useLayoutEffect5(() => {
      if (ref && (radioRef == null ? void 0 : radioRef.current)) {
        if (ref instanceof Function)
          ref(radioRef.current);
        else
          ref.current = radioRef.current;
      }
    }, [radioRef]);
    useEffect9(() => {
      if ((radioRef == null ? void 0 : radioRef.current) && (groupContext == null ? void 0 : groupContext.value) === value) {
        radioRef.current.checked = true;
      }
    }, [radioRef, groupContext == null ? void 0 : groupContext.value]);
    const handleOnChange = (e) => {
      const v = e.target.value;
      (groupContext == null ? void 0 : groupContext.handleChange) && (groupContext == null ? void 0 : groupContext.handleChange(v));
      onChange && onChange(v);
    };
    return /* @__PURE__ */ React43.createElement(
      Box,
      {
        as: "label",
        className: `
          inline-flex
          items-center
          cursor-pointer
        `,
        apply: clsx(className, disabled && "cursor-not-allowed")
      },
      children && labelPosition === "left" && /* @__PURE__ */ React43.createElement(LabelContainer2, { className: "mr-3" }, children),
      /* @__PURE__ */ React43.createElement(Box, { className: "relative flex" }, /* @__PURE__ */ React43.createElement(
        Box,
        {
          as: "input",
          type: "radio",
          name: groupContext == null ? void 0 : groupContext.name,
          className: "peer sr-only",
          ref: radioRef,
          value,
          disabled,
          onChange: handleOnChange,
          defaultChecked,
          ...otherProps
        }
      ), /* @__PURE__ */ React43.createElement(
        Box,
        {
          as: "span",
          className: `
              top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
              w-10
              h-10
              rounded-full
              absolute
            `,
          apply: `
              bg-neutral-600/10
              peer-checked:bg-primary-600/10

              opacity-0
              peer-hover:opacity-100
              peer-disabled:opacity-0

              peer-focus-visible:(
                opacity-100
                outline
                outline-offset-[-2px]

                bg-neutral-600/20
                peer-checked:bg-primary-600/20

                outline-neutral-800
                peer-checked:outline-primary-800
              )
            `
        }
      ), /* @__PURE__ */ React43.createElement(
        Box,
        {
          as: "span",
          className: `
              relative
              inline-block
              w-5
              h-5
              border
              border-2
              rounded-full
              bg-transparent
            `,
          apply: `
            border-neutral-600
            peer-checked:border-primary-600
            peer-disabled:border-neutral-300

            before:(
              content-[""]
              absolute
              h-2.5
              w-2.5
              rounded-full
              top-1/2
              left-1/2
              -translate-x-1/2
              -translate-y-1/2

              opacity-0
              peer-checked:opacity-100

              bg-primary-600
              peer-disabled:bg-neutral-300
            )
          `
        }
      )),
      children && labelPosition === "right" && /* @__PURE__ */ React43.createElement(LabelContainer2, { className: "ml-3", disabled }, children)
    );
  }
);
var LabelContainer2 = ({
  disabled,
  children,
  className
}) => {
  return /* @__PURE__ */ React43.createElement(
    Box,
    {
      as: "span",
      className: "relative text-md",
      apply: clsx(className, disabled && "text-neutral-300")
    },
    children
  );
};
var Radio = {
  ...RadioForwarded,
  Group: RadioGroup
};

// src/components/Select/Select.tsx
import React45, { createContext as createContext10, useCallback as useCallback2, useContext as useContext10 } from "react";
import { forwardRef as forwardRef14, useMemo as useMemo9 } from "react";
import RSelect from "react-select";

// src/components/Tag/Tag.tsx
import React44, { createContext as createContext9, useContext as useContext9 } from "react";
var TagContext = createContext9(void 0);
function useTag() {
  return useContext9(TagContext);
}
var Tag = ({
  children,
  color = "primary",
  disabled,
  className,
  size = "md",
  ...otherProps
}) => {
  const sizeMap8 = {
    xs: "h-4.5",
    sm: "h-6",
    md: "h-7"
  };
  return /* @__PURE__ */ React44.createElement(TagContext.Provider, { value: { color, size, disabled } }, /* @__PURE__ */ React44.createElement(
    Box,
    {
      as: "span",
      className: clsx(
        "inline-flex rounded-full items-center space-x-1 px-2",
        disabled ? "bg-neutral-200 text-neutral-400" : `bg-${color}-200 text-neutral-600`,
        sizeMap8[size]
      ),
      "aria-disabled": disabled,
      apply: className,
      ...otherProps
    },
    children
  ));
};
var TagLabel = ({
  children,
  className,
  ...otherProps
}) => {
  return /* @__PURE__ */ React44.createElement(
    Box,
    {
      as: "span",
      className: "font-semibold text-xs",
      apply: className,
      ...otherProps
    },
    children
  );
};
var TagIcon = ({ as, ...otherProps }) => {
  return /* @__PURE__ */ React44.createElement(Icon, { as, size: "4.5", ...otherProps });
};
var TagCloseButton = ({
  onClick,
  className,
  ...otherProps
}) => {
  const { disabled } = useTag();
  return /* @__PURE__ */ React44.createElement(
    Box,
    {
      as: "button",
      type: "button",
      disabled,
      className: "appearance-none flex items-center rounded-full ml-2 overflow-hidden",
      apply: clsx(
        "hover:text-neutral-800",
        "disabled:text-neutral-400",
        className
      ),
      onClick,
      "aria-label": "Remove",
      "aria-disabled": disabled,
      ...otherProps
    },
    /* @__PURE__ */ React44.createElement(Icon, { as: MdOutlineClear, size: "4.5" })
  );
};
Tag.Label = TagLabel;
Tag.Icon = TagIcon;
Tag.CloseButton = TagCloseButton;

// src/components/Select/Select.tsx
var SelectContext = createContext10(void 0);
function useSelect() {
  return useContext10(SelectContext);
}
var MultiValue = (props) => {
  const { size } = useSelect();
  const sizeMap8 = {
    xs: "xs",
    sm: "sm",
    md: "sm",
    lg: "md"
  };
  return /* @__PURE__ */ React45.createElement(
    Tag,
    {
      color: "primary",
      size: sizeMap8[size],
      className: "mx-0.5 first:ml-0 last:mr-0 my-[2px]",
      disabled: props.isDisabled
    },
    /* @__PURE__ */ React45.createElement(Tag.Label, null, props.data.label),
    /* @__PURE__ */ React45.createElement(Tag.CloseButton, { onClick: props.removeProps.onClick })
  );
};
var DropdownIndicator = (props) => {
  const { size } = useSelect();
  const iconSizeMap6 = {
    xs: "4.5",
    sm: "4.5",
    md: "4.5",
    lg: "6"
  };
  const sizeClassNames = {
    xs: "pr-3 pl-2",
    sm: "pr-3 pl-2",
    md: "pr-3 pl-2",
    lg: "pr-3.5 pl-2.5"
  };
  return /* @__PURE__ */ React45.createElement(
    Box,
    {
      className: clsx(
        "h-full flex justify-center items-center",
        !props.isDisabled && "cursor-pointer",
        sizeClassNames[size]
      )
    },
    /* @__PURE__ */ React45.createElement(
      Icon,
      {
        as: props.selectProps.menuIsOpen ? MdOutlineExpandLess : MdOutlineExpandMore,
        "aria-hidden": "true",
        size: iconSizeMap6[size],
        className: clsx(
          "pointer-events-none",
          props.isDisabled ? "text-neutral-400" : "text-neutral-600"
        )
      }
    )
  );
};
var ClearIndicator = (props) => {
  const {
    innerProps: { ref, ...restInnerProps }
  } = props;
  const { size } = useSelect();
  const iconSizeMap6 = {
    xs: "4.5",
    sm: "4.5",
    md: "4.5",
    lg: "6"
  };
  return /* @__PURE__ */ React45.createElement(
    Box,
    {
      ...restInnerProps,
      ref,
      className: clsx(
        "h-full flex justify-center items-center px-1 mx-1",
        !props.isDisabled && "cursor-pointer"
      )
    },
    /* @__PURE__ */ React45.createElement(
      Icon,
      {
        onClick: props.clearValue,
        as: MdOutlineClear,
        size: iconSizeMap6[size],
        "aria-hidden": "true",
        className: clsx(
          props.isDisabled ? "text-neutral-400" : "text-neutral-600"
        )
      }
    )
  );
};
var Select = forwardRef14(function SelectHelper({
  size = "md",
  isInvalid: invalid,
  isMulti,
  disabled,
  valueAsObject = true,
  value: val,
  defaultValue: defaultVal,
  onChange,
  styles,
  components: components2,
  ...props
}, ref) {
  const { getProp: p } = useTheme();
  const formControl = useFormControl();
  const isInvalid = (formControl == null ? void 0 : formControl.isInvalid) || invalid;
  const isDisabled = (formControl == null ? void 0 : formControl.disabled) || disabled;
  const value = useMemo9(() => {
    var _a3;
    if (valueAsObject)
      return val;
    if (isMulti && val) {
      return (props == null ? void 0 : props.options).filter(
        (option) => val == null ? void 0 : val.includes(option == null ? void 0 : option.value)
      );
    }
    return (_a3 = props.options) == null ? void 0 : _a3.find(
      (option) => (option == null ? void 0 : option.value) === val
    );
  }, [props.options, val, isMulti, valueAsObject]);
  const defaultValue = useMemo9(() => {
    var _a3, _b2;
    if (valueAsObject)
      return defaultVal;
    if (isMulti && defaultVal) {
      return (_a3 = props == null ? void 0 : props.options) == null ? void 0 : _a3.filter(
        (option) => defaultVal == null ? void 0 : defaultVal.includes(option == null ? void 0 : option.value)
      );
    }
    return (_b2 = props.options) == null ? void 0 : _b2.find(
      (option) => (option == null ? void 0 : option.value) === defaultVal
    );
  }, [props.options, defaultVal, isMulti, valueAsObject]);
  const handleChange = useCallback2(
    (selected, metadata) => {
      if (valueAsObject)
        return onChange == null ? void 0 : onChange(selected, metadata);
      if (isMulti) {
        return onChange == null ? void 0 : onChange(
          selected == null ? void 0 : selected.map(
            (option) => option.value
          ),
          metadata
        );
      }
      return onChange == null ? void 0 : onChange(selected == null ? void 0 : selected.value, metadata);
    },
    [onChange, isMulti, valueAsObject]
  );
  const sizeStyles3 = useMemo9(
    () => ({
      xs: {
        height: p("height.8"),
        fontSize: p("fontSize.sm")
      },
      sm: {
        height: p("height.9"),
        fontSize: p("fontSize.sm")
      },
      md: {
        height: p("height.10"),
        fontSize: p("fontSize.md")
      },
      lg: {
        height: p("height.12"),
        fontSize: p("fontSize.md")
      }
    }),
    // eslint-disable-next-line
    []
  );
  const valueContainerSizeStyles = useMemo9(
    () => ({
      xs: {
        paddingLeft: `calc(${p("spacing.3")} - 2px)`,
        paddingRight: `calc(${p("spacing.3")} - 2px)`
      },
      sm: {
        paddingLeft: `calc(${p("spacing.4")} - 2px)`,
        paddingRight: `calc(${p("spacing.4")} - 2px)`
      },
      md: {
        paddingLeft: `calc(${p("spacing.4")} - 2px)`,
        paddingRight: `calc(${p("spacing.4")} - 2px)`
      },
      lg: {
        paddingLeft: `calc(${p("spacing.4")} - 2px)`,
        paddingRight: `calc(${p("spacing.4")} - 2px)`
      }
    }),
    // eslint-disable-next-line
    []
  );
  const selectStyles = {
    valueContainer: (styles2) => ({
      ...styles2,
      ...valueContainerSizeStyles[size]
    }),
    indicatorSeparator: () => ({ display: "none" }),
    placeholder: (styles2) => ({
      ...styles2,
      color: p("colors.neutral.400"),
      fontWeight: p("fontWeight.regular")
    }),
    singleValue: (styles2) => ({
      ...styles2,
      color: isDisabled ? p("colors.neutral.400") : p("colors.neutral.600"),
      fontWeight: isDisabled ? p("fontWeight.regular") : p("fontWeight.semibold")
    }),
    input: (styles2) => ({
      ...styles2,
      ...size === "xs" && {
        padding: 0,
        margin: 0
      },
      color: isDisabled ? p("colors.neutral.400") : p("colors.neutral.600")
    }),
    control: (styles2, state) => {
      let borderColor = p("colors.neutral.400");
      if (isInvalid)
        borderColor = p("colors.danger.600");
      if (state.isFocused && !isInvalid)
        borderColor = p("colors.primary.800");
      if (isDisabled)
        borderColor = p("colors.neutral.300");
      return {
        ...styles2,
        ...sizeStyles3[size],
        ...isMulti && {
          height: "auto"
        },
        minHeight: sizeStyles3[size].height,
        background: isDisabled ? p("colors.neutral.100") : p("colors.neutral.50"),
        borderWidth: 1,
        borderRadius: p("borderRadius.sm"),
        borderColor,
        boxShadow: "none",
        cursor: "text",
        ...state.isFocused && {
          borderWidth: 1.5
        },
        "&:hover": {
          boxShadow: p("boxShadow.sm")
        }
      };
    },
    menu: (styles2) => {
      return {
        ...styles2,
        borderRadius: p("borderRadius.sm"),
        boxShadow: p("boxShadow.sm"),
        marginTop: p("spacing.3"),
        background: p("colors.neutral.50")
      };
    },
    menuList: (styles2) => {
      return {
        ...styles2,
        paddingTop: p("spacing.[2.5]"),
        paddingBottom: p("spacing.[2.5]")
      };
    },
    option: (styles2, state) => {
      return {
        ...styles2,
        background: state.isFocused ? rgba(p("colors.primary.600"), 0.1) : p("colors.neutral.50"),
        color: state.isSelected ? p("colors.primary.700") : p("colors.neutral.700"),
        fontSize: sizeStyles3[size].fontSize,
        fontWeight: p("fontWeight.semibold"),
        cursor: "pointer",
        "&:hover": {
          background: rgba(p("colors.primary.600"), 0.1)
        },
        "&:active": {
          background: rgba(p("colors.primary.600"), 0.15)
        }
      };
    }
  };
  return /* @__PURE__ */ React45.createElement(SelectContext.Provider, { value: { size } }, /* @__PURE__ */ React45.createElement(
    RSelect,
    {
      isMulti,
      isDisabled,
      ref,
      styles: { ...selectStyles, ...styles },
      value,
      defaultValue,
      onChange: handleChange,
      components: {
        MultiValue,
        DropdownIndicator,
        ClearIndicator,
        ...components2
      },
      ...props
    }
  ));
});

// src/components/Switch/Switch.tsx
import React46, { forwardRef as forwardRef15 } from "react";
var Switch = forwardRef15(
  function SwitchHelper({ children, className, disabled, labelPosition = "right", ...otherProps }, ref) {
    return /* @__PURE__ */ React46.createElement(
      Box,
      {
        as: "label",
        className: "inline-flex items-center cursor-pointer",
        apply: clsx(className, disabled && "cursor-not-allowed")
      },
      children && labelPosition === "left" && /* @__PURE__ */ React46.createElement(LabelContainer3, { className: "mr-3", disabled }, children),
      /* @__PURE__ */ React46.createElement(Box, { as: "span", className: "relative flex h-5 items-center" }, /* @__PURE__ */ React46.createElement(
        Box,
        {
          as: "input",
          type: "checkbox",
          className: "sr-only peer",
          ref,
          disabled,
          ...otherProps
        }
      ), /* @__PURE__ */ React46.createElement(
        Box,
        {
          as: "span",
          className: `
              absolute
              top-1/2
              left-1/2
              -translate-x-1/2
              -translate-y-1/2
              h-10
              w-14
              border-2
              rounded-md

              opacity-0
              peer-focus-visible:opacity-100

              bg-neutral-600/20
              peer-checked:bg-primary-600/20

              border-neutral-800
              peer-checked:border-primary-800
            `
        }
      ), /* @__PURE__ */ React46.createElement(
        Box,
        {
          as: "span",
          className: "relative h-3.5 w-9 rounded-full",
          apply: "bg-neutral-600 peer-checked:bg-primary-300 peer-disabled:bg-neutral-300"
        }
      ), /* @__PURE__ */ React46.createElement(
        Box,
        {
          as: "span",
          className: `
              absolute
              h-5
              w-5
              top-1/2
              -translate-y-1/2
              transition-all
              left-0
            `,
          apply: `
              peer-checked:translate-x-4

              before:(
                absolute
                content-['']
                h-10
                w-10
                top-1/2
                left-1/2
                -translate-x-1/2
                -translate-y-1/2
                rounded-full
                transition-all

                bg-neutral-600/10
                peer-checked:bg-primary-600/10

                opacity-0
                peer-hover:opacity-100
                peer-disabled:opacity-0
              )

              after:(
                absolute
                content-['']
                h-full
                w-full
                top-0
                left-0
                rounded-full
                transition-all
                shadow-sm

                bg-neutral-50
                peer-checked:bg-primary-600
                peer-disabled:bg-neutral-300
              )
            `
        }
      )),
      children && labelPosition === "right" && /* @__PURE__ */ React46.createElement(LabelContainer3, { className: "ml-3", disabled }, children)
    );
  }
);
var LabelContainer3 = ({
  children,
  className,
  disabled
}) => /* @__PURE__ */ React46.createElement(
  Box,
  {
    as: "span",
    className,
    apply: clsx(disabled && "text-neutral-300")
  },
  children
);

// src/components/Text/Text.tsx
import React47, { forwardRef as forwardRef16 } from "react";
var Text = forwardRef16(
  function TextHelper(props, ref) {
    const {
      as = "p",
      size = "md",
      numberOfLines,
      className,
      ...otherProps
    } = props;
    return /* @__PURE__ */ React47.createElement(
      Box,
      {
        as,
        ref,
        className: clsx(
          `text-${size}`,
          numberOfLines && `line-clamp-${numberOfLines}`
        ),
        apply: clsx(className),
        ...otherProps
      }
    );
  }
);

// src/components/TextArea/TextArea.tsx
import React48, { forwardRef as forwardRef17 } from "react";
var sizeStyles = {
  xs: "px-3 py-1.5 text-sm",
  sm: "px-4 py-2 text-sm",
  md: "px-4 py-2.5 text-md",
  lg: "px-4 py-3 text-md"
};
var errorStyles = "border-danger-600 border-[1.5] focus-visible:border-danger-600 hover:border-danger-600";
var successStyles = "border-success-700 border-[1.5px] focus-visible:border-success-700 hover:border-success-700";
var TextArea = forwardRef17(
  function TextAreaHelper(props, ref) {
    const {
      variant = "bordered",
      isInvalid: invalid = false,
      isSuccess: success = false,
      size = "md",
      disabled = false,
      required = false,
      className,
      ...otherProps
    } = props;
    const formControl = useFormControl();
    const isInvalid = (formControl == null ? void 0 : formControl.isInvalid) || invalid;
    const isRequired = (formControl == null ? void 0 : formControl.required) || required;
    const isDisabled = (formControl == null ? void 0 : formControl.disabled) || disabled;
    const isSuccess = (formControl == null ? void 0 : formControl.isSuccess) || success;
    return /* @__PURE__ */ React48.createElement(
      Box,
      {
        as: "textarea",
        id: formControl == null ? void 0 : formControl.id,
        className: clsx(
          sizeStyles[size],
          `
            border
            border-neutral-600
            outline-none
            text-neutral-600
            rounded-sm
            w-full
            bg-neutral-50
            hover:shadow-sm
            placeholder:(
              text-neutral-400
              font-normal
            )

            focus-visible:(
              outline-none
              border-primary-800
              border-[1.5px]
            )

            disabled:(
              border-neutral-300
              shadow-none ring-0
              cursor-not-allowed
              text-neutral-400
              bg-neutral-100
            )
        `,
          variant === "unbordered" && "border border-transparent",
          "min-h-[45px]"
        ),
        apply: clsx(
          isInvalid && errorStyles,
          isSuccess && successStyles,
          className
        ),
        disabled: isDisabled,
        ref,
        required: isRequired,
        ...otherProps
      }
    );
  }
);

// src/components/Tooltip/Tooltip.tsx
import { AnimatePresence as AnimatePresence3 } from "framer-motion";
import React49, {
  isValidElement,
  useEffect as useEffect10,
  useLayoutEffect as useLayoutEffect6,
  useRef as useRef7,
  useState as useState10
} from "react";
import { createPortal as createPortal4 } from "react-dom";
var arrowPosition = {
  bottom: "before:top-[-5px] before:left-1/2 before:-translate-x-1/2 mt-0.5",
  top: "before:bottom-[-5px] before:left-1/2 before:-translate-x-1/2 mb-0.5",
  right: "before:left-[-5px] before:top-1/2 before:-translate-y-1/2 ml-0.5",
  left: "before:right-[-5px] before:top-1/2 before:-translate-y-1/2 mr-0.5 "
};
var animationOrigins2 = {
  bottom: "origin-top",
  top: "origin-bottom",
  right: "origin-left",
  left: "origin-right"
};
var Tooltip = ({
  children,
  classname,
  label,
  placement = "top",
  isOpen = false,
  disabled = false,
  shouldWrapChildren = false,
  onOpen,
  onClose
}) => {
  var _a3;
  const [showTooltip, setShowTooltip] = useState10(isOpen);
  const [referenceElement, setReferenceElement] = useState10(
    null
  );
  const [popperElement, setPopperElement] = useState10(null);
  const popper2 = usePopper(referenceElement, popperElement, {
    placement,
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 10]
        }
      }
    ]
  });
  const ref = useRef7(null);
  const [mounted, setMounted] = useState10(false);
  const firstUpdate = useRef7(true);
  useLayoutEffect6(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    if (!firstUpdate.current) {
      if (onOpen && showTooltip)
        onOpen();
      if (onClose && !showTooltip)
        onClose();
    }
  }, [showTooltip]);
  useEffect10(() => {
    var _a4;
    ref.current = (_a4 = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a4.querySelector("body");
    setMounted(true);
  }, []);
  useEffect10(() => {
    setShowTooltip(isOpen);
  }, [isOpen]);
  const currentPlacement = (_a3 = popper2.state) == null ? void 0 : _a3.placement;
  return /* @__PURE__ */ React49.createElement(React49.Fragment, null, shouldWrapChildren || !isValidElement(children) ? /* @__PURE__ */ React49.createElement(
    Box,
    {
      as: "span",
      ref: setReferenceElement,
      onPointerEnter: () => !disabled && setShowTooltip(true),
      onPointerLeave: () => setShowTooltip(false)
    },
    children
  ) : /* @__PURE__ */ React49.createElement(
    children.type,
    {
      ...children.props,
      ref: setReferenceElement,
      onPointerEnter: () => !disabled && setShowTooltip(true),
      onPointerLeave: () => setShowTooltip(false)
    }
  ), mounted && ref.current && createPortal4(
    /* @__PURE__ */ React49.createElement(AnimatePresence3, null, showTooltip && /* @__PURE__ */ React49.createElement(
      MotionBox,
      {
        ref: setPopperElement,
        style: popper2.styles.popper,
        className: "z-tooltip",
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: {
          duration: 0.1
        },
        ...popper2.attributes.popper
      },
      /* @__PURE__ */ React49.createElement(
        MotionBox,
        {
          className: `
                  relative
                  text-neutral-50
                  rounded-sm
                  text-sm
                  shadow-2xl
                  ${clsx(animationOrigins2[currentPlacement])}

                  before:absolute
                  before:content-['']
                  before:h-6
                  before:w-6
                  before:rotate-45
                  before:rounded-sm
                  before:bg-neutral-500
                  before:shadow-2xl
                  ${clsx(arrowPosition[currentPlacement])}
                `,
          apply: classname,
          initial: { scale: 0.8 },
          animate: { scale: 1 },
          exit: { scale: 0.8 },
          transition: { duration: 0.1 }
        },
        /* @__PURE__ */ React49.createElement(
          Box,
          {
            as: "span",
            className: "block relative bg-neutral-500 text-xs rounded-sm p-2.5"
          },
          label
        )
      )
    )),
    ref.current
  ));
};

// src/components/Upload/Upload.tsx
import React57, { forwardRef as forwardRef18, useState as useState11 } from "react";

// src/components/Upload/UploadContext.tsx
import React50 from "react";
var UploadContext = React50.createContext({
  variant: "vertical",
  active: false,
  disabled: false,
  setActive: () => void 0
});
var useUploadContext = () => {
  return React50.useContext(UploadContext);
};

// src/components/Upload/UploadDescription.tsx
import React51 from "react";
var UploadDescription = ({
  children,
  className,
  ...otherProps
}) => {
  const { variant, disabled } = useUploadContext();
  return /* @__PURE__ */ React51.createElement(
    Box,
    {
      className: clsx(
        "flex flex-col justify-center text-neutral-500",
        variant === "vertical" && "items-center",
        variant === "horizontal" && "items-start"
      ),
      apply: clsx(className, disabled && "text-neutral-400"),
      ...otherProps
    },
    children
  );
};

// src/components/Upload/UploadFormat.tsx
import React52 from "react";
var UploadFormat = ({
  children,
  className,
  ...otherProps
}) => {
  const { disabled } = useUploadContext();
  return /* @__PURE__ */ React52.createElement(
    Box,
    {
      as: "p",
      className: "text-xs text-neutral-500",
      apply: clsx(className, disabled && "text-neutral-400"),
      ...otherProps
    },
    children
  );
};

// src/components/Upload/UploadHighlight.tsx
import React53 from "react";
var UploadHighlight = ({
  children,
  className,
  ...otherProps
}) => {
  const { disabled } = useUploadContext();
  return /* @__PURE__ */ React53.createElement(
    Box,
    {
      as: "span",
      className: "text-primary-600",
      apply: clsx(className, disabled && "text-neutral-400"),
      ...otherProps
    },
    children
  );
};

// src/components/Upload/UploadImage.tsx
import React55 from "react";

// src/components/Upload/DefaultUploadIcon.tsx
import React54 from "react";
var DefaultUploadIcon = (props) => {
  const { className } = props;
  return /* @__PURE__ */ React54.createElement(
    Box,
    {
      className: "p-3 bg-neutral-100 rounded-sm text-neutral-400",
      apply: className
    },
    /* @__PURE__ */ React54.createElement(
      Box,
      {
        as: "svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ React54.createElement(
        "path",
        {
          d: "M14 11V14H2V11H0V14C0 15.1 0.9 16 2 16H14C15.1 16 16 15.1 16 14V11H14ZM3 5L4.41 6.41L7 3.83V12H9V3.83L11.59 6.41L13 5L8 0L3 5Z",
          fill: "currentColor"
        }
      )
    )
  );
};

// src/components/Upload/UploadImage.tsx
var UploadImage = ({
  children,
  className,
  ...otherProps
}) => {
  const { active, disabled } = useUploadContext();
  return /* @__PURE__ */ React55.createElement(Box, { apply: clsx(className), ...otherProps }, children || /* @__PURE__ */ React55.createElement(
    DefaultUploadIcon,
    {
      className: clsx(
        active && "text-primary-600 bg-primary-600/10",
        disabled && "text-neutral-400 bg-neutral-200"
      )
    }
  ));
};

// src/components/Upload/UploadLabel.tsx
import React56 from "react";
var UploadLabel = ({ className, ...otherProps }) => {
  return /* @__PURE__ */ React56.createElement(
    Text,
    {
      className: clsx("text-sm text-current text-inherit", className),
      ...otherProps
    }
  );
};

// src/components/Upload/Upload.tsx
var borderColorMap = {
  default: "colors.neutral.500",
  active: "colors.primary.600",
  disabled: "colors.neutral.300"
};
var UploadForwarded = forwardRef18(
  function UploadHelper({
    variant = "horizontal",
    children,
    className,
    disabled,
    onChange,
    ...otherProps
  }, ref) {
    const [active, setActive] = useState11(false);
    const { getProp } = useTheme();
    const handleDrag = function(e) {
      e == null ? void 0 : e.preventDefault();
      e == null ? void 0 : e.stopPropagation();
      const eventType = e == null ? void 0 : e.type;
      if (eventType === "dragenter" || eventType === "dragover") {
        setActive(true);
      } else if (eventType === "dragleave") {
        setActive(false);
      }
    };
    const handleDrop = function(e) {
      var _a3;
      e.preventDefault();
      e.stopPropagation();
      setActive(false);
      const files = (_a3 = e == null ? void 0 : e.dataTransfer) == null ? void 0 : _a3.files;
      if (files == null ? void 0 : files[0])
        handleFiles(files);
    };
    const handleOnChange = function(e) {
      var _a3;
      e == null ? void 0 : e.preventDefault();
      const files = (_a3 = e == null ? void 0 : e.target) == null ? void 0 : _a3.files;
      if (files == null ? void 0 : files[0])
        handleFiles(files);
    };
    const handleFiles = function(files) {
      onChange && onChange(files);
    };
    const colorProp = disabled ? "disabled" : active ? "active" : "default";
    const borderColor = getProp(borderColorMap[colorProp]).split("#").join("%23");
    return /* @__PURE__ */ React57.createElement(UploadContext.Provider, { value: { variant, active, disabled, setActive } }, /* @__PURE__ */ React57.createElement(
      Box,
      {
        as: "label",
        className: clsx(
          `
              inline-block 
              w-full 
              rounded-sm 
              cursor-pointer
              bg-neutral-50 
              bg-[url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='${borderColor}' stroke-width='2' stroke-dasharray='8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
              border-radius: 4px;]
          `,
          active && "border-primary-600 bg-primary-100"
        ),
        apply: clsx(
          className,
          disabled && "border-neutral-300 bg-neutral-100 cursor-not-allowed"
        ),
        onDragEnter: handleDrag,
        onDragLeave: handleDrag,
        onDrop: handleDrop,
        onDragOver: handleDrag
      },
      /* @__PURE__ */ React57.createElement(
        Box,
        {
          className: `
              flex 
              pointer-events-none
            `,
          apply: clsx(
            variant === "vertical" && "flex-col items-center justify-center px-6 pb-6 pt-8 gap-4.5",
            variant === "horizontal" && "flex-row items-center space-x-3 py-4 pl-3 pr-3.5"
          )
        },
        children
      ),
      /* @__PURE__ */ React57.createElement(
        Box,
        {
          as: "input",
          ref,
          type: "file",
          className: "hidden",
          disabled,
          onChange: handleOnChange,
          ...otherProps
        }
      )
    ));
  }
);
var Upload = {
  ...UploadForwarded,
  Image: UploadImage,
  Description: UploadDescription,
  Format: UploadFormat,
  Highlight: UploadHighlight,
  Label: UploadLabel
};

// src/components/UploadProgress/UploadProgress.tsx
import React69 from "react";

// src/components/UploadProgress/UploadProgressBar.tsx
import React59 from "react";

// src/components/UploadProgress/UploadProgressContext.tsx
import React58 from "react";
var UploadProgressContext = React58.createContext({
  state: "active",
  value: 0
});
var useUploadProgressContext = () => {
  return React58.useContext(UploadProgressContext);
};

// src/components/UploadProgress/UploadProgressBar.tsx
var UploadProgressBar = ({
  color,
  ...otherProps
}) => {
  const { state, value } = useUploadProgressContext();
  return /* @__PURE__ */ React59.createElement(
    ProgressBar,
    {
      color: state === "error" ? "danger" : color,
      value,
      ...otherProps
    }
  );
};

// src/components/UploadProgress/UploadProgressCancelBtn.tsx
import React60 from "react";
var UploadProgressCancelBtn = (props) => {
  return /* @__PURE__ */ React60.createElement(IconButton, { icon: /* @__PURE__ */ React60.createElement(MdClose, null), variant: "text", color: "neutral", ...props });
};

// src/components/UploadProgress/UploadProgressDoneMsg.tsx
import React61 from "react";
var UploadProgressDoneMsg = ({
  children,
  className
}) => {
  return /* @__PURE__ */ React61.createElement(Box, { as: "span", className: "text-neutral-500 text-xs", apply: className }, children);
};

// src/components/UploadProgress/UploadProgressErrorMsg.tsx
import React62 from "react";
var UploadProgressErrorMsg = ({
  children,
  className
}) => {
  return /* @__PURE__ */ React62.createElement(
    Box,
    {
      as: "span",
      className: "flex items-center gap-1 text-danger-600 text-xs",
      apply: className
    },
    /* @__PURE__ */ React62.createElement(Icon, { as: MdErrorOutline, size: "4.5" }),
    children
  );
};

// src/components/UploadProgress/UploadProgressIcons.tsx
import React63 from "react";
var FileIcon = (props) => {
  const { className } = props;
  return /* @__PURE__ */ React63.createElement(
    Box,
    {
      as: "svg",
      xmlns: "http://www.w3.org/2000/svg",
      width: "42",
      height: "50",
      fill: "none",
      className
    },
    /* @__PURE__ */ React63.createElement("g", { filter: "url(#a)" }, /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#F3F4F6",
        d: "m28.326 4 7.383 7.43.06 31.466c0 .602-.479 1.104-1.097 1.104H6.097A1.098 1.098 0 0 1 5 42.896V5.104C5 4.502 5.479 4 6.097 4h22.23Z"
      }
    ), /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#D1D5DB",
        d: "m28.297 4 7.472 7.473h-6.3a1.15 1.15 0 0 1-1.152-1.152V4h-.02Zm1.735 24.758H10.028c-.292 0-.548-.41-.548-.879 0-.469.256-.879.548-.879h20.004c.292 0 .547.41.547.88 0 .468-.255.878-.547.878Zm0-5H10.028c-.292 0-.548-.41-.548-.879 0-.469.256-.879.548-.879h20.004c.292 0 .547.41.547.88 0 .468-.255.878-.547.878Zm0 10H10.028c-.292 0-.548-.41-.548-.879 0-.469.256-.879.548-.879h20.004c.292 0 .547.41.547.88 0 .468-.255.878-.547.878Zm0 4.868H10.028c-.292 0-.548-.41-.548-.879 0-.469.256-.879.548-.879h20.004c.292 0 .547.41.547.88 0 .468-.255.878-.547.878Z"
      }
    )),
    /* @__PURE__ */ React63.createElement("defs", null, /* @__PURE__ */ React63.createElement(
      "filter",
      {
        id: "a",
        width: 40.77,
        height: 50,
        x: 0,
        y: 0,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React63.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
      /* @__PURE__ */ React63.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          result: "hardAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }
      ),
      /* @__PURE__ */ React63.createElement("feOffset", { dy: 1 }),
      /* @__PURE__ */ React63.createElement("feGaussianBlur", { stdDeviation: 2.5 }),
      /* @__PURE__ */ React63.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
      /* @__PURE__ */ React63.createElement("feColorMatrix", { values: "0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0.4 0" }),
      /* @__PURE__ */ React63.createElement(
        "feBlend",
        {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7333_11247"
        }
      ),
      /* @__PURE__ */ React63.createElement(
        "feBlend",
        {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_7333_11247",
          result: "shape"
        }
      )
    ))
  );
};
var PdfIcon = (props) => {
  const { className } = props;
  return /* @__PURE__ */ React63.createElement(
    Box,
    {
      as: "svg",
      xmlns: "http://www.w3.org/2000/svg",
      width: 42,
      height: 50,
      fill: "none",
      className,
      ...props
    },
    /* @__PURE__ */ React63.createElement("g", { filter: "url(#a)" }, /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#F3F4F6",
        d: "m28.846 4 7.383 7.43.06 31.466c0 .602-.48 1.104-1.098 1.104H6.617a1.098 1.098 0 0 1-1.097-1.104V5.104C5.52 4.502 5.998 4 6.617 4h22.229Z"
      }
    ), /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#D1D5DB",
        d: "m28.816 4 7.473 7.473h-6.301a1.15 1.15 0 0 1-1.151-1.152V4h-.02Zm1.735 24.758H10.548c-.293 0-.548-.41-.548-.879 0-.469.255-.879.547-.879h20.004c.292 0 .548.41.548.88 0 .468-.256.878-.548.878Zm0 5H10.548c-.293 0-.548-.41-.548-.879 0-.469.255-.879.547-.879h20.004c.292 0 .548.41.548.88 0 .468-.256.878-.548.878Zm0 4.868H10.548c-.293 0-.548-.41-.548-.879 0-.469.255-.879.547-.879h20.004c.292 0 .548.41.548.88 0 .468-.256.878-.548.878Z"
      }
    )),
    /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#A70707",
        d: "M2 11.706A.7.7 0 0 1 2.696 11h22.608a.7.7 0 0 1 .696.706v10.588a.7.7 0 0 1-.696.706H2.696A.7.7 0 0 1 2 22.294V11.706Z"
      }
    ),
    /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#FDFDFD",
        d: "M8.262 16.977h.398c.373 0 .651-.073.836-.22.185-.148.277-.363.277-.644 0-.284-.078-.493-.234-.629-.154-.135-.396-.203-.726-.203h-.551v1.696Zm2.734-.907c0 .615-.193 1.085-.578 1.41-.383.326-.928.489-1.637.489h-.52V20h-1.21v-5.71h1.824c.693 0 1.219.149 1.578.448.362.297.543.741.543 1.332Zm5.816 1.02c0 .94-.268 1.66-.804 2.16-.534.5-1.306.75-2.317.75h-1.617v-5.71h1.793c.932 0 1.656.245 2.172.737.516.493.773 1.18.773 2.063Zm-1.257.031c0-1.226-.542-1.84-1.625-1.84h-.645V19h.52c1.166 0 1.75-.626 1.75-1.879ZM19.188 20h-1.192v-5.71h3.274v.991h-2.082v1.473h1.937v.988h-1.938V20Z"
      }
    ),
    /* @__PURE__ */ React63.createElement("defs", null, /* @__PURE__ */ React63.createElement(
      "filter",
      {
        id: "a",
        width: 40.77,
        height: 50,
        x: 0.52,
        y: 0,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React63.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
      /* @__PURE__ */ React63.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          result: "hardAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }
      ),
      /* @__PURE__ */ React63.createElement("feOffset", { dy: 1 }),
      /* @__PURE__ */ React63.createElement("feGaussianBlur", { stdDeviation: 2.5 }),
      /* @__PURE__ */ React63.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
      /* @__PURE__ */ React63.createElement("feColorMatrix", { values: "0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0.4 0" }),
      /* @__PURE__ */ React63.createElement(
        "feBlend",
        {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7333_10817"
        }
      ),
      /* @__PURE__ */ React63.createElement(
        "feBlend",
        {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_7333_10817",
          result: "shape"
        }
      )
    ))
  );
};
var XlsIcon = (props) => {
  const { className } = props;
  return /* @__PURE__ */ React63.createElement(
    Box,
    {
      as: "svg",
      xmlns: "http://www.w3.org/2000/svg",
      width: 42,
      height: 50,
      fill: "none",
      className
    },
    /* @__PURE__ */ React63.createElement("g", { filter: "url(#a)" }, /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#F3F4F6",
        d: "m28.846 4 7.383 7.43.06 31.466c0 .602-.48 1.104-1.098 1.104H6.617a1.098 1.098 0 0 1-1.097-1.104V5.104C5.52 4.502 5.998 4 6.617 4h22.229Z"
      }
    ), /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#D1D5DB",
        d: "m28.816 4 7.473 7.473h-6.301a1.15 1.15 0 0 1-1.151-1.152V4h-.02Zm1.735 24.758H10.548c-.293 0-.548-.41-.548-.879 0-.469.255-.879.547-.879h20.004c.292 0 .548.41.548.88 0 .468-.256.878-.548.878Zm0 5H10.548c-.293 0-.548-.41-.548-.879 0-.469.255-.879.547-.879h20.004c.292 0 .548.41.548.88 0 .468-.256.878-.548.878Zm0 4.868H10.548c-.293 0-.548-.41-.548-.879 0-.469.255-.879.547-.879h20.004c.292 0 .548.41.548.88 0 .468-.256.878-.548.878Z"
      }
    )),
    /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#2A7B30",
        d: "M2 11.706A.7.7 0 0 1 2.696 11h22.608a.7.7 0 0 1 .696.706v10.588a.7.7 0 0 1-.696.706H2.696A.7.7 0 0 1 2 22.294V11.706Z"
      }
    ),
    /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#FDFDFD",
        d: "M12.703 20H11.32l-1.328-2.16L8.664 20H7.367l1.895-2.945-1.774-2.766h1.336l1.23 2.055 1.208-2.055h1.304l-1.793 2.832L12.703 20Zm.719 0v-5.71h1.21V19h2.317v1h-3.527Zm7.894-1.586c0 .516-.186.922-.558 1.219-.37.297-.886.445-1.547.445-.61 0-1.148-.114-1.617-.344V18.61c.385.172.71.293.976.364.268.07.513.105.735.105.265 0 .468-.05.61-.152.142-.102.214-.253.214-.453a.492.492 0 0 0-.094-.297 1.021 1.021 0 0 0-.277-.254 7.01 7.01 0 0 0-.738-.387c-.35-.164-.611-.322-.786-.473a1.774 1.774 0 0 1-.418-.527 1.505 1.505 0 0 1-.156-.703c0-.505.17-.902.512-1.191.344-.29.818-.434 1.422-.434.297 0 .58.035.847.105.271.07.554.17.848.297l-.39.942a5.648 5.648 0 0 0-.758-.262 2.408 2.408 0 0 0-.586-.074c-.23 0-.405.053-.528.16a.528.528 0 0 0-.183.418c0 .107.024.2.074.281.05.078.128.155.234.23.11.074.366.206.77.4.534.254.9.51 1.098.769.197.255.296.569.296.941Z"
      }
    ),
    /* @__PURE__ */ React63.createElement("defs", null, /* @__PURE__ */ React63.createElement(
      "filter",
      {
        id: "a",
        width: 40.77,
        height: 50,
        x: 0.52,
        y: 0,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React63.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
      /* @__PURE__ */ React63.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          result: "hardAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }
      ),
      /* @__PURE__ */ React63.createElement("feOffset", { dy: 1 }),
      /* @__PURE__ */ React63.createElement("feGaussianBlur", { stdDeviation: 2.5 }),
      /* @__PURE__ */ React63.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
      /* @__PURE__ */ React63.createElement("feColorMatrix", { values: "0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0.4 0" }),
      /* @__PURE__ */ React63.createElement(
        "feBlend",
        {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7333_10833"
        }
      ),
      /* @__PURE__ */ React63.createElement(
        "feBlend",
        {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_7333_10833",
          result: "shape"
        }
      )
    ))
  );
};
var DocIcon = (props) => {
  const { className } = props;
  return /* @__PURE__ */ React63.createElement(
    Box,
    {
      as: "svg",
      xmlns: "http://www.w3.org/2000/svg",
      width: "42",
      height: "50",
      fill: "none",
      className,
      ...props
    },
    /* @__PURE__ */ React63.createElement("g", { filter: "url(#a)" }, /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#F3F4F6",
        d: "m28.846 4 7.383 7.43.06 31.466c0 .602-.48 1.104-1.098 1.104H6.617a1.098 1.098 0 0 1-1.097-1.104V5.104C5.52 4.502 5.998 4 6.617 4h22.229Z"
      }
    ), /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#D1D5DB",
        d: "m28.816 4 7.473 7.473h-6.301a1.15 1.15 0 0 1-1.151-1.152V4h-.02Zm1.735 24.758H10.548c-.293 0-.548-.41-.548-.879 0-.469.255-.879.547-.879h20.004c.292 0 .548.41.548.88 0 .468-.256.878-.548.878Zm0 5H10.548c-.293 0-.548-.41-.548-.879 0-.469.255-.879.547-.879h20.004c.292 0 .548.41.548.88 0 .468-.256.878-.548.878Zm0 4.868H10.548c-.293 0-.548-.41-.548-.879 0-.469.255-.879.547-.879h20.004c.292 0 .548.41.548.88 0 .468-.256.878-.548.878Z"
      }
    )),
    /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#0654C6",
        d: "M2 11.706A.7.7 0 0 1 2.696 11h22.608a.7.7 0 0 1 .696.706v10.588a.7.7 0 0 1-.696.706H2.696A.7.7 0 0 1 2 22.294V11.706Z"
      }
    ),
    /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#FDFDFD",
        d: "M10.762 17.09c0 .94-.269 1.66-.805 2.16-.534.5-1.306.75-2.316.75H6.023v-5.71h1.793c.933 0 1.657.245 2.172.737.516.493.774 1.18.774 2.063Zm-1.258.031c0-1.226-.542-1.84-1.625-1.84h-.645V19h.52c1.167 0 1.75-.626 1.75-1.879Zm7.625.016c0 .945-.235 1.672-.703 2.18-.469.507-1.14.761-2.016.761-.875 0-1.547-.254-2.015-.762-.47-.507-.704-1.237-.704-2.187 0-.95.235-1.676.704-2.176.47-.502 1.145-.754 2.023-.754.878 0 1.548.253 2.012.758.466.505.699 1.232.699 2.18Zm-4.168 0c0 .638.121 1.118.363 1.441.242.323.604.485 1.086.485.966 0 1.45-.642 1.45-1.926 0-1.287-.481-1.93-1.442-1.93-.482 0-.845.163-1.09.488-.245.323-.367.804-.367 1.442Zm7.777-1.922c-.455 0-.808.172-1.058.515-.25.342-.375.818-.375 1.43 0 1.274.478 1.91 1.433 1.91.401 0 .887-.1 1.457-.3v1.015a4.046 4.046 0 0 1-1.57.293c-.83 0-1.466-.251-1.906-.754-.44-.505-.66-1.229-.66-2.172 0-.593.108-1.113.324-1.558.216-.448.526-.79.93-1.028.406-.24.881-.359 1.425-.359.555 0 1.112.134 1.672.402l-.39.985a6.453 6.453 0 0 0-.645-.266 1.923 1.923 0 0 0-.637-.113Z"
      }
    ),
    /* @__PURE__ */ React63.createElement("defs", null, /* @__PURE__ */ React63.createElement(
      "filter",
      {
        id: "a",
        width: 40.77,
        height: 50,
        x: 0.52,
        y: 0,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React63.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
      /* @__PURE__ */ React63.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          result: "hardAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }
      ),
      /* @__PURE__ */ React63.createElement("feOffset", { dy: 1 }),
      /* @__PURE__ */ React63.createElement("feGaussianBlur", { stdDeviation: 2.5 }),
      /* @__PURE__ */ React63.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
      /* @__PURE__ */ React63.createElement("feColorMatrix", { values: "0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0.4 0" }),
      /* @__PURE__ */ React63.createElement(
        "feBlend",
        {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7333_10849"
        }
      ),
      /* @__PURE__ */ React63.createElement(
        "feBlend",
        {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_7333_10849",
          result: "shape"
        }
      )
    ))
  );
};
var JpgIcon = (props) => {
  const { className } = props;
  return /* @__PURE__ */ React63.createElement(
    Box,
    {
      as: "svg",
      xmlns: "http://www.w3.org/2000/svg",
      width: 42,
      height: 50,
      fill: "none",
      className,
      ...props
    },
    /* @__PURE__ */ React63.createElement("g", { filter: "url(#a)" }, /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#F3F4F6",
        d: "m28.846 4 7.383 7.43.06 31.466c0 .602-.48 1.104-1.098 1.104H6.617a1.098 1.098 0 0 1-1.097-1.104V5.104C5.52 4.502 5.998 4 6.617 4h22.229Z"
      }
    ), /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#D1D5DB",
        d: "m28.816 4 7.473 7.473h-6.301a1.15 1.15 0 0 1-1.151-1.152V4h-.02Z"
      }
    )),
    /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#B47A37",
        d: "M2 11.706A.7.7 0 0 1 2.696 11h22.608a.7.7 0 0 1 .696.706v10.588a.7.7 0 0 1-.696.706H2.696A.7.7 0 0 1 2 22.294V11.706Z"
      }
    ),
    /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "#FDFDFD",
        d: "M7.387 21.68c-.274 0-.512-.029-.715-.086v-1.008c.208.052.398.078.57.078.266 0 .456-.083.57-.25.115-.164.172-.422.172-.773v-5.352h1.211v5.344c0 .666-.152 1.174-.457 1.523-.304.35-.755.524-1.351.524Zm4.457-4.703h.398c.373 0 .651-.073.836-.22.185-.148.277-.363.277-.644 0-.284-.078-.493-.234-.629-.154-.135-.396-.203-.726-.203h-.551v1.696Zm2.734-.907c0 .615-.193 1.085-.578 1.41-.383.326-.928.489-1.637.489h-.52V20h-1.21v-5.71h1.824c.693 0 1.219.149 1.578.448.362.297.543.741.543 1.332Zm3.246.723h2.266v2.96c-.367.12-.714.204-1.04.25a6.54 6.54 0 0 1-.991.075c-.862 0-1.521-.252-1.977-.758-.453-.508-.68-1.235-.68-2.183 0-.922.263-1.64.79-2.157.528-.515 1.26-.773 2.195-.773.586 0 1.15.117 1.695.352l-.402.968a2.874 2.874 0 0 0-1.301-.312c-.524 0-.943.176-1.258.527-.315.352-.473.824-.473 1.418 0 .62.127 1.094.38 1.422.255.326.624.488 1.109.488.252 0 .509-.026.77-.078v-1.191h-1.083v-1.008Z"
      }
    ),
    /* @__PURE__ */ React63.createElement(
      "path",
      {
        stroke: "#D1D5DB",
        strokeLinejoin: "round",
        strokeWidth: "1.5",
        d: "M13.8 38.776 19.193 32l3.003 3.801 1.156-1.421 4.05 4.82"
      }
    ),
    /* @__PURE__ */ React63.createElement(
      "circle",
      {
        cx: "24.999",
        cy: "31.2",
        r: "1.4",
        stroke: "#D1D5DB",
        strokeWidth: "1.2"
      }
    ),
    /* @__PURE__ */ React63.createElement(
      "rect",
      {
        width: "17.5",
        height: "11.9",
        x: "12.25",
        y: "27.25",
        stroke: "#D1D5DB",
        strokeLinejoin: "round",
        strokeWidth: "1.5",
        rx: "1.75"
      }
    ),
    /* @__PURE__ */ React63.createElement("defs", null, /* @__PURE__ */ React63.createElement(
      "filter",
      {
        id: "a",
        width: "40.77",
        height: "50",
        x: ".52",
        y: "0",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React63.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ React63.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          result: "hardAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }
      ),
      /* @__PURE__ */ React63.createElement("feOffset", { dy: "1" }),
      /* @__PURE__ */ React63.createElement("feGaussianBlur", { stdDeviation: "2.5" }),
      /* @__PURE__ */ React63.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
      /* @__PURE__ */ React63.createElement("feColorMatrix", { values: "0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0.4 0" }),
      /* @__PURE__ */ React63.createElement(
        "feBlend",
        {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_8631_56077"
        }
      ),
      /* @__PURE__ */ React63.createElement(
        "feBlend",
        {
          in: "SourceGraphic",
          in2: "effect1_dropShadow_8631_56077",
          result: "shape"
        }
      )
    ))
  );
};

// src/components/UploadProgress/UploadProgressImage.tsx
import React64 from "react";
var UploadProgressImage = ({
  children,
  ...otherProps
}) => {
  return /* @__PURE__ */ React64.createElement(Box, { as: "span", ...otherProps }, children || /* @__PURE__ */ React64.createElement(FileIcon, null));
};

// src/components/UploadProgress/UploadProgressLabel.tsx
import React65 from "react";
var UploadProgressLabel = ({
  children,
  className
}) => {
  const { state } = useUploadProgressContext();
  return /* @__PURE__ */ React65.createElement(
    Box,
    {
      as: "span",
      className: "text-neutral-700 text-sm",
      apply: clsx(className, state === "done" && "font-semibold")
    },
    children
  );
};

// src/components/UploadProgress/UploadProgressRetryBtn.tsx
import React66 from "react";
var UploadProgressRetryBtn = (props) => {
  return /* @__PURE__ */ React66.createElement(
    IconButton,
    {
      icon: /* @__PURE__ */ React66.createElement(MdRefresh, null),
      variant: "text",
      color: "neutral",
      ...props
    }
  );
};

// src/components/UploadProgress/UploadProgressSuccessMsg.tsx
import React67 from "react";
var UploadProgressSuccessMsg = ({ children, className }) => {
  return /* @__PURE__ */ React67.createElement(
    Box,
    {
      as: "span",
      className: "flex items-center gap-1 text-success-600 text-xs",
      apply: className
    },
    /* @__PURE__ */ React67.createElement(Icon, { as: MdCheckCircleOutline, size: "4.5" }),
    children
  );
};

// src/components/UploadProgress/UploadProgressValue.tsx
import React68 from "react";
var UploadProgressValue = ({
  className,
  ...otherProps
}) => {
  const { value } = useUploadProgressContext();
  return /* @__PURE__ */ React68.createElement(
    Box,
    {
      as: "span",
      className: "text-neutral-500 text-xs",
      apply: className,
      ...otherProps
    },
    value,
    "%"
  );
};

// src/components/UploadProgress/UploadProgress.tsx
var UploadProgress = ({
  className,
  children,
  state = "active",
  value = 0,
  customContent,
  ...otherProps
}) => {
  const childrens = {
    UploadProgressImage: null,
    ProgressBarLabel: null,
    UploadProgressBar: null,
    UploadProgressCancelBtn: null,
    UploadProgressRetryBtn: null,
    ProgressBarErrorMsg: null,
    ProgressBarSuccessMsg: null,
    UploadProgressDoneMsg: null,
    UploadProgressValue: null
  };
  React69.Children.forEach(children, (child) => {
    if (React69.isValidElement(child)) {
      if (child.type === UploadProgressImage) {
        childrens.UploadProgressImage = child;
      } else if (child.type === UploadProgressLabel) {
        childrens.ProgressBarLabel = child;
      } else if (child.type === UploadProgressBar) {
        childrens.UploadProgressBar = child;
      } else if (child.type === UploadProgressCancelBtn) {
        childrens.UploadProgressCancelBtn = child;
      } else if (child.type === UploadProgressRetryBtn) {
        childrens.UploadProgressRetryBtn = child;
      } else if (child.type === UploadProgressDoneMsg) {
        childrens.UploadProgressDoneMsg = child;
      } else if (child.type === UploadProgressErrorMsg) {
        childrens.ProgressBarErrorMsg = child;
      } else if (child.type === UploadProgressSuccessMsg) {
        childrens.ProgressBarSuccessMsg = child;
      } else if (child.type === UploadProgressValue) {
        childrens.UploadProgressValue = child;
      }
    }
  });
  return /* @__PURE__ */ React69.createElement(UploadProgressContext.Provider, { value: { state, value } }, /* @__PURE__ */ React69.createElement(
    Box,
    {
      as: "span",
      className: clsx(
        `
            inline-flex
            items-center
            gap-5
            p-4
            w-full
            h-[72px]
            border
            border-neutral-300
            rounded-sm
            bg-neutral-50
          `,
        state === "error" && "border-danger-600"
      ),
      apply: clsx(className),
      ...otherProps
    },
    childrens.UploadProgressImage,
    /* @__PURE__ */ React69.createElement(Box, { className: "flex flex-col flex-1 gap-1" }, childrens.ProgressBarLabel, state !== "done" && childrens.UploadProgressBar, state === "active" && childrens.UploadProgressValue, state === "done" && childrens.UploadProgressDoneMsg, state === "error" && childrens.ProgressBarErrorMsg, state === "success" && childrens.ProgressBarSuccessMsg),
    state === "error" && childrens.UploadProgressRetryBtn,
    state !== "error" && childrens.UploadProgressCancelBtn,
    customContent
  ));
};
UploadProgress.Image = UploadProgressImage;
UploadProgress.Bar = UploadProgressBar;
UploadProgress.DoneMsg = UploadProgressDoneMsg;
UploadProgress.CancelBtn = UploadProgressCancelBtn;
UploadProgress.RetryBtn = UploadProgressRetryBtn;
UploadProgress.Label = UploadProgressLabel;
UploadProgress.Value = UploadProgressValue;
UploadProgress.ErrorMsg = UploadProgressErrorMsg;
UploadProgress.SuccessMsg = UploadProgressSuccessMsg;
UploadProgress.FileIcon = FileIcon;
UploadProgress.DocIcon = DocIcon;
UploadProgress.JpgIcon = JpgIcon;
UploadProgress.PdfIcon = PdfIcon;
UploadProgress.XlsIcon = XlsIcon;

// src/components/Breadcrumb/Breadcrumb.tsx
import React72, { Children, useState as useState12 } from "react";

// src/components/Breadcrumb/BreadcrumbItem.tsx
import React70 from "react";

// src/components/Breadcrumb/BreadcrumbItemContext.ts
import { createContext as createContext11, useContext as useContext11 } from "react";
var BreadcrumbItemContext = createContext11(
  {}
);
var useBreadcrumbItemContext = () => useContext11(BreadcrumbItemContext);

// src/components/Breadcrumb/BreadcrumbItem.tsx
var BreadcrumbItem = ({
  className,
  children,
  isCurrentPage,
  ...otherProps
}) => {
  const isChildrenString = typeof children === "string";
  return /* @__PURE__ */ React70.createElement(BreadcrumbItemContext.Provider, { value: { isCurrentPage } }, /* @__PURE__ */ React70.createElement(
    Box,
    {
      as: "li",
      className: clsx(isCurrentPage && isChildrenString && "font-semibold"),
      apply: clsx(className),
      ...otherProps
    },
    children
  ));
};

// src/components/Breadcrumb/BreadcrumbLink.tsx
import React71, { forwardRef as forwardRef19 } from "react";
var BreadcrumbLink = forwardRef19(function BreadcrumbLinkHelper({ className, as: Element2, ...otherProps }, ref) {
  const { isCurrentPage } = useBreadcrumbItemContext();
  return /* @__PURE__ */ React71.createElement(
    Box,
    {
      as: isCurrentPage ? "span" : Element2 || Link,
      ref,
      className: clsx(
        `
          no-underline
          text-neutral-500
        `,
        isCurrentPage ? "text-neutral-800 font-semibold" : "hover:underline",
        className
      ),
      "aria-current": isCurrentPage ? "page" : void 0,
      ...otherProps
    }
  );
});

// src/components/Breadcrumb/Breadcrumb.tsx
var Breadcrumb = ({
  separator = "/",
  className,
  children,
  ...otherProps
}) => {
  const totalItems = Children.count(children);
  const maxItems = 4;
  const arrItems = Children.toArray(children);
  const [isExpanded, setIsExpanded] = useState12(false);
  const items = !isExpanded && totalItems > maxItems ? Children.toArray([
    arrItems[0],
    /* @__PURE__ */ React72.createElement("li", null, /* @__PURE__ */ React72.createElement(
      Link,
      {
        role: "button",
        className: "no-underline hover:underline text-neutral-500",
        onClick: () => setIsExpanded(true)
      },
      "..."
    )),
    arrItems[totalItems - 2],
    arrItems[totalItems - 1]
  ]) : arrItems;
  return /* @__PURE__ */ React72.createElement(Box, { as: "nav", "aria-label": "breadcrumb", apply: className, ...otherProps }, /* @__PURE__ */ React72.createElement(Box, { as: "ol", className: "list-none flex gap-3 text-neutral-500 text-xs" }, Children.map(items, (child, index) => {
    const isLastChildren = index === items.length - 1;
    if (isLastChildren)
      return child;
    return /* @__PURE__ */ React72.createElement(React72.Fragment, null, child, /* @__PURE__ */ React72.createElement("li", null, separator));
  })));
};
Breadcrumb.Item = BreadcrumbItem;
Breadcrumb.Link = BreadcrumbLink;

// src/components/Table/Table.tsx
import React88 from "react";

// src/components/Table/TableBody.tsx
import React73 from "react";
var TableBody = ({ ...otherProps }) => {
  return /* @__PURE__ */ React73.createElement(Box, { as: "tbody", ...otherProps });
};

// src/components/Table/TableCell.tsx
import React74 from "react";
var rowHeightClass = {
  sm: "10",
  md: "12",
  lg: "14",
  auto: ""
};
var TableCell = ({
  className,
  children,
  isNumeric,
  height = "md",
  ...otherProps
}) => {
  return /* @__PURE__ */ React74.createElement(
    Box,
    {
      as: "td",
      className: "px-4 text-sm text-left text-neutral-700",
      apply: clsx(className),
      ...otherProps
    },
    /* @__PURE__ */ React74.createElement(
      Box,
      {
        as: "span",
        className: clsx(
          "w-full inline-flex items-center",
          `min-h-${rowHeightClass[height ?? "md"]}`,
          isNumeric && "justify-end"
        )
      },
      children
    )
  );
};

// src/components/Table/TableCheckbox.tsx
import React75 from "react";
var TableCheckbox = (props) => {
  return /* @__PURE__ */ React75.createElement(Checkbox, { ...props });
};

// src/components/Table/TableContainer.tsx
import React76, { useState as useState13 } from "react";

// src/components/Table/TableContext.tsx
import { createContext as createContext12, useContext as useContext12 } from "react";
var TableContext = createContext12({
  setSortBy: () => null
});
var useTableContext = () => useContext12(TableContext);

// src/components/Table/TableContainer.tsx
var TableContainer = ({
  page,
  totalPages,
  totalRows,
  rowsPerPage,
  className,
  variant = "outline",
  isLoading,
  onChangeRowsPerPage,
  onNextPage,
  onPreviousPage,
  width = "full",
  ...otherProps
}) => {
  const [sortBy, setSortBy] = useState13(null);
  return /* @__PURE__ */ React76.createElement(
    TableContext.Provider,
    {
      value: {
        page,
        totalRows,
        totalPages,
        rowsPerPage,
        isLoading,
        onChangeRowsPerPage,
        onNextPage,
        onPreviousPage,
        sortBy,
        setSortBy
      }
    },
    /* @__PURE__ */ React76.createElement(
      Box,
      {
        className: clsx(
          "relative overflow-x-auto rounded-sm border border-neutral-200",
          width === "fit" && "w-fit",
          variant === "elevated" && "shadow-xs",
          isLoading && "cursor-wait"
        ),
        apply: clsx(className),
        ...otherProps
      }
    )
  );
};

// src/components/Table/TableCounter.tsx
import React77 from "react";
var TableCounter = ({
  className,
  children,
  ...otherProps
}) => {
  const { page = 1, rowsPerPage = 0, totalRows = 0 } = useTableContext();
  const prevPage = page - 1;
  return /* @__PURE__ */ React77.createElement(
    Box,
    {
      className: "flex items-center text-sm text-neutral-700",
      apply: className,
      ...otherProps
    },
    children == null ? void 0 : children({
      from: rowsPerPage * prevPage + 1,
      to: rowsPerPage * page,
      total: totalRows
    })
  );
};

// src/components/Table/TableFoot.tsx
import React78 from "react";
var TableFoot = ({ ...otherProps }) => {
  return /* @__PURE__ */ React78.createElement(Box, { as: "tfoot", ...otherProps });
};

// src/components/Table/TableFooter.tsx
import React79 from "react";
var TableFooter = ({
  className,
  ...otherProps
}) => {
  const { isLoading } = useTableContext();
  return /* @__PURE__ */ React79.createElement(
    Box,
    {
      className: "flex items-center justify-between border-t border-neutral-200 min-h-14 px-5",
      apply: clsx(className, isLoading && "opacity-50 pointer-events-none"),
      ...otherProps
    }
  );
};

// src/components/Table/TableHead.tsx
import React80 from "react";

// src/components/Table/TableHeadContext.tsx
import { createContext as createContext13, useContext as useContext13 } from "react";
var TableHeadContext = createContext13({
  inHead: true
});

// src/components/Table/TableHead.tsx
var TableHead = ({
  className,
  children,
  ...otherProps
}) => {
  return /* @__PURE__ */ React80.createElement(
    Box,
    {
      as: "thead",
      className: "bg-neutral-100",
      apply: className,
      ...otherProps
    },
    /* @__PURE__ */ React80.createElement(TableHeadContext.Provider, { value: { inHead: true } }, children)
  );
};

// src/components/Table/TableHeader.tsx
import React82 from "react";

// src/components/Table/TableIcons.tsx
import React81 from "react";
var AscSortIcon = ({ className }) => {
  return /* @__PURE__ */ React81.createElement(
    Box,
    {
      className,
      as: "svg",
      xmlns: "http://www.w3.org/2000/svg",
      height: "24px",
      viewBox: "0 0 24 24",
      width: "24px",
      fill: "inherit",
      role: "img"
    },
    /* @__PURE__ */ React81.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" }),
    /* @__PURE__ */ React81.createElement("path", { d: "M7 14l5-5 5 5H7z" })
  );
};
var DescSortIcon = ({ className }) => {
  return /* @__PURE__ */ React81.createElement(
    Box,
    {
      className,
      as: "svg",
      xmlns: "http://www.w3.org/2000/svg",
      height: "24px",
      viewBox: "0 0 24 24",
      width: "24px",
      fill: "inherit",
      role: "img"
    },
    /* @__PURE__ */ React81.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" }),
    /* @__PURE__ */ React81.createElement("path", { d: "M7 10l5 5 5-5H7z" })
  );
};

// src/components/Table/TableHeader.tsx
var TableHeader = ({
  sorteable,
  children,
  className,
  onSort,
  rowid,
  height = "md",
  ...otherProps
}) => {
  const { sortBy: sortContext, setSortBy } = useTableContext();
  const sortBy = (sortContext == null ? void 0 : sortContext.id) === rowid ? sortContext == null ? void 0 : sortContext.type : null;
  const handleOnSort = () => {
    const newType = sortBy === "ascending" ? "descending" : "ascending";
    if (rowid === null || rowid === void 0)
      setSortBy(null);
    else
      setSortBy({ id: rowid, type: newType });
    onSort == null ? void 0 : onSort(newType);
  };
  return /* @__PURE__ */ React82.createElement(
    Box,
    {
      as: "th",
      className: clsx("px-4 font-semibold"),
      apply: clsx(className),
      ...otherProps
    },
    /* @__PURE__ */ React82.createElement(
      Box,
      {
        as: "span",
        className: clsx(
          "flex justify-between gap-x-2 items-center",
          `min-h-${rowHeightClass[height ?? "md"]}`
        )
      },
      children,
      sorteable && /* @__PURE__ */ React82.createElement(
        IconButton,
        {
          icon: sortBy ? SortIconMap[sortBy] : SortIconMap.indeterminated,
          "aria-sort": sortBy ? sortBy : "none",
          "aria-label": "Sort rows",
          "aria-controls": "table",
          size: "sm",
          color: sortBy ? "primary" : "neutral",
          variant: "text",
          onClick: handleOnSort
        }
      )
    )
  );
};
var SortIconMap = {
  ascending: /* @__PURE__ */ React82.createElement(AscSortIcon, null),
  descending: /* @__PURE__ */ React82.createElement(DescSortIcon, null),
  indeterminated: /* @__PURE__ */ React82.createElement(DescSortIcon, null)
};

// src/components/Table/TablePagination.tsx
import React83 from "react";
var TablePagination = ({
  children,
  className,
  ...otherProps
}) => {
  return /* @__PURE__ */ React83.createElement(
    Box,
    {
      className: "flex justify-center items-align gap-5",
      apply: className,
      ...otherProps
    },
    children
  );
};

// src/components/Table/TablePaginator.tsx
import React84 from "react";
var TablePaginator = (props) => {
  const { onNextPage, onPreviousPage, totalPages, page, totalRows } = useTableContext();
  const disabledLeftBtn = page === 1;
  const disabledRightBtn = typeof totalPages === "number" ? page === totalPages : false;
  return /* @__PURE__ */ React84.createElement(Box, { as: "span", ...props }, /* @__PURE__ */ React84.createElement(
    IconButton,
    {
      variant: "text",
      color: "neutral",
      icon: /* @__PURE__ */ React84.createElement(MdChevronLeft, null),
      onClick: () => {
        if (!page)
          return onPreviousPage == null ? void 0 : onPreviousPage({
            page,
            totalPages,
            totalRows
          });
        onPreviousPage == null ? void 0 : onPreviousPage({
          page,
          totalPages,
          totalRows,
          previousPage: page - 1
        });
      },
      disabled: disabledLeftBtn
    }
  ), /* @__PURE__ */ React84.createElement(
    IconButton,
    {
      variant: "text",
      color: "neutral",
      icon: /* @__PURE__ */ React84.createElement(MdChevronRight, null),
      onClick: () => {
        if (!page || !totalPages)
          return onNextPage == null ? void 0 : onNextPage({
            page,
            totalPages,
            totalRows
          });
        onNextPage == null ? void 0 : onNextPage({
          page,
          totalPages,
          totalRows,
          nextPage: page + 1
        });
      },
      disabled: disabledRightBtn
    }
  ));
};

// src/components/Table/TableRow.tsx
import React85 from "react";
var TableRow = ({
  className,
  children,
  ...otherProps
}) => {
  return /* @__PURE__ */ React85.createElement(
    Box,
    {
      as: "tr",
      className: clsx(
        "border-b border-neutral-200 last:border-b-0 text-sm text-left"
      ),
      apply: className,
      ...otherProps
    },
    React85.Children.map(children, (child, index) => {
      if (React85.isValidElement(child)) {
        return React85.cloneElement(child, {
          rowid: index
        });
      }
      return child;
    })
  );
};

// src/components/Table/TableRowsPerPageSelect.tsx
import React86 from "react";
var DEFAULT_OPTS = ["5", "10", "20", "50", "100"];
var TableRowsPerPageSelect = ({
  className,
  options = DEFAULT_OPTS,
  label,
  ...otherProps
}) => {
  const { rowsPerPage, onChangeRowsPerPage } = useTableContext();
  const handleOnChange = (opt) => {
    onChangeRowsPerPage == null ? void 0 : onChangeRowsPerPage(opt.value);
  };
  const opts = options.map((opt) => ({ value: opt, label: opt }));
  return /* @__PURE__ */ React86.createElement(
    Box,
    {
      as: "span",
      className: "inline-flex items-center gap-2.5 text-sm text-neutral-700",
      apply: clsx(className),
      ...otherProps
    },
    label,
    /* @__PURE__ */ React86.createElement(
      Select,
      {
        menuPosition: "fixed",
        size: "xs",
        options: opts,
        onChange: (a) => handleOnChange(a),
        value: { value: rowsPerPage, label: rowsPerPage }
      }
    )
  );
};

// src/components/Table/TableTitle.tsx
import React87 from "react";
var TableTitle = ({ className, ...otherProps }) => {
  return /* @__PURE__ */ React87.createElement(
    Box,
    {
      className: "block text-xl font-semibold text-neutral-900 p-5",
      apply: clsx(className),
      ...otherProps
    }
  );
};

// src/components/Table/Table.tsx
var Table = ({ className, ...otherProps }) => {
  const { isLoading } = useTableContext();
  return /* @__PURE__ */ React88.createElement(
    Box,
    {
      as: "table",
      className: "w-full",
      apply: clsx(className, isLoading && "opacity-50 pointer-events-none"),
      ...otherProps
    }
  );
};
Table.Container = TableContainer;
Table.Title = TableTitle;
Table.Head = TableHead;
Table.Header = TableHeader;
Table.Body = TableBody;
Table.Foot = TableFoot;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.RowsPerPageSelect = TableRowsPerPageSelect;
Table.Checkbox = TableCheckbox;
Table.Pagination = TablePagination;
Table.Paginator = TablePaginator;
Table.Footer = TableFooter;
Table.Counter = TableCounter;

// src/components/Tabs/Tabs.tsx
import React89, { createContext as createContext14, useContext as useContext14, useState as useState14 } from "react";
var TabsContext = createContext14(void 0);
function useTabs() {
  return useContext14(TabsContext);
}
var Tabs = ({
  index,
  defaultIndex,
  children,
  className,
  ...props
}) => {
  const [idx, setIdx] = useState14(defaultIndex ?? 0);
  const indexFormatted = index ?? idx;
  const onChange = (i) => {
    var _a3;
    if (isNaN(Number(index)))
      setIdx(i);
    (_a3 = props == null ? void 0 : props.onChange) == null ? void 0 : _a3.call(props, i);
  };
  return /* @__PURE__ */ React89.createElement(TabsContext.Provider, { value: { onChange, index: indexFormatted } }, /* @__PURE__ */ React89.createElement(Box, { className: clsx("block", className), ...props }, children));
};
var TabList = ({ children, className }) => {
  if (!children)
    return null;
  const items = Array.isArray(children) ? children : [children];
  return /* @__PURE__ */ React89.createElement(Box, { className: "flex", apply: className }, items.map((item, index) => /* @__PURE__ */ React89.createElement(item.type, { key: index, index, ...item.props })));
};
var Tab = ({ children, index }) => {
  const tabs = useTabs();
  const isActive = (tabs == null ? void 0 : tabs.index) === index;
  const handleClick = () => {
    var _a3;
    if (index === void 0)
      return;
    (_a3 = tabs == null ? void 0 : tabs.onChange) == null ? void 0 : _a3.call(tabs, index);
  };
  return /* @__PURE__ */ React89.createElement(
    Box,
    {
      as: "button",
      type: "button",
      role: "tab",
      "aria-selected": isActive,
      className: "bg-neutral-50 rounded-t-sm p-2 border-b-2 border-transparent text-sm text-neutral-600 min-h-12 min-w-28 flex flex-col items-center justify-center",
      apply: clsx(
        isActive && "border-primary-700 text-primary-700 font-semibold"
      ),
      onClick: handleClick
    },
    children
  );
};
var TabPanels = ({ children, className }) => {
  if (!children)
    return null;
  const items = Array.isArray(children) ? children : [children];
  return /* @__PURE__ */ React89.createElement(Box, { className: "w-full", apply: className }, items.map((item, index) => /* @__PURE__ */ React89.createElement(item.type, { key: index, index, ...item.props })));
};
var TabPanel = ({
  children,
  className,
  index
}) => {
  const tabs = useTabs();
  const isHidden = index !== (tabs == null ? void 0 : tabs.index);
  return /* @__PURE__ */ React89.createElement(
    Box,
    {
      className: clsx("p-4", isHidden && "hidden"),
      hidden: isHidden,
      apply: className,
      role: "tabpanel"
    },
    children
  );
};
Tabs.List = TabList;
Tabs.Tab = Tab;
Tabs.Panels = TabPanels;
Tabs.Panel = TabPanel;

// src/components/Pagination/Pagination.tsx
import React90 from "react";
import ReactPaginate from "react-paginate";
var Pagination = ({
  className,
  pageLinkClassName,
  previousLinkClassName,
  nextLinkClassName,
  breakLinkClassName,
  activeLinkClassName,
  variant = "outline",
  ...otherProps
}) => {
  const tw = useTw();
  const baseButtonStyles = clsx(
    "inline-flex justify-center items-center border border-solid border-transparent bg-transparent rounded-sm whitespace-nowrap font-semibold rounded-full w-7.5 h-7.5",
    "focus:outline-none focus-visible:outline-none"
  );
  const variantMap2 = {
    outline: clsx(
      `border-neutral-600 text-neutral-600`,
      `hover:(border-neutral-700 text-neutral-700 bg-neutral-600/10)`,
      `active:(border-neutral-800 text-neutral-800 bg-neutral-600/15)`,
      `focus-visible:(border-neutral-800 text-neutral-800 bg-neutral-600/20 ring-[1.5px] ring-offset-2 ring-neutral-800/100)`,
      "disabled:(bg-transparent border-neutral-300 text-neutral-400 cursor-not-allowed)"
    ),
    text: clsx(
      `text-neutral-600`,
      `hover:(text-neutral-700 bg-neutral-600/10)`,
      `active:(text-neutral-800 bg-neutral-600/15)`,
      `focus-visible:(text-neutral-800 bg-neutral-600/20 ring-[1.5px] ring-offset-2 ring-neutral-800/100)`,
      "disabled:(bg-transparent text-neutral-400 cursor-not-allowed)"
    )
  };
  const activeStyles = clsx(
    `border-primary-600 bg-primary-600 text-neutral-50`,
    `hover:(border-primary-700 bg-primary-700)`,
    `active:(border-primary-800 bg-primary-800)`,
    `focus-visible:(border-primary-800 bg-primary-800 ring-[1.5px] ring-offset-2 ring-primary-800/100)`,
    "disabled:(border-neutral-100 bg-neutral-100 text-neutral-400 cursor-not-allowed)"
  );
  const applyStyles2 = (base, apply) => {
    if (!apply)
      return tw(base);
    return tw(`@(${clsx(base, apply)})`);
  };
  return /* @__PURE__ */ React90.createElement(
    Box,
    {
      as: ReactPaginate,
      previousLabel: /* @__PURE__ */ React90.createElement(Icon, { as: MdChevronLeft }),
      nextLabel: /* @__PURE__ */ React90.createElement(Icon, { as: MdChevronRight }),
      className: "flex space-x-2 text-xs",
      apply: className,
      pageLinkClassName: applyStyles2(
        baseButtonStyles,
        clsx(variantMap2[variant], pageLinkClassName)
      ),
      previousLinkClassName: applyStyles2(
        baseButtonStyles,
        clsx(variantMap2[variant], previousLinkClassName)
      ),
      nextLinkClassName: applyStyles2(
        baseButtonStyles,
        clsx(variantMap2[variant], nextLinkClassName)
      ),
      breakLinkClassName: applyStyles2(
        baseButtonStyles,
        clsx(variantMap2[variant], breakLinkClassName)
      ),
      activeLinkClassName: applyStyles2(
        baseButtonStyles,
        clsx(`!(${activeStyles})`, activeLinkClassName)
      ),
      ...otherProps
    }
  );
};

// src/components/Editable/Editable.tsx
import React91 from "react";
var textSizeMap = {
  xs: "sm",
  sm: "sm",
  md: "md",
  lg: "md"
};
var Editable = ({
  className,
  containerClassName,
  value,
  defaultValue,
  size = "md",
  isDisabled,
  onChange
}) => {
  const [hasFocus, setHasFocus] = React91.useState(false);
  const prevValue = React91.useRef(value);
  const handleFocus = () => {
    prevValue.current = value;
    setHasFocus(true);
  };
  const handleBlur = () => {
    setHasFocus(false);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter")
      handleBlur();
    if (e.key === "Escape") {
      onChange == null ? void 0 : onChange({
        target: { value: prevValue.current }
      });
      handleBlur();
    }
  };
  return /* @__PURE__ */ React91.createElement(Box, { className: "inline-block w-full", apply: containerClassName }, hasFocus ? /* @__PURE__ */ React91.createElement(
    Input,
    {
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      autoFocus: true,
      value,
      size,
      onChange,
      defaultValue,
      disabled: isDisabled,
      className
    }
  ) : /* @__PURE__ */ React91.createElement(
    Text,
    {
      onClick: handleFocus,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      tabIndex: 0,
      size: textSizeMap[size],
      className: clsx("min-h-8", className)
    },
    value === void 0 ? defaultValue : value
  ));
};

// src/components/List/ListIcon.tsx
import React92 from "react";

// src/components/List/ListContext.tsx
import { createContext as createContext15, useContext as useContext15 } from "react";
var ListContext = createContext15({
  size: "md"
});
var useListContext = () => useContext15(ListContext);

// src/components/List/ListIcon.tsx
var iconSizeMap4 = {
  xs: "4.5",
  sm: "4.5",
  md: "4.5",
  lg: "6"
};
var ListIcon = ({
  className,
  ...otherProps
}) => {
  const { size } = useListContext();
  return /* @__PURE__ */ React92.createElement(
    Icon,
    {
      className: clsx("text-primary-600", className),
      size: iconSizeMap4[size],
      ...otherProps
    }
  );
};

// src/components/List/ListItem.tsx
import React93 from "react";
var orderedPaddingMap = {
  xs: "[3px]",
  sm: "1",
  md: "[5px]",
  lg: "[5px]"
};
var unorderedPaddingMap = {
  xs: "[5px]",
  sm: "[7px]",
  md: "[9px]",
  lg: "[11px]"
};
var ListItem = ({
  className,
  children,
  index
}) => {
  const { variant, size } = useListContext();
  return /* @__PURE__ */ React93.createElement(
    Box,
    {
      as: "li",
      className: clsx(
        variant === "ordered" && `list-["${index}."] pl-${orderedPaddingMap[size]}`,
        variant === "unordered" && `list-["\u2022"] pl-${unorderedPaddingMap[size]}`,
        variant === "unstyled" && `flex items-center gap-x-0.5`
      ),
      apply: className
    },
    children
  );
};

// src/components/List/OrderedList.tsx
import React94 from "react";

// src/components/List/shared.ts
var listBaseClassName = "text-neutral-600";
var sizeMap7 = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-md",
  lg: "text-lg"
};

// src/components/List/OrderedList.tsx
var OrderedList = ({
  size = "md",
  children,
  className,
  ...otherProps
}) => {
  return /* @__PURE__ */ React94.createElement(
    ListContext.Provider,
    {
      value: {
        variant: "ordered",
        size
      }
    },
    /* @__PURE__ */ React94.createElement(
      Box,
      {
        as: "ul",
        className: clsx(listBaseClassName, sizeMap7[size]),
        apply: className,
        ...otherProps
      },
      React94.Children.map(children, (child, index) => {
        return React94.cloneElement(child, {
          index: index + 1
        });
      })
    )
  );
};

// src/components/List/UnorderedList.tsx
import React95 from "react";
var UnorderedList = ({
  size = "md",
  className,
  children,
  ...otherProps
}) => {
  return /* @__PURE__ */ React95.createElement(
    ListContext.Provider,
    {
      value: {
        variant: "unordered",
        size
      }
    },
    /* @__PURE__ */ React95.createElement(
      Box,
      {
        as: "ul",
        className: clsx(listBaseClassName, sizeMap7[size]),
        apply: className,
        ...otherProps
      },
      children
    )
  );
};

// src/components/List/UnstyledList.tsx
import React96 from "react";
var UnstyledList = ({
  size = "md",
  children,
  className,
  ...otherProps
}) => {
  return /* @__PURE__ */ React96.createElement(
    ListContext.Provider,
    {
      value: {
        variant: "unstyled",
        size
      }
    },
    /* @__PURE__ */ React96.createElement(
      Box,
      {
        as: "ul",
        className: clsx(listBaseClassName, sizeMap7[size]),
        apply: className,
        ...otherProps
      },
      children
    )
  );
};

// src/components/List/List.ts
var List = {
  Ordered: OrderedList,
  Unordered: UnorderedList,
  Unstyled: UnstyledList,
  Item: ListItem,
  Icon: ListIcon
};

// src/components/Placeholder/Placeholder.tsx
import React103 from "react";

// src/components/Placeholder/PlaceholderBtnGroup.tsx
import React97 from "react";

// src/components/Placeholder/PlaceholderContext.ts
import { createContext as createContext16, useContext as useContext16 } from "react";
var PlaceholderContext = createContext16({
  variant: "vertical"
});
var usePlaceholderContext = () => {
  return useContext16(PlaceholderContext);
};

// src/components/Placeholder/PlaceholderBtnGroup.tsx
var PlaceholderBtnGroup = ({
  className,
  children,
  ...otherProps
}) => {
  const { variant } = usePlaceholderContext();
  return /* @__PURE__ */ React97.createElement(
    Box,
    {
      as: "span",
      className: clsx(
        "flex gap-3.5",
        variant === "horizontal" && "flex-col ml-4"
      ),
      apply: clsx(className),
      ...otherProps
    },
    children
  );
};

// src/components/Placeholder/PlaceholderContent.tsx
import React98 from "react";
var PlaceholderContent = ({
  className,
  children,
  ...otherProps
}) => {
  const { variant } = usePlaceholderContext();
  return /* @__PURE__ */ React98.createElement(
    Box,
    {
      as: "span",
      className: clsx(
        "flex flex-col justify-center gap-2",
        variant === "horizontal" ? "flex-1" : "w-full",
        variant === "vertical" && "items-center"
      ),
      apply: clsx(className),
      ...otherProps
    },
    children
  );
};

// src/components/Placeholder/PlaceholderDescription.tsx
import React99 from "react";
var PlaceholderDescription = ({
  className,
  children,
  ...otherProps
}) => {
  const { variant } = usePlaceholderContext();
  const isChildrenString = typeof children === "string";
  if (isChildrenString) {
    return /* @__PURE__ */ React99.createElement(
      Text,
      {
        className: clsx(
          "text-sm text-neutral-600",
          variant === "vertical" && "text-center",
          className
        ),
        ...otherProps
      },
      children
    );
  }
  return /* @__PURE__ */ React99.createElement(Box, { as: "span", apply: clsx(className), ...otherProps }, children);
};

// src/components/Placeholder/PlaceholderImage.tsx
import React101 from "react";

// src/components/Placeholder/PlaceholderIcons.tsx
import React100 from "react";
var Empty = ({
  width = "152",
  height = "100",
  ...otherProps
}) => /* @__PURE__ */ React100.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 152 100",
    fill: "none",
    ...otherProps
  },
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#6B7280",
      fillRule: "evenodd",
      d: "M46.273 1.621a6 6 0 0 0-6 6v7.641h5.457V9.078a2 2 0 0 1 2-2h30.103a2 2 0 0 1 2 2v6.184h5.456v-7.64a6 6 0 0 0-6-6H46.273Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#E5E7EB",
      d: "M121.878 88.454a8 8 0 0 1-8 7.973H10.079a8 8 0 0 1-8-8V23.262a8 8 0 0 1 8-8h104.015a8 8 0 0 1 8 8.027l-.216 65.165Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      stroke: "#9CA3AF",
      strokeDasharray: "4 4",
      d: "M59.521 39.516c-1.285-5.924-3.855-15.638 5.958-21.325 10.332-5.987 19.275 1.777 19.275 7.82 0 4.264-1.752 4.975-4.556 4.975-2.102 0-3.855-2.11-3.855-4.976 0-7.463 6.079-14.571 19.276-14.571 16.121 0 21.027 20.258 36.447 6.752"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#D1D5DB",
      d: "M22.599 36.388 2.527 89.962C1.302 93.23 3.72 96.71 7.21 96.71h107.241a7.999 7.999 0 0 0 7.491-5.194l20.069-53.565c1.225-3.269-1.191-6.754-4.682-6.754H30.09a7.998 7.998 0 0 0-7.491 5.191Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#FDFDFD",
      d: "M93.54 52.59c-.675-.053-1.194-.684-1.142-1.367.779-10.035 9.445-17.548 19.356-16.76.675.053 1.194.683 1.142 1.366a1.273 1.273 0 0 1-1.349 1.156c-8.563-.683-16.035 5.832-16.71 14.449 0 .735-.623 1.26-1.297 1.155Z",
      opacity: ".76"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#E5E7EB",
      d: "M106.979 71.136c-11.157-.893-19.563-10.77-18.681-22.12.882-11.295 10.638-19.807 21.847-18.914 11.157.893 19.564 10.771 18.682 22.12-.883 11.296-10.639 19.807-21.848 18.914Zm3.062-39.773c-10.482-.84-19.667 7.146-20.498 17.759-.83 10.613 7.058 19.912 17.54 20.753 10.483.84 19.668-7.145 20.498-17.758.83-10.614-7.057-19.913-17.54-20.754Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#0C2D4A",
      d: "m124.675 69.875-.83-.946a.914.914 0 0 1 .104-1.26l-2.854 2.469-.052.052a.914.914 0 0 0-.104 1.261l.986 1.156c.415-.578 1.557-1.681 2.75-2.732Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#0C2D4A",
      d: "M123.949 67.616a.916.916 0 0 0-.104 1.26l.83.946c1.142-.998 2.387-1.996 3.062-2.364l-.934-1.103c-.311-.368-.778-.42-1.142-.158-.052 0-.052.053-.103.053l-1.609 1.366Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#6B7280",
      d: "m150.672 92.887-22.625-25.64c-.052-.052-.26-.157-.519 0-.675.369-1.194.631-2.335 1.63-1.194 1.05-2.336 2.154-2.751 2.732-.155.21-.882 1.208-.83 1.26l22.625 25.64c1.505 1.786 4.152 1.997 5.968.473 1.765-1.576 1.972-4.308.467-6.095Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#9CA3AF",
      d: "M125.557 66.302c.052-.052.052-.052.104-.052a23.47 23.47 0 0 0 5.864-13.818c.986-12.82-8.458-24.01-21.12-25.01-12.662-.997-23.716 8.565-24.701 21.384-.986 12.82 8.458 24.011 21.12 25.01 5.241.42 10.223-.999 14.323-3.678l2.854-2.47 1.556-1.366Zm-18.525 4.203c-10.846-.84-18.941-10.455-18.111-21.436.83-10.98 10.327-19.177 21.172-18.336 10.846.84 18.941 10.455 18.111 21.436-.83 10.98-10.327 19.177-21.172 18.337Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#D1D5DB",
      d: "M106.771 74.13c-12.818-.998-22.418-12.399-21.432-25.323.986-12.978 12.247-22.698 25.013-21.7 12.817.999 22.418 12.4 21.432 25.325-.416 5.254-2.439 10.087-5.916 13.975l-.052.053c-.052 0-.052.052-.052.052l-4.463 3.836c-4.359 2.89-9.393 4.203-14.53 3.783Zm3.581-46.392c-12.455-.998-23.404 8.511-24.39 21.121-.986 12.61 8.407 23.696 20.861 24.694 5.034.42 9.912-.84 14.115-3.626l4.411-3.835c.052-.052.052-.052.104-.052 3.373-3.783 5.345-8.46 5.76-13.556.934-12.714-8.407-23.8-20.861-24.746Zm-3.321 43.083c-11.002-.841-19.253-10.613-18.423-21.752.83-11.138 10.483-19.492 21.484-18.651 11.002.84 19.253 10.613 18.422 21.751-.83 11.139-10.482 19.492-21.483 18.652Zm3.061-39.773c-10.638-.84-19.979 7.25-20.809 18.074-.83 10.77 7.161 20.228 17.851 21.068 10.638.84 19.979-7.25 20.809-18.073.779-10.771-7.213-20.228-17.851-21.069Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "circle",
    {
      cx: "136.703",
      cy: "6.993",
      r: "4.945",
      fill: "#D1D5DB",
      transform: "rotate(45 136.703 6.993)"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "circle",
    {
      cx: "132.816",
      cy: "12.432",
      r: "3.846",
      fill: "#D1D5DB",
      transform: "rotate(45 132.816 12.432)"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "circle",
    {
      cx: "142.918",
      cy: "13.209",
      r: "4.945",
      fill: "#D1D5DB",
      transform: "rotate(45 142.918 13.21)"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "circle",
    {
      cx: "137.48",
      cy: "17.094",
      r: "3.846",
      fill: "#D1D5DB",
      transform: "rotate(45 137.48 17.094)"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "rect",
    {
      width: "3.297",
      height: "10.989",
      x: "140.59",
      y: "6.993",
      fill: "#F3F4F6",
      rx: "1.648",
      transform: "rotate(45 140.59 6.993)"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#FDFDFD",
      d: "M34.334 53.511H10.932c-.792 0-1.452-.668-1.452-1.47V44.07c0-.802.66-1.47 1.452-1.47h23.402c.791 0 1.451.668 1.451 1.47v7.927c.044.846-.616 1.514-1.451 1.514Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#F3F4F6",
      d: "M51.971 65.358H19.245c-.792 0-1.452-.668-1.452-1.47V52.086c0-.801.66-1.47 1.452-1.47h32.727c.791 0 1.451.669 1.451 1.47v11.802c0 .802-.66 1.47-1.452 1.47Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#FDFDFD",
      d: "M26.503 62.24h36.246c1.1 0 1.98.891 1.98 2.004v11.223c0 1.114-.88 2.005-1.98 2.005H26.503c-1.1 0-1.98-.891-1.98-2.005V64.244c0-1.113.88-2.004 1.98-2.004Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#FDFDFD",
      d: "M26.503 62.24h36.246c1.1 0 1.98.891 1.98 2.004v11.223c0 1.114-.88 2.005-1.98 2.005H26.503c-1.1 0-1.98-.891-1.98-2.005V64.244c0-1.113.88-2.004 1.98-2.004Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#D1D5DB",
      d: "M30.373 73.33c1.725 0 3.123-1.416 3.123-3.162 0-1.747-1.398-3.162-3.123-3.162-1.725 0-3.123 1.415-3.123 3.162 0 1.746 1.398 3.162 3.123 3.162ZM22.894 61.171c1.482 0 2.683-1.216 2.683-2.716 0-1.5-1.2-2.717-2.683-2.717-1.482 0-2.683 1.216-2.683 2.717 0 1.5 1.201 2.716 2.683 2.716ZM13.79 50.394c1.311 0 2.375-1.077 2.375-2.405 0-1.328-1.064-2.405-2.376-2.405-1.312 0-2.375 1.077-2.375 2.405 0 1.328 1.063 2.405 2.375 2.405ZM59.933 70.524H35.828a.68.68 0 0 1-.66-.668.68.68 0 0 1 .66-.668h24.105a.68.68 0 0 1 .66.668.68.68 0 0 1-.66.668ZM49.95 58.677H28.042a.538.538 0 0 1-.527-.534c0-.267.264-.535.528-.535h21.905c.308 0 .528.268.528.535s-.22.534-.528.534ZM33.543 48.3H17.707a.349.349 0 0 1-.352-.356c0-.222.132-.356.352-.356h15.836a.35.35 0 0 1 .352.356.35.35 0 0 1-.352.357Z"
    }
  )
);
var EmptyFile = ({
  width = "107",
  height = "134",
  ...otherProps
}) => /* @__PURE__ */ React100.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 107 134",
    fill: "none",
    ...otherProps
  },
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#F3F4F6",
      d: "M60.867 106.666h-4.665v-1.215h4.666v1.215Zm-9.33 0h-4.665v-1.215h4.665v1.215Zm-9.33 0H37.5v-1.215h4.665v1.215h.04Zm-9.371 0H28.17v-1.215h4.665v1.215Zm-9.33 0H18.84v-1.215h4.666v1.215Zm-9.371 0H9.47v-1.215h4.665v1.215Zm-9.33 0H3.275c-1.367 0-2.574-1.053-2.775-2.431l1.207-.162c.12.77.804 1.378 1.568 1.378h1.528v1.215Zm58.878-4.091h-1.207v-4.7h1.207v4.7Zm-62.016-3.12H.461v-4.698h1.206v4.698Zm62.016-6.278h-1.207v-4.7h1.207v4.7Zm-62.016-3.16H.461v-4.699h1.206v4.7Zm62.016-6.278h-1.207v-4.7h1.207v4.7Zm-62.016-3.12H.461v-4.698h1.206v4.698Zm62.016-6.278h-1.207v-4.7h1.207v4.7ZM1.667 71.22H.461v-4.698h1.206v4.699Zm62.016-6.278h-1.207v-4.74h1.207v4.74Zm-62.016-3.16H.461v-4.699h1.206v4.7Zm62.016-6.279h-1.207v-4.698h1.207v4.699ZM1.667 52.386H.461v-4.698h1.206v4.698Zm62.016-6.278h-1.207v-4.7h1.207v4.7Zm-62.016-3.16H.461v-4.699h1.206v4.7Zm62.016-6.279h-1.207V31.97h1.207v4.7ZM1.667 33.55H.461V28.85h1.206v4.7Zm60.81-6.197c-.121-.77-.805-1.378-1.57-1.378H59.34V24.76h1.569c1.367 0 2.574 1.013 2.775 2.39l-1.207.203Zm-7.803-1.337h-4.665v-1.216h4.665v1.216Zm-9.37 0h-4.666v-1.216h4.665v1.216Zm-9.331 0h-4.665v-1.216h4.665v1.216Zm-9.37 0h-4.666v-1.216h4.665v1.216Zm-9.331 0h-4.665v-1.216h4.665v1.216Zm-9.33 0H3.275v-1.216h4.665v1.216Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#D1D5DB",
      d: "M81.543 95.396H23.91a2.214 2.214 0 0 1-2.212-2.228V10.734c0-1.215.965-2.227 2.212-2.227h57.632c1.206 0 2.212.972 2.212 2.228v82.433c-.04 1.256-1.006 2.228-2.212 2.228Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#E5E7EB",
      d: "m53.995 18.431 14.88 14.988.12 63.476a2.214 2.214 0 0 1-2.211 2.228H9.192a2.213 2.213 0 0 1-2.212-2.228V20.659c0-1.215.966-2.228 2.212-2.228h44.803Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#9CA3AF",
      d: "m53.992 18.431 14.88 14.988H56.326c-1.287 0-2.293-1.053-2.293-2.309V18.431h-.04Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#F3F4F6",
      d: "M78.766 9.924H57.37a1.344 1.344 0 0 1-1.327-1.336V1.337c0-.73.603-1.337 1.327-1.337h21.396c.724 0 1.327.608 1.327 1.337v7.21c.04.77-.563 1.377-1.327 1.377Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#E5E7EB",
      d: "M94.893 20.7H64.972a1.344 1.344 0 0 1-1.327-1.337V8.628c0-.729.603-1.337 1.327-1.337h29.921c.724 0 1.328.608 1.328 1.337v10.735c0 .729-.604 1.337-1.328 1.337Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#FDFDFD",
      d: "M71.607 17.864h33.139c1.005 0 1.81.81 1.81 1.823v10.208a1.81 1.81 0 0 1-1.81 1.823h-33.14c-1.005 0-1.81-.81-1.81-1.823V19.687c0-1.013.805-1.823 1.81-1.823Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#F3F4F6",
      d: "M71.607 17.864h33.139c1.005 0 1.81.81 1.81 1.823v10.208a1.81 1.81 0 0 1-1.81 1.823h-33.14c-1.005 0-1.81-.81-1.81-1.823V19.687c0-1.013.805-1.823 1.81-1.823Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#D1D5DB",
      d: "M75.144 27.95A2.866 2.866 0 0 0 78 25.074a2.866 2.866 0 0 0-2.856-2.876 2.866 2.866 0 0 0-2.855 2.876 2.866 2.866 0 0 0 2.855 2.876ZM68.309 16.892a2.462 2.462 0 0 0 2.453-2.471 2.462 2.462 0 0 0-2.453-2.471 2.462 2.462 0 0 0-2.453 2.47 2.462 2.462 0 0 0 2.453 2.472ZM59.984 7.089c1.2 0 2.172-.98 2.172-2.188a2.18 2.18 0 0 0-2.172-2.187c-1.2 0-2.172.98-2.172 2.187a2.18 2.18 0 0 0 2.172 2.188Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#FDFDFD",
      d: "M84.372 106.763c5.968-6.011 5.968-15.757 0-21.769a15.205 15.205 0 0 0-21.612 0c-5.969 6.012-5.969 15.758 0 21.769a15.206 15.206 0 0 0 21.612 0Z",
      opacity: ".21"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#FDFDFD",
      d: "M61.915 97.421c-.523-.04-.925-.526-.885-1.053.603-7.737 7.32-13.53 15.001-12.922.523.04.925.527.885 1.053a.985.985 0 0 1-1.046.892c-6.636-.527-12.427 4.496-12.95 11.14 0 .566-.482.971-1.005.89Z",
      opacity: ".76"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#E5E7EB",
      d: "M72.332 111.721c-8.646-.689-15.162-8.304-14.478-17.054.684-8.71 8.245-15.272 16.931-14.583 8.647.689 15.162 8.304 14.479 17.054-.684 8.709-8.245 15.271-16.932 14.583Zm2.373-30.665c-8.124-.648-15.242 5.51-15.886 13.692-.643 8.182 5.47 15.352 13.594 16.001 8.124.648 15.242-5.51 15.886-13.692.643-8.183-5.47-15.353-13.594-16Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#0C2D4A",
      d: "m86.046 110.748-.643-.729a.703.703 0 0 1 .08-.972l-2.212 1.904-.04.04a.704.704 0 0 0-.08.973l.764.891c.322-.446 1.206-1.296 2.131-2.107Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#0C2D4A",
      d: "M85.485 109.007a.703.703 0 0 0-.08.972l.643.729c.885-.77 1.85-1.539 2.373-1.823l-.724-.851c-.241-.283-.603-.324-.885-.121-.04 0-.04.04-.08.04l-1.247 1.054Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#6B7280",
      d: "m106.196 128.491-17.535-19.768c-.04-.04-.201-.121-.402 0-.523.284-.925.486-1.81 1.256-.925.81-1.81 1.661-2.132 2.106-.12.162-.683.932-.643.972l17.535 19.768c1.166 1.378 3.217 1.54 4.625.365 1.367-1.215 1.528-3.322.362-4.699Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#9CA3AF",
      d: "M86.73 107.994c.041-.041.041-.041.081-.041A18.049 18.049 0 0 0 91.356 97.3c.764-9.884-6.556-18.512-16.369-19.282-9.813-.77-18.379 6.603-19.143 16.487-.764 9.884 6.555 18.512 16.368 19.281 4.062.325 7.923-.769 11.1-2.835l2.212-1.904 1.207-1.053Zm-14.357 3.241c-8.405-.649-14.68-8.062-14.036-16.528.644-8.466 8.004-14.785 16.409-14.137 8.405.648 14.68 8.061 14.036 16.527-.644 8.466-8.003 14.786-16.409 14.138Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#9CA3AF",
      d: "M72.172 114.03c-9.934-.77-17.374-9.56-16.61-19.525.764-10.006 9.491-17.5 19.385-16.73 9.933.77 17.373 9.56 16.61 19.525-.322 4.051-1.89 7.777-4.585 10.775l-.04.04c-.04 0-.04.041-.04.041l-3.46 2.957c-3.378 2.228-7.279 3.241-11.26 2.917Zm2.775-35.769c-9.653-.77-18.139 6.562-18.903 16.284-.764 9.722 6.516 18.269 16.168 19.039a17.12 17.12 0 0 0 10.939-2.795l3.418-2.957c.04-.041.04-.041.08-.041 2.615-2.916 4.143-6.521 4.465-10.45.724-9.803-6.515-18.35-16.167-19.08Zm-2.574 33.217c-8.526-.649-14.921-8.183-14.278-16.77.644-8.588 8.124-15.03 16.65-14.38 8.527.647 14.921 8.182 14.278 16.77-.644 8.587-8.124 15.028-16.65 14.38Zm2.373-30.665c-8.245-.648-15.484 5.59-16.128 13.935-.643 8.304 5.55 15.595 13.835 16.243 8.245.649 15.484-5.59 16.127-13.934.603-8.304-5.59-15.596-13.834-16.244Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#D1D5DB",
      d: "M102.174 25.398h-22.04a.62.62 0 0 1-.603-.607.62.62 0 0 1 .603-.608h22.04c.321 0 .603.284.603.608a.621.621 0 0 1-.603.607ZM93.046 14.623H73.018a.49.49 0 0 1-.483-.486c0-.243.242-.486.483-.486h20.028a.49.49 0 0 1 .483.486.49.49 0 0 1-.483.486ZM78.042 5.185H63.564a.318.318 0 0 1-.322-.324c0-.203.12-.324.322-.324h14.478c.161 0 .322.121.322.324 0 .202-.16.324-.322.324Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#6B7280",
      d: "M45.226 56.63c0 5.145-5.148 5.225-5.148 7.13v.486c0 .526-.402.931-.844.931h-3.258c-.483 0-.845-.405-.845-.931v-.649c0-2.754 1.93-3.848 3.379-4.739 1.246-.77 2.01-1.256 2.01-2.268 0-1.337-1.568-2.188-2.815-2.188-1.649 0-2.413.85-3.499 2.309-.281.405-.804.486-1.166.162l-1.97-1.62c-.363-.284-.443-.85-.202-1.256 1.69-2.673 3.821-4.172 7.16-4.172 3.498 0 7.198 2.957 7.198 6.805Zm-4.625 12.841c0 1.782-1.327 3.24-2.976 3.24s-2.976-1.458-2.976-3.24c0-1.782 1.327-3.24 2.976-3.24 1.649.04 2.976 1.458 2.976 3.24Z"
    }
  )
);
var Error2 = ({
  width = "101",
  height = "119",
  ...otherProps
}) => /* @__PURE__ */ React100.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 101 119",
    fill: "none",
    ...otherProps
  },
  /* @__PURE__ */ React100.createElement("g", { clipPath: "url(#a)" }, /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#F3F4F6",
      d: "M76.124 99.607h-4.771v-1.233h4.73l.04 1.233Zm-9.502 0h-4.73v-1.233h4.73v1.233Zm-9.46 0H52.43v-1.233h4.73v1.233Zm-9.502 0h-4.73v-1.233h4.73v1.233Zm-9.461 0h-4.771v-1.233h4.73v1.233h.04Zm-9.502 0h-4.73v-1.233h4.73v1.233Zm-9.46 0h-1.55c-1.387 0-2.61-1.068-2.814-2.465l1.223-.165c.122.781.816 1.397 1.59 1.397h1.55v1.233Zm59.7-4.109h-1.223v-4.767h1.224v4.767Zm-62.882-3.205h-1.223v-4.767h1.223v4.767Zm62.883-6.37h-1.224v-4.766h1.224v4.767ZM16.055 82.76h-1.223v-4.767h1.223v4.767Zm62.883-6.37h-1.224v-4.766h1.224v4.767Zm-62.883-3.204h-1.223v-4.767h1.223v4.767Zm62.883-6.37h-1.224V62.05h1.224v4.766Zm-62.883-3.164h-1.223v-4.766h1.223v4.766Zm62.883-6.369h-1.224v-4.766h1.224v4.766ZM16.055 54.12h-1.223v-4.766h1.223v4.766Zm62.883-6.369h-1.224v-4.767h1.224v4.767Zm-62.883-3.205h-1.223v-4.767h1.223v4.767Zm62.883-6.37h-1.224V33.41h1.224v4.767Zm-62.883-3.163h-1.223v-4.767h1.223v4.767Zm62.883-6.37h-1.224v-4.766h1.224v4.767Zm-62.883-3.204h-1.223V20.67h1.223v4.767Zm61.66-6.246c-.123-.781-.816-1.397-1.591-1.397h-1.59v-1.233h1.59c1.386 0 2.61 1.027 2.814 2.424l-1.224.206Zm-7.912-1.397h-4.73v-1.233h4.73v1.233Zm-9.502 0h-4.73v-1.233h4.73v1.233Zm-9.46 0H46.11v-1.233h4.73v1.233Zm-9.502 0h-4.73v-1.233h4.73v1.233Zm-9.461 0h-4.73v-1.233h4.73v1.233Zm-9.461 0h-4.73v-1.233h4.73v1.233Z"
    }
  ), /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#D1D5DB",
      d: "M97.096 88.1H38.7a2.245 2.245 0 0 1-2.243-2.26V2.26c0-1.233.979-2.26 2.243-2.26h58.437c1.224 0 2.243.986 2.243 2.26v83.62a2.272 2.272 0 0 1-2.284 2.22Z"
    }
  ), /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#F3F4F6",
      d: "M69.203 10.067 84.29 25.271l.122 64.39c0 1.233-.978 2.26-2.242 2.26H23.774a2.245 2.245 0 0 1-2.243-2.26V12.286c0-1.232.979-2.26 2.243-2.26h45.429"
    }
  ), /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#9CA3AF",
      d: "m69.203 10.067 15.089 15.204H71.568c-1.305 0-2.324-1.068-2.324-2.342V10.067h-.04Z"
    }
  ), /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#D1D5DB",
      d: "M73.69 57.487H31.728c-.245 0-.408-.165-.408-.411 0-.247.163-.411.408-.411H73.69c.245 0 .408.164.408.41 0 .247-.163.412-.408.412ZM73.69 64.965H31.728c-.245 0-.408-.164-.408-.41 0-.247.163-.412.408-.412H73.69c.245 0 .408.165.408.411 0 .247-.163.411-.408.411ZM73.69 72.444H31.728c-.245 0-.408-.165-.408-.411 0-.247.163-.411.408-.411H73.69c.245 0 .408.164.408.41 0 .247-.163.412-.408.412ZM73.69 79.963H31.728c-.245 0-.408-.164-.408-.41 0-.247.163-.411.408-.411H73.69c.245 0 .408.164.408.41 0 .247-.163.411-.408.411ZM73.69 35.01H31.728c-.245 0-.408-.165-.408-.411 0-.247.163-.411.408-.411H73.69c.245 0 .408.164.408.41 0 .247-.163.412-.408.412ZM73.69 42.488H31.728c-.245 0-.408-.164-.408-.41 0-.247.163-.412.408-.412H73.69c.245 0 .408.165.408.411 0 .247-.163.411-.408.411ZM73.69 49.967H31.728c-.245 0-.408-.164-.408-.411 0-.247.163-.411.408-.411H73.69c.245 0 .408.164.408.41 0 .248-.163.412-.408.412Z"
    }
  ), /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#6B7280",
      d: "M1.347 92.373.164 95.249c-.449 1.069.082 2.301 1.142 2.753l1.631.699c-.204 1.52-.204 3.082.04 4.561l-1.63.699c-1.06.452-1.55 1.684-1.142 2.753l1.182 2.876a2.13 2.13 0 0 0 2.733 1.151l1.63-.699c.898 1.192 1.958 2.301 3.222 3.205l-.693 1.644c-.448 1.068.082 2.301 1.142 2.753l2.854 1.192c1.06.452 2.284-.083 2.733-1.151l.693-1.644c1.509.206 3.058.206 4.526-.041l.694 1.644a2.132 2.132 0 0 0 2.732 1.151l2.855-1.192c1.06-.452 1.55-1.685 1.141-2.753l-.693-1.644c1.183-.904 2.284-1.972 3.181-3.246l1.631.698c1.06.452 2.284-.082 2.732-1.15l1.183-2.876c.449-1.069-.081-2.302-1.142-2.754l-1.631-.698c.204-1.52.204-3.082-.04-4.561l1.63-.699c1.06-.452 1.55-1.684 1.142-2.753l-1.182-2.876a2.13 2.13 0 0 0-2.733-1.15l-1.63.698c-.898-1.192-1.958-2.301-3.222-3.205l.693-1.644c.448-1.068-.082-2.301-1.142-2.753l-2.854-1.192c-1.06-.452-2.284.082-2.733 1.15l-.693 1.644c-1.509-.205-3.059-.205-4.527.041l-.693-1.643a2.13 2.13 0 0 0-2.732-1.15l-2.855 1.19c-1.06.453-1.55 1.686-1.141 2.754l.693 1.644c-1.183.904-2.284 1.972-3.181 3.246l-1.631-.699c-1.101-.452-2.325.083-2.732 1.15Zm7.38 4.725c2.08-5.136 7.912-7.602 13.01-5.506 5.097 2.096 7.544 7.972 5.464 13.108-2.08 5.137-7.911 7.602-13.009 5.506-5.097-2.095-7.544-7.971-5.464-13.108ZM26.139 67.43l-.856 2.137c-.327.781.04 1.726.856 2.055l1.223.493a11.661 11.661 0 0 0 0 3.37l-1.223.534c-.775.328-1.183 1.273-.816 2.054l.898 2.137c.326.78 1.264 1.192 2.038.822l1.224-.534c.652.904 1.468 1.684 2.406 2.383l-.49 1.233c-.326.78.041 1.725.857 2.054l2.12.863a1.555 1.555 0 0 0 2.04-.863l.489-1.233c1.142.165 2.243.165 3.344 0l.53 1.233c.326.78 1.264 1.192 2.039.822l2.12-.904c.775-.329 1.183-1.274.816-2.055l-.53-1.232c.897-.658 1.672-1.48 2.365-2.425l1.223.493a1.555 1.555 0 0 0 2.04-.863l.856-2.136a1.575 1.575 0 0 0-.857-2.055l-1.223-.493c.163-1.15.163-2.26 0-3.37l1.223-.534c.775-.328 1.183-1.273.816-2.054l-.897-2.137c-.326-.78-1.264-1.191-2.04-.822l-1.222.534c-.653-.903-1.469-1.684-2.407-2.383l.49-1.233a1.575 1.575 0 0 0-.857-2.054l-2.12-.863a1.555 1.555 0 0 0-2.039.863l-.49 1.233a11.403 11.403 0 0 0-3.343 0l-.53-1.233c-.327-.78-1.265-1.192-2.04-.822l-2.12.904c-.775.329-1.183 1.274-.816 2.055l.53 1.232c-.897.658-1.671 1.48-2.365 2.425l-1.223-.493c-.775-.33-1.713.082-2.039.863Zm5.505 3.534a7.432 7.432 0 0 1 9.665-4.109c3.793 1.52 5.587 5.917 4.078 9.739a7.432 7.432 0 0 1-9.665 4.109c-3.833-1.561-5.627-5.958-4.078-9.739Z"
    }
  ), /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#9CA3AF",
      d: "M83.517 80.004c-1.916-5.095-1.06-8.464-1.06-8.464l-4.73 2.054-4.73 2.055s3.017 1.726 5.341 6.615l6.24 14.629s1.916 4.684.937 8.136l4.73-2.055 4.731-2.054c-3.18-1.644-5.22-6.287-5.22-6.287l-6.239-14.629Z"
    }
  ), /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#9CA3AF",
      d: "M79.316 68.91c.938-.904.041-2.014.041-2.014l-3.833-6.656c-.53-1.439.978-1.028.978-1.028 6.81 4.068 7.178 7.849 7.178 7.849.856 5.547-5.383 8.012-5.383 8.012-6.729 2.63-9.461-1.602-9.461-1.602s-2.488-2.918-.693-10.643c0 0 .774-1.356 1.427 0l2.161 7.356s.204 1.438 1.509 1.356c.04 0 3.63.04 6.076-2.63Z"
    }
  ), /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#D1D5DB",
      d: "m69.243 62.582 2.324 8.054s.245 1.561 1.631 1.479c0 0 3.915.041 6.606-2.835 1.02-.987.041-2.22.041-2.22l-4.16-7.231c-.08-.206-.122-.329-.122-.493-.163.164-.204.41-.04.904l3.833 6.656s.897 1.11-.04 2.014c-2.448 2.67-6.036 2.63-6.036 2.63-1.264.082-1.51-1.356-1.51-1.356l-2.16-7.356c-.204-.452-.45-.616-.653-.616.082.041.204.164.286.37Z"
    }
  ), /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#9CA3AF",
      d: "M76.542 59.212s-.897-.205-1.06.329c.285-.082.611 0 .611 0 5.995 3.575 6.321 6.944 6.321 6.944.734 4.89-4.73 7.068-4.73 7.068-5.913 2.342-8.32-1.397-8.32-1.397s-2.16-2.548-.611-9.41c0 0 .163-.288.408-.452-.49-.246-.938.575-.938.575-1.754 7.767.693 10.643.693 10.643s2.732 4.232 9.46 1.603c0 0 6.2-2.466 5.384-8.013-.041-.041-.408-3.863-7.218-7.89ZM88.776 107.905c-.938.904-.04 2.014-.04 2.014l3.833 6.657c.53 1.438-.979 1.027-.979 1.027-6.81-4.068-7.177-7.849-7.177-7.849-.857-5.547 5.383-8.012 5.383-8.012 6.728-2.63 9.46 1.602 9.46 1.602s2.488 2.918.694 10.643c0 0-.775 1.356-1.428 0l-2.16-7.355s-.245-1.439-1.51-1.356c-.04.041-3.629-.042-6.076 2.629Z"
    }
  ), /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#D1D5DB",
      d: "m98.85 114.233-2.324-8.053s-.245-1.562-1.632-1.48c0 0-3.914-.041-6.606 2.836-1.02.986-.04 2.218-.04 2.218l4.159 7.233c.081.205.122.328.122.493.163-.165.204-.411.041-.904l-3.833-6.657s-.897-1.11.04-2.014c2.447-2.671 6.036-2.629 6.036-2.629 1.264-.083 1.509 1.356 1.509 1.356l2.161 7.355c.204.452.449.616.652.616-.081-.041-.163-.164-.285-.37Z"
    }
  ), /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#9CA3AF",
      d: "M91.55 117.644s.897.205 1.06-.329c-.285.082-.612 0-.612 0-5.994-3.575-6.32-6.944-6.32-6.944-.734-4.89 4.73-7.068 4.73-7.068 5.913-2.342 8.319 1.397 8.319 1.397s2.161 2.548.612 9.41c0 0-.163.288-.408.452.49.247.938-.575.938-.575 1.753-7.766-.693-10.643-.693-10.643s-2.733-4.232-9.461-1.602c0 0-6.199 2.465-5.383 8.012.04.042.408 3.822 7.218 7.89Z"
    }
  ), /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#6B7280",
      d: "m5.79 52.843-.734 1.85c-.285.698.041 1.479.734 1.766l1.06.452c-.162.986-.122 1.973 0 2.918l-1.06.452a1.349 1.349 0 0 0-.734 1.767l.775 1.849a1.331 1.331 0 0 0 1.754.74l1.06-.453c.57.781 1.264 1.48 2.039 2.055l-.449 1.068c-.285.699.041 1.48.734 1.767l1.836.74a1.331 1.331 0 0 0 1.753-.74l.449-1.068c.978.164 1.957.123 2.895 0l.448 1.068a1.332 1.332 0 0 0 1.754.74l1.835-.78a1.349 1.349 0 0 0 .734-1.768l-.448-1.068a9.705 9.705 0 0 0 2.039-2.055l1.06.452a1.332 1.332 0 0 0 1.753-.74l.734-1.848a1.349 1.349 0 0 0-.734-1.767l-1.06-.452c.163-.987.122-1.973 0-2.918l1.06-.452a1.349 1.349 0 0 0 .734-1.767l-.774-1.849a1.331 1.331 0 0 0-1.754-.74l-1.06.453a9.705 9.705 0 0 0-2.04-2.055l.45-1.068a1.349 1.349 0 0 0-.735-1.767l-1.835-.74a1.331 1.331 0 0 0-1.753.74l-.449 1.068c-.979-.164-1.957-.123-2.895 0l-.449-1.068a1.332 1.332 0 0 0-1.753-.74l-1.835.78a1.349 1.349 0 0 0-.734 1.768l.448 1.068a9.704 9.704 0 0 0-2.039 2.055l-1.06-.452c-.653-.247-1.468.082-1.754.74Zm4.73 3.041c1.347-3.287 5.058-4.849 8.32-3.534 3.262 1.356 4.812 5.095 3.507 8.383-1.346 3.287-5.057 4.849-8.32 3.534-3.261-1.356-4.811-5.096-3.506-8.383Z"
    }
  ), /* @__PURE__ */ React100.createElement("circle", { cx: "16.262", cy: "58.391", r: "6.652", fill: "#FDFDFD" }), /* @__PURE__ */ React100.createElement("circle", { cx: "18.107", cy: "100.891", r: "9.978", fill: "#FDFDFD" })),
  /* @__PURE__ */ React100.createElement("defs", null, /* @__PURE__ */ React100.createElement("clipPath", { id: "a" }, /* @__PURE__ */ React100.createElement("path", { fill: "#fff", d: "M0 0h100.522v119H0z" })))
);
var ErrorDownload = ({
  width = "97",
  height = "108",
  ...otherProps
}) => /* @__PURE__ */ React100.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width,
    height,
    viewBox: "0 0 97 108",
    fill: "none",
    ...otherProps
  },
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#F3F4F6",
      d: "M72.858 98.927h-4.72v-1.225h4.72v1.225Zm-9.44 0h-4.72v-1.225h4.72v1.225Zm-9.439 0h-4.76v-1.225h4.72v1.225h.04Zm-9.48 0h-4.72v-1.225h4.72v1.225Zm-9.44 0H30.34v-1.225h4.72v1.225Zm-9.48 0h-4.72v-1.225h4.72v1.225Zm-9.439 0h-1.546c-1.383 0-2.604-1.061-2.807-2.45l1.22-.163c.122.776.814 1.388 1.587 1.388h1.546v1.225Zm59.566-4.123h-1.22v-4.736h1.22v4.736Zm-62.74-3.144h-1.22v-4.735h1.22v4.735Zm62.74-6.328h-1.22v-4.735h1.22v4.736Zm-62.74-3.184h-1.22v-4.736h1.22v4.736Zm62.74-6.328h-1.22v-4.735h1.22v4.735Zm-62.74-3.143h-1.22V67.94h1.22v4.736Zm62.74-6.328h-1.22v-4.736h1.22v4.736Zm-62.74-3.144h-1.22V58.47h1.22v4.736Zm62.74-6.327h-1.22V52.1h1.22v4.777Zm-62.74-3.185h-1.22v-4.735h1.22v4.735Zm62.74-6.328h-1.22V42.63h1.22v4.735Zm-62.74-3.143h-1.22v-4.736h1.22v4.736Zm62.74-6.328h-1.22v-4.736h1.22v4.736Zm-62.74-3.184h-1.22v-4.736h1.22v4.736Zm62.74-6.328h-1.22v-4.736h1.22v4.736Zm-62.74-3.144h-1.22v-4.735h1.22v4.735Zm61.52-6.246c-.123-.775-.815-1.388-1.588-1.388h-1.586V16.38h1.586c1.384 0 2.604 1.02 2.808 2.408l-1.22.204Zm-7.894-1.347h-4.72V16.42h4.72v1.225Zm-9.48 0h-4.72V16.42h4.72v1.225Zm-9.44 0h-4.72V16.42h4.72v1.225Zm-9.48 0h-4.72V16.42h4.72v1.225Zm-9.439 0h-4.72V16.42h4.72v1.225Zm-9.44 0h-4.719V16.42h4.72v1.225Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#D1D5DB",
      d: "M93.772 87.57H35.468c-1.22 0-2.238-.98-2.238-2.246V2.245c0-1.224.977-2.245 2.238-2.245h58.304c1.221 0 2.238.98 2.238 2.245v83.079c-.04 1.265-1.017 2.245-2.238 2.245Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#F3F4F6",
      d: "m65.903 10.002 15.054 15.105.122 63.972a2.235 2.235 0 0 1-2.238 2.246H20.578c-1.221 0-2.238-.98-2.238-2.246V12.247c0-1.225.976-2.245 2.238-2.245h45.325Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#9CA3AF",
      d: "m65.902 10.002 15.055 15.105H68.262a2.322 2.322 0 0 1-2.319-2.327V10.002h-.04Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#6B7280",
      d: "M55.897 51.385v3.802H40.703v-3.802h-2.539v3.802c0 1.382 1.12 2.549 2.54 2.549h15.193a2.549 2.549 0 0 0 2.54-2.549v-3.802h-2.54Zm-1.291-5.054-1.765-1.771-3.27 3.283V37.432h-2.54V47.8l-3.271-3.283-1.765 1.77 6.327 6.351 6.284-6.307Z"
    }
  ),
  /* @__PURE__ */ React100.createElement("g", { fill: "#9CA3AF", opacity: ".7" }, /* @__PURE__ */ React100.createElement("path", { d: "M53.853 70.718c-.388.39-.345.994 0 1.383l5.208 5.097 1.334-1.382-5.208-5.098c-.344-.389-.947-.389-1.334 0ZM60.954 63.418c-.387.389-.344.993 0 1.382l5.208 5.055 1.335-1.383-5.208-5.097c-.345-.346-.947-.346-1.335.043Z" })),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#9CA3AF",
      d: "m78.559 85.147-2.453 2.55a.46.46 0 0 1-.603.042L71.5 84.24l3.486-3.585 3.573 3.93c.172.174.172.39 0 .562Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#9CA3AF",
      d: "m77.31 79.315-7.274 7.301a2.643 2.643 0 0 1-3.744 0l-5.38-5.4a2.666 2.666 0 0 1 0-3.758l7.274-7.301a2.643 2.643 0 0 1 3.744 0l5.38 5.4a2.666 2.666 0 0 1 0 3.758Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#9CA3AF",
      d: "M70.895 69.509 60.178 80.525a1.336 1.336 0 0 1-1.85.043l-.388-.346a1.348 1.348 0 0 1-.043-1.857l10.717-11.016a1.336 1.336 0 0 1 1.851-.043l.387.345c.517.475.56 1.34.043 1.858ZM89.189 108c-.603 0-1.12-.432-1.249-1.037-1.764-8.64-6.843-16.589-13.902-21.816-.56-.432-.689-1.253-.258-1.814.43-.562 1.248-.692 1.807-.26C83.163 88.69 88.586 97.2 90.48 106.445c.129.691-.302 1.382-.99 1.512-.13.043-.215.043-.301.043Z"
    }
  ),
  /* @__PURE__ */ React100.createElement(
    "path",
    {
      fill: "#6B7280",
      d: "m21.038 87.295-.85 2.122c-.324.775.04 1.714.85 2.04l1.215.49a11.584 11.584 0 0 0 0 3.346l-1.215.53c-.769.327-1.174 1.265-.81 2.04l.891 2.122c.324.775 1.256 1.183 2.025.816l1.215-.53c.648.897 1.458 1.673 2.39 2.366l-.487 1.224c-.324.776.04 1.714.85 2.041l2.106.856c.77.327 1.701-.04 2.025-.856l.486-1.225c1.134.164 2.227.164 3.32 0l.527 1.225c.324.775 1.255 1.183 2.025.816l2.105-.898c.77-.326 1.175-1.265.81-2.04l-.526-1.224c.89-.653 1.66-1.469 2.348-2.408l1.215.49c.77.326 1.701-.041 2.025-.857l.85-2.122a1.564 1.564 0 0 0-.85-2.04l-1.215-.49a11.577 11.577 0 0 0 0-3.345l1.215-.53c.77-.327 1.174-1.266.81-2.041l-.891-2.122c-.324-.775-1.255-1.183-2.025-.816l-1.215.53c-.648-.897-1.457-1.672-2.389-2.366l.486-1.224a1.564 1.564 0 0 0-.85-2.04l-2.106-.857c-.77-.327-1.7.04-2.025.857l-.486 1.224a11.32 11.32 0 0 0-3.32 0l-.526-1.224c-.325-.776-1.256-1.184-2.025-.816l-2.106.897c-.77.327-1.174 1.265-.81 2.04l.527 1.224c-.891.653-1.66 1.47-2.35 2.408l-1.214-.49c-.77-.326-1.7.082-2.025.857Zm5.467 3.51a7.38 7.38 0 0 1 9.597-4.081c3.766 1.51 5.548 5.876 4.05 9.67a7.38 7.38 0 0 1-9.597 4.081c-3.807-1.55-5.589-5.917-4.05-9.67ZM.831 72.81l-.728 1.836a1.34 1.34 0 0 0 .728 1.755l1.053.449c-.162.979-.121 1.958 0 2.897l-1.053.449a1.34 1.34 0 0 0-.728 1.754l.769 1.836a1.322 1.322 0 0 0 1.741.735l1.053-.449a9.635 9.635 0 0 0 2.025 2.04l-.446 1.061a1.34 1.34 0 0 0 .73 1.755l1.821.734a1.322 1.322 0 0 0 1.742-.734l.445-1.061c.972.163 1.944.122 2.875 0l.446 1.06a1.322 1.322 0 0 0 1.74.735l1.823-.775a1.34 1.34 0 0 0 .729-1.755l-.445-1.06a9.635 9.635 0 0 0 2.024-2.04l1.053.448a1.322 1.322 0 0 0 1.741-.734l.73-1.837a1.34 1.34 0 0 0-.73-1.754l-1.052-.449c.161-.98.121-1.959 0-2.897l1.052-.449a1.34 1.34 0 0 0 .73-1.754l-.77-1.837a1.322 1.322 0 0 0-1.741-.734l-1.053.449a9.637 9.637 0 0 0-2.025-2.04l.445-1.061a1.34 1.34 0 0 0-.728-1.755l-1.823-.734a1.322 1.322 0 0 0-1.74.734l-.446 1.061c-.972-.163-1.944-.122-2.875 0l-.446-1.06a1.322 1.322 0 0 0-1.741-.735l-1.822.775a1.34 1.34 0 0 0-.73 1.755l.446 1.06a9.635 9.635 0 0 0-2.024 2.04l-1.053-.448c-.648-.245-1.458.081-1.742.734Zm4.698 3.02c1.336-3.265 5.021-4.815 8.26-3.51 3.24 1.347 4.779 5.06 3.483 8.325-1.336 3.264-5.021 4.814-8.26 3.509-3.24-1.347-4.78-5.06-3.483-8.324Z"
    }
  ),
  /* @__PURE__ */ React100.createElement("circle", { cx: "11.227", cy: "78.319", r: "6.606", fill: "#FDFDFD" })
);

// src/components/Placeholder/PlaceholderImage.tsx
var PlaceholderImage = ({
  className,
  children,
  ...otherProps
}) => {
  return /* @__PURE__ */ React101.createElement(Box, { as: "span", apply: className, ...otherProps }, children);
};
var PlaceholderEmptyIcon = (props) => {
  const { variant } = usePlaceholderContext();
  return variant === "vertical" ? /* @__PURE__ */ React101.createElement(Empty, { ...props }) : /* @__PURE__ */ React101.createElement(Empty, { width: "110", height: "67", ...props });
};
var PlaceholderEmptyFileIcon = (props) => {
  const { variant } = usePlaceholderContext();
  return variant === "vertical" ? /* @__PURE__ */ React101.createElement(EmptyFile, { ...props }) : /* @__PURE__ */ React101.createElement(EmptyFile, { width: "92", height: "92", ...props });
};
var PlaceholderErrorIcon = (props) => {
  const { variant } = usePlaceholderContext();
  return variant === "vertical" ? /* @__PURE__ */ React101.createElement(Error2, { ...props }) : /* @__PURE__ */ React101.createElement(Error2, { width: "88", height: "104", ...props });
};
var PlaceholderErrorDownloadIcon = (props) => {
  const { variant } = usePlaceholderContext();
  return variant === "vertical" ? /* @__PURE__ */ React101.createElement(ErrorDownload, { ...props }) : /* @__PURE__ */ React101.createElement(ErrorDownload, { width: "85", height: "95", ...props });
};

// src/components/Placeholder/PlaceholderTitle.tsx
import React102 from "react";
var PlaceholderTitle = ({
  className,
  children
}) => {
  const { variant } = usePlaceholderContext();
  return /* @__PURE__ */ React102.createElement(
    Box,
    {
      as: "span",
      className: clsx(
        "text-lg text-neutral-600 font-bold",
        variant === "horizontal" && "text-md"
      ),
      apply: className
    },
    children
  );
};

// src/components/Placeholder/Placeholder.tsx
var Placeholder = ({
  children,
  className,
  variant = "vertical",
  ...otherProps
}) => {
  return /* @__PURE__ */ React103.createElement(PlaceholderContext.Provider, { value: { variant } }, /* @__PURE__ */ React103.createElement(
    Box,
    {
      className: clsx(
        "p-1 rounded-sm flex flex-col items-center justify-center gap-6",
        variant === "horizontal" && "flex-row"
      ),
      apply: clsx(className),
      ...otherProps
    },
    children
  ));
};
Placeholder.Image = PlaceholderImage;
Placeholder.Description = PlaceholderDescription;
Placeholder.Content = PlaceholderContent;
Placeholder.Title = PlaceholderTitle;
Placeholder.BtnGroup = PlaceholderBtnGroup;
Placeholder.EmptyIcon = PlaceholderEmptyIcon;
Placeholder.EmptyFileIcon = PlaceholderEmptyFileIcon;
Placeholder.EmptyDownloadIcon = PlaceholderErrorDownloadIcon;
Placeholder.EmptyErrorIcon = PlaceholderErrorIcon;

// src/components/FilterButton/FilterButton.tsx
import React104, { forwardRef as forwardRef20 } from "react";
var baseStyles5 = clsx(
  "border border-neutral-300 outline-none bg-neutral-50 rounded-sm",
  "inline-flex items-center",
  "font-regular text-neutral-600"
);
var sizeStyles2 = {
  xs: "h-8 text-sm",
  sm: "h-9 text-sm",
  md: "h-10 text-md",
  lg: "h-12 text-md"
};
var iconSizeMap5 = {
  xs: "4.5",
  sm: "4.5",
  md: "4.5",
  lg: "6"
};
var statusStyles = clsx("hover:shadow-sm", "focus-visible:border-primary-800");
var FilterButton = forwardRef20(
  function FilterButtonHelper({
    className,
    onClear,
    size = "md",
    isSelected,
    children,
    isOpen,
    value,
    ...props
  }, ref) {
    const handleClear = (e) => {
      e.stopPropagation();
      onClear == null ? void 0 : onClear();
    };
    return /* @__PURE__ */ React104.createElement(
      Box,
      {
        ref,
        className: baseStyles5,
        apply: clsx(
          statusStyles,
          sizeStyles2[size],
          isSelected && "border-primary-300 bg-primary-200",
          isOpen && "border-primary-800",
          className
        ),
        ...props
      },
      /* @__PURE__ */ React104.createElement(
        Box,
        {
          as: "span",
          className: clsx(
            "cursor-pointer select-none h-full flex items-center",
            size === "xs" ? "pl-3 pr-1" : "pl-4 pr-1.5",
            isSelected && "hover:bg-neutral-600/10"
          )
        },
        children ?? value
      ),
      /* @__PURE__ */ React104.createElement(
        Box,
        {
          as: "button",
          type: "button",
          className: clsx(
            "appearance-none flex items-center pr-3 pl-2 ml-auto h-full",
            size === "xs" ? "pr-3 pl-2" : "pr-4 pl-2.5",
            isSelected && "hover:bg-neutral-600/10"
          ),
          onClick: isSelected ? handleClear : void 0
        },
        isSelected ? /* @__PURE__ */ React104.createElement(Icon, { as: MdClear, size: iconSizeMap5[size] }) : /* @__PURE__ */ React104.createElement(
          Icon,
          {
            as: isOpen ? MdOutlineExpandLess : MdOutlineExpandMore,
            size: iconSizeMap5[size]
          }
        )
      )
    );
  }
);

// src/components/SelectMultiCheckbox/SelectMultiCheckbox.tsx
import React105, { forwardRef as forwardRef21, useCallback as useCallback3, useMemo as useMemo10, useState as useState15 } from "react";
import { components } from "react-select";

// node_modules/react-tiny-virtual-list/build/react-tiny-virtual-list.es.js
var import_prop_types = __toESM(require_prop_types());
import { PureComponent, createElement } from "react";
var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2)
      if (b2.hasOwnProperty(p))
        d2[p] = b2[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign2 = function() {
  __assign2 = Object.assign || function __assign3(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign2.apply(this, arguments);
};
function __rest2(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") {
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
      if (e.indexOf(p[i]) < 0)
        t[p[i]] = s[p[i]];
  }
  return t;
}
var ALIGNMENT;
(function(ALIGNMENT2) {
  ALIGNMENT2["AUTO"] = "auto";
  ALIGNMENT2["START"] = "start";
  ALIGNMENT2["CENTER"] = "center";
  ALIGNMENT2["END"] = "end";
})(ALIGNMENT || (ALIGNMENT = {}));
var DIRECTION;
(function(DIRECTION2) {
  DIRECTION2["HORIZONTAL"] = "horizontal";
  DIRECTION2["VERTICAL"] = "vertical";
})(DIRECTION || (DIRECTION = {}));
var SCROLL_CHANGE_REASON;
(function(SCROLL_CHANGE_REASON2) {
  SCROLL_CHANGE_REASON2["OBSERVED"] = "observed";
  SCROLL_CHANGE_REASON2["REQUESTED"] = "requested";
})(SCROLL_CHANGE_REASON || (SCROLL_CHANGE_REASON = {}));
var scrollProp = (_a2 = {}, _a2[DIRECTION.VERTICAL] = "scrollTop", _a2[DIRECTION.HORIZONTAL] = "scrollLeft", _a2);
var sizeProp = (_b = {}, _b[DIRECTION.VERTICAL] = "height", _b[DIRECTION.HORIZONTAL] = "width", _b);
var positionProp = (_c = {}, _c[DIRECTION.VERTICAL] = "top", _c[DIRECTION.HORIZONTAL] = "left", _c);
var marginProp = (_d = {}, _d[DIRECTION.VERTICAL] = "marginTop", _d[DIRECTION.HORIZONTAL] = "marginLeft", _d);
var oppositeMarginProp = (_e = {}, _e[DIRECTION.VERTICAL] = "marginBottom", _e[DIRECTION.HORIZONTAL] = "marginRight", _e);
var _a2;
var _b;
var _c;
var _d;
var _e;
var SizeAndPositionManager = (
  /** @class */
  function() {
    function SizeAndPositionManager2(_a3) {
      var itemCount = _a3.itemCount, itemSizeGetter = _a3.itemSizeGetter, estimatedItemSize = _a3.estimatedItemSize;
      this.itemSizeGetter = itemSizeGetter;
      this.itemCount = itemCount;
      this.estimatedItemSize = estimatedItemSize;
      this.itemSizeAndPositionData = {};
      this.lastMeasuredIndex = -1;
    }
    SizeAndPositionManager2.prototype.updateConfig = function(_a3) {
      var itemCount = _a3.itemCount, itemSizeGetter = _a3.itemSizeGetter, estimatedItemSize = _a3.estimatedItemSize;
      if (itemCount != null) {
        this.itemCount = itemCount;
      }
      if (estimatedItemSize != null) {
        this.estimatedItemSize = estimatedItemSize;
      }
      if (itemSizeGetter != null) {
        this.itemSizeGetter = itemSizeGetter;
      }
    };
    SizeAndPositionManager2.prototype.getLastMeasuredIndex = function() {
      return this.lastMeasuredIndex;
    };
    SizeAndPositionManager2.prototype.getSizeAndPositionForIndex = function(index) {
      if (index < 0 || index >= this.itemCount) {
        throw Error("Requested index " + index + " is outside of range 0.." + this.itemCount);
      }
      if (index > this.lastMeasuredIndex) {
        var lastMeasuredSizeAndPosition = this.getSizeAndPositionOfLastMeasuredItem();
        var offset2 = lastMeasuredSizeAndPosition.offset + lastMeasuredSizeAndPosition.size;
        for (var i = this.lastMeasuredIndex + 1; i <= index; i++) {
          var size = this.itemSizeGetter(i);
          if (size == null || isNaN(size)) {
            throw Error("Invalid size returned for index " + i + " of value " + size);
          }
          this.itemSizeAndPositionData[i] = {
            offset: offset2,
            size
          };
          offset2 += size;
        }
        this.lastMeasuredIndex = index;
      }
      return this.itemSizeAndPositionData[index];
    };
    SizeAndPositionManager2.prototype.getSizeAndPositionOfLastMeasuredItem = function() {
      return this.lastMeasuredIndex >= 0 ? this.itemSizeAndPositionData[this.lastMeasuredIndex] : { offset: 0, size: 0 };
    };
    SizeAndPositionManager2.prototype.getTotalSize = function() {
      var lastMeasuredSizeAndPosition = this.getSizeAndPositionOfLastMeasuredItem();
      return lastMeasuredSizeAndPosition.offset + lastMeasuredSizeAndPosition.size + (this.itemCount - this.lastMeasuredIndex - 1) * this.estimatedItemSize;
    };
    SizeAndPositionManager2.prototype.getUpdatedOffsetForIndex = function(_a3) {
      var _b2 = _a3.align, align = _b2 === void 0 ? ALIGNMENT.START : _b2, containerSize = _a3.containerSize, currentOffset = _a3.currentOffset, targetIndex = _a3.targetIndex;
      if (containerSize <= 0) {
        return 0;
      }
      var datum = this.getSizeAndPositionForIndex(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;
      var idealOffset;
      switch (align) {
        case ALIGNMENT.END:
          idealOffset = minOffset;
          break;
        case ALIGNMENT.CENTER:
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        case ALIGNMENT.START:
          idealOffset = maxOffset;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
      }
      var totalSize = this.getTotalSize();
      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    };
    SizeAndPositionManager2.prototype.getVisibleRange = function(_a3) {
      var containerSize = _a3.containerSize, offset2 = _a3.offset, overscanCount = _a3.overscanCount;
      var totalSize = this.getTotalSize();
      if (totalSize === 0) {
        return {};
      }
      var maxOffset = offset2 + containerSize;
      var start2 = this.findNearestItem(offset2);
      if (typeof start2 === "undefined") {
        throw Error("Invalid offset " + offset2 + " specified");
      }
      var datum = this.getSizeAndPositionForIndex(start2);
      offset2 = datum.offset + datum.size;
      var stop = start2;
      while (offset2 < maxOffset && stop < this.itemCount - 1) {
        stop++;
        offset2 += this.getSizeAndPositionForIndex(stop).size;
      }
      if (overscanCount) {
        start2 = Math.max(0, start2 - overscanCount);
        stop = Math.min(stop + overscanCount, this.itemCount - 1);
      }
      return {
        start: start2,
        stop
      };
    };
    SizeAndPositionManager2.prototype.resetItem = function(index) {
      this.lastMeasuredIndex = Math.min(this.lastMeasuredIndex, index - 1);
    };
    SizeAndPositionManager2.prototype.findNearestItem = function(offset2) {
      if (isNaN(offset2)) {
        throw Error("Invalid offset " + offset2 + " specified");
      }
      offset2 = Math.max(0, offset2);
      var lastMeasuredSizeAndPosition = this.getSizeAndPositionOfLastMeasuredItem();
      var lastMeasuredIndex = Math.max(0, this.lastMeasuredIndex);
      if (lastMeasuredSizeAndPosition.offset >= offset2) {
        return this.binarySearch({
          high: lastMeasuredIndex,
          low: 0,
          offset: offset2
        });
      } else {
        return this.exponentialSearch({
          index: lastMeasuredIndex,
          offset: offset2
        });
      }
    };
    SizeAndPositionManager2.prototype.binarySearch = function(_a3) {
      var low = _a3.low, high = _a3.high, offset2 = _a3.offset;
      var middle = 0;
      var currentOffset = 0;
      while (low <= high) {
        middle = low + Math.floor((high - low) / 2);
        currentOffset = this.getSizeAndPositionForIndex(middle).offset;
        if (currentOffset === offset2) {
          return middle;
        } else if (currentOffset < offset2) {
          low = middle + 1;
        } else if (currentOffset > offset2) {
          high = middle - 1;
        }
      }
      if (low > 0) {
        return low - 1;
      }
      return 0;
    };
    SizeAndPositionManager2.prototype.exponentialSearch = function(_a3) {
      var index = _a3.index, offset2 = _a3.offset;
      var interval = 1;
      while (index < this.itemCount && this.getSizeAndPositionForIndex(index).offset < offset2) {
        index += interval;
        interval *= 2;
      }
      return this.binarySearch({
        high: Math.min(index, this.itemCount - 1),
        low: Math.floor(index / 2),
        offset: offset2
      });
    };
    return SizeAndPositionManager2;
  }()
);
var STYLE_WRAPPER = {
  overflow: "auto",
  willChange: "transform",
  WebkitOverflowScrolling: "touch"
};
var STYLE_INNER = {
  position: "relative",
  width: "100%",
  minHeight: "100%"
};
var STYLE_ITEM = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%"
};
var STYLE_STICKY_ITEM = __assign2({}, STYLE_ITEM, { position: "sticky" });
var VirtualList = (
  /** @class */
  function(_super) {
    __extends(VirtualList2, _super);
    function VirtualList2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.itemSizeGetter = function(itemSize) {
        return function(index) {
          return _this.getSize(index, itemSize);
        };
      };
      _this.sizeAndPositionManager = new SizeAndPositionManager({
        itemCount: _this.props.itemCount,
        itemSizeGetter: _this.itemSizeGetter(_this.props.itemSize),
        estimatedItemSize: _this.getEstimatedItemSize()
      });
      _this.state = {
        offset: _this.props.scrollOffset || _this.props.scrollToIndex != null && _this.getOffsetForIndex(_this.props.scrollToIndex) || 0,
        scrollChangeReason: SCROLL_CHANGE_REASON.REQUESTED
      };
      _this.styleCache = {};
      _this.getRef = function(node) {
        _this.rootNode = node;
      };
      _this.handleScroll = function(event) {
        var onScroll = _this.props.onScroll;
        var offset2 = _this.getNodeOffset();
        if (offset2 < 0 || _this.state.offset === offset2 || event.target !== _this.rootNode) {
          return;
        }
        _this.setState({
          offset: offset2,
          scrollChangeReason: SCROLL_CHANGE_REASON.OBSERVED
        });
        if (typeof onScroll === "function") {
          onScroll(offset2, event);
        }
      };
      return _this;
    }
    VirtualList2.prototype.componentDidMount = function() {
      var _a3 = this.props, scrollOffset = _a3.scrollOffset, scrollToIndex = _a3.scrollToIndex;
      this.rootNode.addEventListener("scroll", this.handleScroll, {
        passive: true
      });
      if (scrollOffset != null) {
        this.scrollTo(scrollOffset);
      } else if (scrollToIndex != null) {
        this.scrollTo(this.getOffsetForIndex(scrollToIndex));
      }
    };
    VirtualList2.prototype.componentWillReceiveProps = function(nextProps) {
      var _a3 = this.props, estimatedItemSize = _a3.estimatedItemSize, itemCount = _a3.itemCount, itemSize = _a3.itemSize, scrollOffset = _a3.scrollOffset, scrollToAlignment = _a3.scrollToAlignment, scrollToIndex = _a3.scrollToIndex;
      var scrollPropsHaveChanged = nextProps.scrollToIndex !== scrollToIndex || nextProps.scrollToAlignment !== scrollToAlignment;
      var itemPropsHaveChanged = nextProps.itemCount !== itemCount || nextProps.itemSize !== itemSize || nextProps.estimatedItemSize !== estimatedItemSize;
      if (nextProps.itemSize !== itemSize) {
        this.sizeAndPositionManager.updateConfig({
          itemSizeGetter: this.itemSizeGetter(nextProps.itemSize)
        });
      }
      if (nextProps.itemCount !== itemCount || nextProps.estimatedItemSize !== estimatedItemSize) {
        this.sizeAndPositionManager.updateConfig({
          itemCount: nextProps.itemCount,
          estimatedItemSize: this.getEstimatedItemSize(nextProps)
        });
      }
      if (itemPropsHaveChanged) {
        this.recomputeSizes();
      }
      if (nextProps.scrollOffset !== scrollOffset) {
        this.setState({
          offset: nextProps.scrollOffset || 0,
          scrollChangeReason: SCROLL_CHANGE_REASON.REQUESTED
        });
      } else if (typeof nextProps.scrollToIndex === "number" && (scrollPropsHaveChanged || itemPropsHaveChanged)) {
        this.setState({
          offset: this.getOffsetForIndex(nextProps.scrollToIndex, nextProps.scrollToAlignment, nextProps.itemCount),
          scrollChangeReason: SCROLL_CHANGE_REASON.REQUESTED
        });
      }
    };
    VirtualList2.prototype.componentDidUpdate = function(_, prevState) {
      var _a3 = this.state, offset2 = _a3.offset, scrollChangeReason = _a3.scrollChangeReason;
      if (prevState.offset !== offset2 && scrollChangeReason === SCROLL_CHANGE_REASON.REQUESTED) {
        this.scrollTo(offset2);
      }
    };
    VirtualList2.prototype.componentWillUnmount = function() {
      this.rootNode.removeEventListener("scroll", this.handleScroll);
    };
    VirtualList2.prototype.scrollTo = function(value) {
      var _a3 = this.props.scrollDirection, scrollDirection = _a3 === void 0 ? DIRECTION.VERTICAL : _a3;
      this.rootNode[scrollProp[scrollDirection]] = value;
    };
    VirtualList2.prototype.getOffsetForIndex = function(index, scrollToAlignment, itemCount) {
      if (scrollToAlignment === void 0) {
        scrollToAlignment = this.props.scrollToAlignment;
      }
      if (itemCount === void 0) {
        itemCount = this.props.itemCount;
      }
      var _a3 = this.props.scrollDirection, scrollDirection = _a3 === void 0 ? DIRECTION.VERTICAL : _a3;
      if (index < 0 || index >= itemCount) {
        index = 0;
      }
      return this.sizeAndPositionManager.getUpdatedOffsetForIndex({
        align: scrollToAlignment,
        containerSize: this.props[sizeProp[scrollDirection]],
        currentOffset: this.state && this.state.offset || 0,
        targetIndex: index
      });
    };
    VirtualList2.prototype.recomputeSizes = function(startIndex) {
      if (startIndex === void 0) {
        startIndex = 0;
      }
      this.styleCache = {};
      this.sizeAndPositionManager.resetItem(startIndex);
    };
    VirtualList2.prototype.render = function() {
      var _this = this;
      var _a3 = this.props, estimatedItemSize = _a3.estimatedItemSize, height = _a3.height, _b2 = _a3.overscanCount, overscanCount = _b2 === void 0 ? 3 : _b2, renderItem = _a3.renderItem, itemCount = _a3.itemCount, itemSize = _a3.itemSize, onItemsRendered = _a3.onItemsRendered, onScroll = _a3.onScroll, _c2 = _a3.scrollDirection, scrollDirection = _c2 === void 0 ? DIRECTION.VERTICAL : _c2, scrollOffset = _a3.scrollOffset, scrollToIndex = _a3.scrollToIndex, scrollToAlignment = _a3.scrollToAlignment, stickyIndices = _a3.stickyIndices, style = _a3.style, width = _a3.width, props = __rest2(_a3, ["estimatedItemSize", "height", "overscanCount", "renderItem", "itemCount", "itemSize", "onItemsRendered", "onScroll", "scrollDirection", "scrollOffset", "scrollToIndex", "scrollToAlignment", "stickyIndices", "style", "width"]);
      var offset2 = this.state.offset;
      var _d2 = this.sizeAndPositionManager.getVisibleRange({
        containerSize: this.props[sizeProp[scrollDirection]] || 0,
        offset: offset2,
        overscanCount
      }), start2 = _d2.start, stop = _d2.stop;
      var items = [];
      var wrapperStyle = __assign2({}, STYLE_WRAPPER, style, { height, width });
      var innerStyle = __assign2({}, STYLE_INNER, (_e2 = {}, _e2[sizeProp[scrollDirection]] = this.sizeAndPositionManager.getTotalSize(), _e2));
      if (stickyIndices != null && stickyIndices.length !== 0) {
        stickyIndices.forEach(function(index2) {
          return items.push(renderItem({
            index: index2,
            style: _this.getStyle(index2, true)
          }));
        });
        if (scrollDirection === DIRECTION.HORIZONTAL) {
          innerStyle.display = "flex";
        }
      }
      if (typeof start2 !== "undefined" && typeof stop !== "undefined") {
        for (var index = start2; index <= stop; index++) {
          if (stickyIndices != null && stickyIndices.includes(index)) {
            continue;
          }
          items.push(renderItem({
            index,
            style: this.getStyle(index, false)
          }));
        }
        if (typeof onItemsRendered === "function") {
          onItemsRendered({
            startIndex: start2,
            stopIndex: stop
          });
        }
      }
      return createElement("div", __assign2({ ref: this.getRef }, props, { style: wrapperStyle }), createElement("div", { style: innerStyle }, items));
      var _e2;
    };
    VirtualList2.prototype.getNodeOffset = function() {
      var _a3 = this.props.scrollDirection, scrollDirection = _a3 === void 0 ? DIRECTION.VERTICAL : _a3;
      return this.rootNode[scrollProp[scrollDirection]];
    };
    VirtualList2.prototype.getEstimatedItemSize = function(props) {
      if (props === void 0) {
        props = this.props;
      }
      return props.estimatedItemSize || typeof props.itemSize === "number" && props.itemSize || 50;
    };
    VirtualList2.prototype.getSize = function(index, itemSize) {
      if (typeof itemSize === "function") {
        return itemSize(index);
      }
      return Array.isArray(itemSize) ? itemSize[index] : itemSize;
    };
    VirtualList2.prototype.getStyle = function(index, sticky) {
      var style = this.styleCache[index];
      if (style) {
        return style;
      }
      var _a3 = this.props.scrollDirection, scrollDirection = _a3 === void 0 ? DIRECTION.VERTICAL : _a3;
      var _b2 = this.sizeAndPositionManager.getSizeAndPositionForIndex(index), size = _b2.size, offset2 = _b2.offset;
      return this.styleCache[index] = sticky ? __assign2({}, STYLE_STICKY_ITEM, (_c2 = {}, _c2[sizeProp[scrollDirection]] = size, _c2[marginProp[scrollDirection]] = offset2, _c2[oppositeMarginProp[scrollDirection]] = -(offset2 + size), _c2.zIndex = 1, _c2)) : __assign2({}, STYLE_ITEM, (_d2 = {}, _d2[sizeProp[scrollDirection]] = size, _d2[positionProp[scrollDirection]] = offset2, _d2));
      var _c2, _d2;
    };
    VirtualList2.defaultProps = {
      overscanCount: 3,
      scrollDirection: DIRECTION.VERTICAL,
      width: "100%"
    };
    VirtualList2.propTypes = {
      estimatedItemSize: import_prop_types.number,
      height: (0, import_prop_types.oneOfType)([import_prop_types.number, import_prop_types.string]).isRequired,
      itemCount: import_prop_types.number.isRequired,
      itemSize: (0, import_prop_types.oneOfType)([import_prop_types.number, import_prop_types.array, import_prop_types.func]).isRequired,
      onScroll: import_prop_types.func,
      onItemsRendered: import_prop_types.func,
      overscanCount: import_prop_types.number,
      renderItem: import_prop_types.func.isRequired,
      scrollOffset: import_prop_types.number,
      scrollToIndex: import_prop_types.number,
      scrollToAlignment: (0, import_prop_types.oneOf)([ALIGNMENT.AUTO, ALIGNMENT.START, ALIGNMENT.CENTER, ALIGNMENT.END]),
      scrollDirection: (0, import_prop_types.oneOf)([DIRECTION.HORIZONTAL, DIRECTION.VERTICAL]),
      stickyIndices: (0, import_prop_types.arrayOf)(import_prop_types.number),
      style: import_prop_types.object,
      width: (0, import_prop_types.oneOfType)([import_prop_types.number, import_prop_types.string])
    };
    return VirtualList2;
  }(PureComponent)
);
var react_tiny_virtual_list_es_default = VirtualList;

// src/components/SelectMultiCheckbox/SelectMultiCheckbox.tsx
var DropdownIndicator2 = () => /* @__PURE__ */ React105.createElement(Icon, { as: MdOutlineSearch, size: "4.5", className: "text-neutral-600" });
var defaultItemHeight = 34;
var labelHeight = 21;
var descriptionHeight = 18;
var calcItemHeight = (labelNumberOfLines, hideDescription) => {
  if (hideDescription)
    return defaultItemHeight - descriptionHeight + labelNumberOfLines * labelHeight;
  return defaultItemHeight + labelNumberOfLines * labelHeight;
};
var MenuList = (labelNumberOfLines, hideDescription) => (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function MenuListComponent({ options, children, maxHeight, getValue }) {
    const [value] = useMemo10(() => getValue(), [getValue]);
    const itemHeight = useMemo10(
      () => calcItemHeight(labelNumberOfLines, hideDescription),
      [labelNumberOfLines, hideDescription]
    );
    const initialOffset = useMemo10(
      () => options.indexOf(value) * itemHeight,
      [value]
    );
    const childrenOptions = useMemo10(
      () => React105.Children.toArray(children),
      [children]
    );
    const wrapperHeight = useMemo10(
      () => maxHeight < childrenOptions.length * itemHeight ? maxHeight : childrenOptions.length * itemHeight,
      [maxHeight, childrenOptions]
    );
    const renderItem = useCallback3(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (props) => {
        var _a3;
        if (Array.isArray(children)) {
          return /* @__PURE__ */ React105.createElement("div", { style: props.style, key: props.index }, children[props.index]);
        }
        return /* @__PURE__ */ React105.createElement(
          Box,
          {
            className: clsx(
              "text-center px-2 py-3 text-neutral-400 font-semibold flex items-center justify-center",
              `h-[${itemHeight}px]`
            ),
            key: props.index
          },
          (_a3 = children == null ? void 0 : children.props) == null ? void 0 : _a3.children
        );
      },
      [children]
    );
    return /* @__PURE__ */ React105.createElement(Box, { className: "py-2.5" }, /* @__PURE__ */ React105.createElement(
      react_tiny_virtual_list_es_default,
      {
        width: "100%",
        height: wrapperHeight + 6,
        scrollOffset: initialOffset,
        itemCount: childrenOptions.length,
        itemSize: itemHeight,
        renderItem
      }
    ));
  }
);
var Option = (labelNumberOfLines, hideDescription) => (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function OptionComponent(props) {
    const { description, label, rightText } = props.data;
    const { selectOption } = props;
    const { onMouseMove, onMouseOver, ...rest } = props.innerProps;
    const newProps = { ...props, innerProps: rest };
    const [refText, setRefText] = useState15(null);
    const textTopElement = refText;
    const isEllipsis = useMemo10(
      () => (textTopElement == null ? void 0 : textTopElement.scrollHeight) > (textTopElement == null ? void 0 : textTopElement.offsetHeight),
      [textTopElement]
    );
    const itemHeight = useMemo10(
      () => calcItemHeight(labelNumberOfLines, hideDescription),
      [labelNumberOfLines, hideDescription]
    );
    const handleChange = useCallback3(
      () => selectOption(props.data),
      [props.data]
    );
    return /* @__PURE__ */ React105.createElement(
      Box,
      {
        as: components.Option,
        ...newProps,
        className: `h-[${itemHeight}px]`
      },
      /* @__PURE__ */ React105.createElement(Box, { className: "flex items-center w-full" }, props.isMulti && /* @__PURE__ */ React105.createElement(Checkbox, { checked: props.isSelected, onChange: handleChange }), /* @__PURE__ */ React105.createElement(Box, { className: clsx({ "ml-4": props.isMulti }) }, /* @__PURE__ */ React105.createElement(
        Tooltip,
        {
          placement: "top",
          classname: "max-w-[250px]",
          shouldWrapChildren: true,
          label,
          disabled: !isEllipsis
        },
        /* @__PURE__ */ React105.createElement(
          Text,
          {
            ref: setRefText,
            numberOfLines: labelNumberOfLines,
            className: clsx(
              "text-sm font-semibold m-0",
              props.isSelected ? "text-primary-800" : "text-neutral-600"
            )
          },
          label
        )
      ), !hideDescription && /* @__PURE__ */ React105.createElement(
        Text,
        {
          className: clsx(
            "text-xs m-0 font-normal",
            props.isSelected ? "text-primary-700" : "text-neutral-500"
          )
        },
        description
      )), /* @__PURE__ */ React105.createElement(Box, { className: "ml-auto pl-3" }, /* @__PURE__ */ React105.createElement(
        Text,
        {
          className: clsx(
            "text-xs whitespace-nowrap font-normal",
            props.isSelected ? "text-primary-700" : "text-neutral-500"
          )
        },
        rightText
      )))
    );
  }
);
var SelectMultiCheckbox = forwardRef21(function SelectHelper2({
  removeShadows = false,
  hideSearch = false,
  labelNumberOfLines = 1,
  hideDescription = false,
  ...props
}, ref) {
  const { getProp: p } = useTheme();
  const MenuListComponent = useMemo10(
    () => MenuList(labelNumberOfLines, hideDescription),
    [labelNumberOfLines, hideDescription]
  );
  const OptionComponent = useMemo10(
    () => Option(labelNumberOfLines, hideDescription),
    [labelNumberOfLines, hideDescription]
  );
  return /* @__PURE__ */ React105.createElement(
    Select,
    {
      isMulti: true,
      hideSelectedOptions: false,
      captureMenuScroll: false,
      tabSelectsValue: false,
      styles: {
        menu: (baseStyles6) => ({
          ...baseStyles6,
          marginTop: 0,
          marginBottom: 0,
          boxShadow: "none",
          borderRadius: `0 0 ${p("borderRadius.sm")} ${p("borderRadius.sm")}`,
          position: "static"
        }),
        menuPortal: (baseStyles6) => ({
          ...baseStyles6,
          boxShadow: removeShadows ? "none" : p("boxShadow.sm")
        }),
        control: (baseStyles6) => ({
          ...baseStyles6,
          border: 0,
          boxShadow: "none",
          display: hideSearch ? "none" : "flex",
          borderBottom: `1px solid ${p("colors.neutral.200")}`,
          borderRadius: `${p("borderRadius.sm")} ${p("borderRadius.sm")} 0 0`,
          minHeight: 40,
          zIndex: 2,
          ":hover": {
            boxShadow: "none",
            borderBottom: `1px solid ${p("colors.neutral.200")}`
          }
        }),
        container: (baseStyles6) => ({
          ...baseStyles6,
          boxShadow: removeShadows ? "none" : p("boxShadow.sm"),
          borderRadius: p("borderRadius.sm"),
          overflow: "hidden"
        }),
        option: (baseStyles6, state) => ({
          ...baseStyles6,
          paddingLeft: p("spacing.4"),
          paddingRight: p("spacing.4"),
          position: "relative",
          display: "flex",
          background: state.isFocused || state.isSelected ? rgba(p("colors.primary.600"), state.isSelected ? 0.15 : 0.1) : p("colors.neutral.50"),
          fontWeight: p("fontWeight.semibold"),
          cursor: "pointer",
          "&:hover": {
            background: rgba(p("colors.primary.600"), 0.1)
          },
          "&:active": {
            background: rgba(p("colors.primary.600"), 0.15)
          }
        }),
        placeholder: (baseStyles6) => ({
          ...baseStyles6,
          fontSize: p("fontSize.xs")
        }),
        valueContainer: (baseStyles6) => ({
          ...baseStyles6,
          paddingLeft: p("spacing.4"),
          paddingRight: p("spacing.4")
        }),
        indicatorsContainer: (baseStyles6) => ({
          ...baseStyles6,
          paddingRight: p("spacing.4")
        })
      },
      components: {
        DropdownIndicator: DropdownIndicator2,
        IndicatorSeparator: null,
        Option: OptionComponent,
        MenuList: MenuListComponent
      },
      getOptionLabel: (option) => {
        const opt = option;
        return `${(opt == null ? void 0 : opt.label) || ""} ${(opt == null ? void 0 : opt.description) || ""} ${(opt == null ? void 0 : opt.rightText) || ""}`;
      },
      ref,
      ...props
    }
  );
});

// src/components/Drawer/Drawer.tsx
import { css as css6 } from "@emotion/css";
import { Global as Global3 } from "@emotion/react";
import { AnimatePresence as AnimatePresence4 } from "framer-motion";
import React106, {
  createContext as createContext17,
  useContext as useContext17,
  useEffect as useEffect11,
  useRef as useRef8,
  useState as useState16
} from "react";
import { createPortal as createPortal5 } from "react-dom";
var DrawerContext = createContext17(void 0);
function useDrawer() {
  return useContext17(DrawerContext);
}
var Drawer = ({
  isOpen = false,
  onClose,
  children,
  closeOnOverlayClick = true,
  closeOnEsc = true,
  placement = "left"
}) => {
  const ref = useRef8(null);
  const [mounted, setMounted] = useState16(false);
  useEffect11(() => {
    var _a3;
    ref.current = (_a3 = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a3.querySelector("body");
    setMounted(true);
  }, []);
  useEffect11(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose == null ? void 0 : onClose();
      }
    };
    if (!(globalThis == null ? void 0 : globalThis.document))
      return;
    if (closeOnEsc && isOpen)
      globalThis.document.addEventListener("keydown", handleKeyDown);
    return () => {
      var _a3;
      return (_a3 = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a3.removeEventListener("keydown", handleKeyDown);
    };
  }, [closeOnEsc, isOpen, onClose]);
  if (!(globalThis == null ? void 0 : globalThis.document))
    return null;
  return mounted ? createPortal5(
    /* @__PURE__ */ React106.createElement(
      DrawerContext.Provider,
      {
        value: {
          isOpen,
          onClose,
          closeOnOverlayClick,
          closeOnEsc,
          placement
        }
      },
      /* @__PURE__ */ React106.createElement(AnimatePresence4, null, isOpen && /* @__PURE__ */ React106.createElement("div", { key: "DrawerManager" }, children)),
      isOpen && /* @__PURE__ */ React106.createElement(
        Global3,
        {
          styles: {
            body: {
              overflow: "hidden"
            }
          }
        }
      )
    ),
    ref.current
  ) : null;
};
var DrawerOverlay = () => /* @__PURE__ */ React106.createElement(
  MotionBox,
  {
    key: "drawer-overlay",
    initial: { opacity: 0 },
    animate: { opacity: 0.6 },
    exit: { opacity: 0 },
    className: "z-modal bg-neutral-900 fixed left-0 top-0 h-screen w-screen opacity-60"
  }
);
var DrawerCloseButton = ({
  icon = /* @__PURE__ */ React106.createElement(MdClose, null),
  className,
  ...otherProps
}) => {
  const { onClose } = useDrawer();
  return /* @__PURE__ */ React106.createElement(
    IconButton,
    {
      "aria-label": "Close",
      color: "neutral",
      variant: "text",
      className: clsx("absolute top-5 right-5", className),
      onClick: onClose,
      icon,
      ...otherProps
    }
  );
};
var DrawerHeader = ({
  children,
  className = "",
  ...otherProps
}) => {
  return /* @__PURE__ */ React106.createElement(
    Box,
    {
      as: "header",
      className: clsx(
        "text-primary-900 border-neutral-300 border-b py-6 px-8 font-semibold text-xl"
      ),
      apply: className,
      ...otherProps
    },
    children
  );
};
var DrawerBody = ({
  children,
  className = "",
  ...otherProps
}) => {
  const { getProp: p } = useTheme();
  const scrollStyles = css6({
    background: `
      linear-gradient(${p("colors.neutral.50")} 33%, ${rgba(p("colors.neutral.50"), 0)}),
      linear-gradient(${rgba(p("colors.neutral.900"), 0.1)}, ${rgba(p("colors.neutral.900"), 0)}),
      linear-gradient(${p("colors.neutral.50")}, ${p("colors.neutral.50")}) 0 100%,
      linear-gradient(${p("colors.neutral.100")}, ${p("colors.neutral.100")}) 0 100%
    `,
    backgroundSize: `
      100% ${p("spacing.2")},
      100% ${p("spacing.1")},
      100% ${p("spacing.1")},
      100% ${p("spacing.[0.5]")}
    `,
    backgroundAttachment: `
      local,
      scroll,
      local,
      scroll
    `,
    backgroundRepeat: "no-repeat",
    overflow: "overlay"
  });
  return /* @__PURE__ */ React106.createElement(
    Box,
    {
      className: clsx(
        "px-8 py-6 overflow-auto text-neutral-600 text-md",
        scrollStyles
      ),
      apply: className,
      ...otherProps
    },
    children
  );
};
var DrawerFooter = ({
  children,
  className = "",
  ...otherProps
}) => {
  return /* @__PURE__ */ React106.createElement(
    Box,
    {
      as: "footer",
      className: `flex justify-end px-8 py-9 mt-auto`,
      apply: className,
      ...otherProps
    },
    children
  );
};
var DrawerContent = ({
  children,
  className = "",
  ...otherProps
}) => {
  const { onClose, closeOnOverlayClick, placement } = useDrawer();
  const mouseDownTarget = useRef8(null);
  const overlayRef = useRef8(null);
  const onMouseDown = (e) => {
    mouseDownTarget.current = e.target;
  };
  const handleClickOverlay = (e) => {
    e.stopPropagation();
    const isDraggingToOutside = mouseDownTarget.current !== e.target;
    const isNotOverlayElement = e.target !== overlayRef.current;
    if (!closeOnOverlayClick || isDraggingToOutside || isNotOverlayElement)
      return;
    onClose == null ? void 0 : onClose();
  };
  return /* @__PURE__ */ React106.createElement(
    Box,
    {
      className: clsx(
        "fixed left-0 top-0 flex h-screen w-screen  z-modal",
        placement === "left" ? "justify-start" : "justify-end"
      ),
      onClick: handleClickOverlay,
      onMouseDown,
      ref: overlayRef
    },
    /* @__PURE__ */ React106.createElement(
      MotionBox,
      {
        key: "drawer",
        role: "dialog",
        "aria-modal": "true",
        initial: {
          translateX: placement === "left" ? "-100%" : "100%",
          opacity: 0
        },
        animate: { translateX: 0, opacity: 1 },
        exit: {
          translateX: placement === "left" ? "-100%" : "100%",
          opacity: 0
        },
        transition: { type: "easeInOut" },
        className: clsx(
          "z-modal bg-neutral-50 relative shadow-2xl flex flex-col w-[500px]"
        ),
        apply: className,
        ...otherProps
      },
      children
    )
  );
};
Drawer.Overlay = DrawerOverlay;
Drawer.Content = DrawerContent;
Drawer.CloseButton = DrawerCloseButton;
Drawer.Header = DrawerHeader;
Drawer.Body = DrawerBody;
Drawer.Footer = DrawerFooter;
export {
  Avatar,
  AvatarForwarded,
  Badge,
  Banner,
  Box,
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  DatePicker,
  Dialog,
  Divider,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  Dropdown,
  Editable,
  FilterButton,
  FormControl,
  Icon,
  IconButton,
  Image,
  Input,
  Link,
  List,
  Modal,
  MotionBox,
  Navbar,
  Pagination,
  Placeholder,
  ProgressBar,
  Radio,
  Select,
  SelectMultiCheckbox,
  Spinner,
  Switch,
  Table,
  Tabs,
  Tag,
  Text,
  TextArea,
  ThemeContext,
  ThemeProvider,
  Toast,
  ToastProvider,
  Tooltip,
  Upload,
  UploadProgress,
  animationOrigins,
  useBreakpoint,
  useDisclosure,
  useDrawer,
  useFormControl,
  useInputGroup,
  useMediaQuery,
  useSelect,
  useTabs,
  useTag,
  useTheme,
  useToast,
  useTw
};
/*! Bundled license information:

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)

react-tiny-virtual-list/build/react-tiny-virtual-list.es.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
  
  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
  
  See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** *)
*/
//# sourceMappingURL=index.esm.js.map
